/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as DavetRouteImport } from "./routes/davet";
import { Route as GirisRouteImport } from "./routes/giris";
import { Route as ParolaSifirlaRouteImport } from "./routes/parola-sifirla";
import { Route as ParolaUnuttumRouteImport } from "./routes/parola-unuttum";
import { Route as PlatformRouteImport } from "./routes/platform";
import { Route as PortalRouteImport } from "./routes/portal";
import { Route as SiraEkraniRouteImport } from "./routes/sira-ekrani";
import { Route as AppIndexRouteImport } from "./routes/_app/index";
import { Route as AppDuyurularRouteImport } from "./routes/_app/duyurular";
import { Route as AppKurulumRouteImport } from "./routes/_app/kurulum";
import { Route as DevUiShowcaseRouteImport } from "./routes/dev.ui-showcase";
import { Route as PlatformIndexRouteImport } from "./routes/platform/index";
import { Route as PlatformAyarlarRouteImport } from "./routes/platform/ayarlar";
import { Route as PlatformDestekRouteImport } from "./routes/platform/destek";
import { Route as PlatformDevirlerRouteImport } from "./routes/platform/devirler";
import { Route as PlatformDuyurularRouteImport } from "./routes/platform/duyurular";
import { Route as PlatformPersonelRouteImport } from "./routes/platform/personel";
import { Route as PlatformPlanlarRouteImport } from "./routes/platform/planlar";
import { Route as PlatformSaglikRouteImport } from "./routes/platform/saglik";
import { Route as PlatformTahsilatRouteImport } from "./routes/platform/tahsilat";
import { Route as PlatformYayinlarRouteImport } from "./routes/platform/yayinlar";
import { Route as PortalIndexRouteImport } from "./routes/portal/index";
import { Route as PortalAraclarRouteImport } from "./routes/portal/araclar";
import { Route as PortalFaturalarRouteImport } from "./routes/portal/faturalar";
import { Route as PortalIslemlerRouteImport } from "./routes/portal/islemler";
import { Route as PortalTaleplerRouteImport } from "./routes/portal/talepler";
import { Route as SiraEkraniYikamaRouteImport } from "./routes/sira-ekrani/yikama";
import { Route as AppAjanlarIndexRouteImport } from "./routes/_app/ajanlar/index";
import { Route as AppAjanlarIdRouteImport } from "./routes/_app/ajanlar/$id";
import { Route as AppAkaryakitAyarlarRouteImport } from "./routes/_app/akaryakit/ayarlar";
import { Route as AppAkaryakitEndeksRouteImport } from "./routes/_app/akaryakit/endeks";
import { Route as AppAkaryakitFireRaporuRouteImport } from "./routes/_app/akaryakit/fire-raporu";
import { Route as AppAkaryakitFiyatFarkiRouteImport } from "./routes/_app/akaryakit/fiyat-farki";
import { Route as AppAkaryakitMaliyetRouteImport } from "./routes/_app/akaryakit/maliyet";
import { Route as AppAkaryakitMutabakatRouteImport } from "./routes/_app/akaryakit/mutabakat";
import { Route as AppAkaryakitSatislarRouteImport } from "./routes/_app/akaryakit/satislar";
import { Route as AppAkaryakitSiparisOnerileriRouteImport } from "./routes/_app/akaryakit/siparis-onerileri";
import { Route as AppAkaryakitTanklarRouteImport } from "./routes/_app/akaryakit/tanklar";
import { Route as AppAlarmlarIndexRouteImport } from "./routes/_app/alarmlar/index";
import { Route as AppAlarmlarAlarmIdRouteImport } from "./routes/_app/alarmlar/$alarmId";
import { Route as AppAlarmlarKurallarRouteImport } from "./routes/_app/alarmlar/kurallar";
import { Route as AppAyarlarAbonelikRouteImport } from "./routes/_app/ayarlar/abonelik";
import { Route as AppAyarlarBolgelerRouteImport } from "./routes/_app/ayarlar/bolgeler";
import { Route as AppAyarlarDestekErisimiRouteImport } from "./routes/_app/ayarlar/destek-erisimi";
import { Route as AppAyarlarGuvenlikRouteImport } from "./routes/_app/ayarlar/guvenlik";
import { Route as AppAyarlarIstasyonDevirleriRouteImport } from "./routes/_app/ayarlar/istasyon-devirleri";
import { Route as AppAyarlarKullanicilarRouteImport } from "./routes/_app/ayarlar/kullanicilar";
import { Route as AppAyarlarProfilRouteImport } from "./routes/_app/ayarlar/profil";
import { Route as AppAyarlarRollerRouteImport } from "./routes/_app/ayarlar/roller";
import { Route as AppAyarlarSirketlerRouteImport } from "./routes/_app/ayarlar/sirketler";
import { Route as AppBakimAyarlarRouteImport } from "./routes/_app/bakim/ayarlar";
import { Route as AppBakimPlanlarRouteImport } from "./routes/_app/bakim/planlar";
import { Route as AppBakimRaporlarRouteImport } from "./routes/_app/bakim/raporlar";
import { Route as AppBildirimlerIndexRouteImport } from "./routes/_app/bildirimler/index";
import { Route as AppBildirimlerTercihlerRouteImport } from "./routes/_app/bildirimler/tercihler";
import { Route as AppButceIndexRouteImport } from "./routes/_app/butce/index";
import { Route as AppButceIdRouteImport } from "./routes/_app/butce/$id";
import { Route as AppButceRaporRouteImport } from "./routes/_app/butce/rapor";
import { Route as AppCariIndexRouteImport } from "./routes/_app/cari/index";
import { Route as AppCariAcilisAktarimiRouteImport } from "./routes/_app/cari/acilis-aktarimi";
import { Route as AppCariHareketYeniRouteImport } from "./routes/_app/cari/hareket-yeni";
import { Route as AppCariRaporlarRouteImport } from "./routes/_app/cari/raporlar";
import { Route as AppCariRiskRouteImport } from "./routes/_app/cari/risk";
import { Route as AppCariYeniRouteImport } from "./routes/_app/cari/yeni";
import { Route as AppCekSenetIndexRouteImport } from "./routes/_app/cek-senet/index";
import { Route as AppCekSenetIdRouteImport } from "./routes/_app/cek-senet/$id";
import { Route as AppCekSenetAyarlarRouteImport } from "./routes/_app/cek-senet/ayarlar";
import { Route as AppCekSenetBordroYeniRouteImport } from "./routes/_app/cek-senet/bordro-yeni";
import { Route as AppCekSenetKarnelerRouteImport } from "./routes/_app/cek-senet/karneler";
import { Route as AppCekSenetRaporlarRouteImport } from "./routes/_app/cek-senet/raporlar";
import { Route as AppCekSenetTakvimRouteImport } from "./routes/_app/cek-senet/takvim";
import { Route as AppFaturalarIndexRouteImport } from "./routes/_app/faturalar/index";
import { Route as AppFaturalarAyarlarRouteImport } from "./routes/_app/faturalar/ayarlar";
import { Route as AppFaturalarEArsivTalepleriRouteImport } from "./routes/_app/faturalar/e-arsiv-talepleri";
import { Route as AppFaturalarYeniRouteImport } from "./routes/_app/faturalar/yeni";
import { Route as AppFiloIndexRouteImport } from "./routes/_app/filo/index";
import { Route as AppFiloCounterpartyIdRouteImport } from "./routes/_app/filo/$counterpartyId";
import { Route as AppFiloAracTalepleriRouteImport } from "./routes/_app/filo/arac-talepleri";
import { Route as AppFiloTuketimRouteImport } from "./routes/_app/filo/tuketim";
import { Route as AppFinansIndexRouteImport } from "./routes/_app/finans/index";
import { Route as AppFinansAyarlarRouteImport } from "./routes/_app/finans/ayarlar";
import { Route as AppFinansDbsRouteImport } from "./routes/_app/finans/dbs";
import { Route as AppFinansEkstreRouteImport } from "./routes/_app/finans/ekstre";
import { Route as AppFinansHareketYeniRouteImport } from "./routes/_app/finans/hareket-yeni";
import { Route as AppFinansHareketlerRouteImport } from "./routes/_app/finans/hareketler";
import { Route as AppFinansKredilerRouteImport } from "./routes/_app/finans/krediler";
import { Route as AppFinansPosRouteImport } from "./routes/_app/finans/pos";
import { Route as AppFinansTeminatlarRouteImport } from "./routes/_app/finans/teminatlar";
import { Route as AppFiyatlarIndexRouteImport } from "./routes/_app/fiyatlar/index";
import { Route as AppFiyatlarTopluDegisiklikRouteImport } from "./routes/_app/fiyatlar/toplu-degisiklik";
import { Route as AppGiderlerIndexRouteImport } from "./routes/_app/giderler/index";
import { Route as AppGiderlerTanimlarRouteImport } from "./routes/_app/giderler/tanimlar";
import { Route as AppGiderlerYeniRouteImport } from "./routes/_app/giderler/yeni";
import { Route as AppKasaAyarlarRouteImport } from "./routes/_app/kasa/ayarlar";
import { Route as AppKasaKampanyalarRouteImport } from "./routes/_app/kasa/kampanyalar";
import { Route as AppKatalogUrunlerRouteImport } from "./routes/_app/katalog/urunler";
import { Route as AppKvkkAyarlarRouteImport } from "./routes/_app/kvkk/ayarlar";
import { Route as AppKvkkMetinlerRouteImport } from "./routes/_app/kvkk/metinler";
import { Route as AppKvkkPazarlamaRouteImport } from "./routes/_app/kvkk/pazarlama";
import { Route as AppMarketAyarlarRouteImport } from "./routes/_app/market/ayarlar";
import { Route as AppMarketEtiketlerRouteImport } from "./routes/_app/market/etiketler";
import { Route as AppMarketFiyatOnerisiRouteImport } from "./routes/_app/market/fiyat-onerisi";
import { Route as AppMarketGunKapanislariRouteImport } from "./routes/_app/market/gun-kapanislari";
import { Route as AppMarketHareketlerRouteImport } from "./routes/_app/market/hareketler";
import { Route as AppMarketLisanslarRouteImport } from "./routes/_app/market/lisanslar";
import { Route as AppMarketPartilerRouteImport } from "./routes/_app/market/partiler";
import { Route as AppMarketRaporlarRouteImport } from "./routes/_app/market/raporlar";
import { Route as AppMarketSiparisOnerisiRouteImport } from "./routes/_app/market/siparis-onerisi";
import { Route as AppMuhasebeAraclarRouteImport } from "./routes/_app/muhasebe/araclar";
import { Route as AppMuhasebeDonemlerRouteImport } from "./routes/_app/muhasebe/donemler";
import { Route as AppMuhasebeEslestirmelerRouteImport } from "./routes/_app/muhasebe/eslestirmeler";
import { Route as AppMuhasebeHesapPlaniRouteImport } from "./routes/_app/muhasebe/hesap-plani";
import { Route as AppMuhasebeRaporlarRouteImport } from "./routes/_app/muhasebe/raporlar";
import { Route as AppMusterilerIndexRouteImport } from "./routes/_app/musteriler/index";
import { Route as AppMusterilerIdRouteImport } from "./routes/_app/musteriler/$id";
import { Route as AppMusterilerYeniRouteImport } from "./routes/_app/musteriler/yeni";
import { Route as AppNakitAkisIndexRouteImport } from "./routes/_app/nakit-akis/index";
import { Route as AppOdemelerIndexRouteImport } from "./routes/_app/odemeler/index";
import { Route as AppOdemelerIdRouteImport } from "./routes/_app/odemeler/$id";
import { Route as AppOnaylarIndexRouteImport } from "./routes/_app/onaylar/index";
import { Route as AppOnaylarIdRouteImport } from "./routes/_app/onaylar/$id";
import { Route as AppOnaylarPolitikalarRouteImport } from "./routes/_app/onaylar/politikalar";
import { Route as AppOnaylarVekaletlerRouteImport } from "./routes/_app/onaylar/vekaletler";
import { Route as AppRaporlarIndexRouteImport } from "./routes/_app/raporlar/index";
import { Route as AppRaporlarAkaryakitRouteImport } from "./routes/_app/raporlar/akaryakit";
import { Route as AppRaporlarAyarlarRouteImport } from "./routes/_app/raporlar/ayarlar";
import { Route as AppRaporlarFinansRouteImport } from "./routes/_app/raporlar/finans";
import { Route as AppRaporlarKarlilikRouteImport } from "./routes/_app/raporlar/karlilik";
import { Route as AppRaporlarKarsilastirmaRouteImport } from "./routes/_app/raporlar/karsilastirma";
import { Route as AppRaporlarZamanlanmisRouteImport } from "./routes/_app/raporlar/zamanlanmis";
import { Route as AppSadakatIncelemeRouteImport } from "./routes/_app/sadakat/inceleme";
import { Route as AppSadakatKurallarRouteImport } from "./routes/_app/sadakat/kurallar";
import { Route as AppSadakatProgramRouteImport } from "./routes/_app/sadakat/program";
import { Route as AppSadakatRaporlarRouteImport } from "./routes/_app/sadakat/raporlar";
import { Route as AppSadakatSeviyelerRouteImport } from "./routes/_app/sadakat/seviyeler";
import { Route as AppSarjAgAktarimlariRouteImport } from "./routes/_app/sarj/ag-aktarimlari";
import { Route as AppSarjAyarlarRouteImport } from "./routes/_app/sarj/ayarlar";
import { Route as AppSarjDisaAktarimRouteImport } from "./routes/_app/sarj/disa-aktarim";
import { Route as AppSarjPanoRouteImport } from "./routes/_app/sarj/pano";
import { Route as AppSarjRaporlarRouteImport } from "./routes/_app/sarj/raporlar";
import { Route as AppSarjTarifelerRouteImport } from "./routes/_app/sarj/tarifeler";
import { Route as AppUyumIndexRouteImport } from "./routes/_app/uyum/index";
import { Route as AppUyumTurlerRouteImport } from "./routes/_app/uyum/turler";
import { Route as AppVardiyaAyarlarRouteImport } from "./routes/_app/vardiya/ayarlar";
import { Route as AppVardiyaPanoRouteImport } from "./routes/_app/vardiya/pano";
import { Route as AppVardiyaPersonelRouteImport } from "./routes/_app/vardiya/personel";
import { Route as AppVardiyaRaporlarRouteImport } from "./routes/_app/vardiya/raporlar";
import { Route as AppVardiyaSablonlarRouteImport } from "./routes/_app/vardiya/sablonlar";
import { Route as AppVardiyaZRaporlariRouteImport } from "./routes/_app/vardiya/z-raporlari";
import { Route as AppVergiTakvimiIndexRouteImport } from "./routes/_app/vergi-takvimi/index";
import { Route as AppVergiTakvimiKdvOzetiRouteImport } from "./routes/_app/vergi-takvimi/kdv-ozeti";
import { Route as AppVergiTakvimiKurallarRouteImport } from "./routes/_app/vergi-takvimi/kurallar";
import { Route as AppYikamaAyarlarRouteImport } from "./routes/_app/yikama/ayarlar";
import { Route as AppYikamaCalismalarRouteImport } from "./routes/_app/yikama/calismalar";
import { Route as AppYikamaKimyasallarRouteImport } from "./routes/_app/yikama/kimyasallar";
import { Route as AppYikamaProgramlarRouteImport } from "./routes/_app/yikama/programlar";
import { Route as AppYikamaRandevularRouteImport } from "./routes/_app/yikama/randevular";
import { Route as AppYikamaRaporlarRouteImport } from "./routes/_app/yikama/raporlar";
import { Route as AppYikamaSiraRouteImport } from "./routes/_app/yikama/sira";
import { Route as AppYikamaUnitelerRouteImport } from "./routes/_app/yikama/uniteler";
import { Route as PlatformFaturalarIndexRouteImport } from "./routes/platform/faturalar/index";
import { Route as PlatformFaturalarIdRouteImport } from "./routes/platform/faturalar/$id";
import { Route as PlatformKiracilarIndexRouteImport } from "./routes/platform/kiracilar/index";
import { Route as PlatformKiracilarIdRouteImport } from "./routes/platform/kiracilar/$id";
import { Route as AppAkaryakitDolumlarIndexRouteImport } from "./routes/_app/akaryakit/dolumlar/index";
import { Route as AppAkaryakitDolumlarIdRouteImport } from "./routes/_app/akaryakit/dolumlar/$id";
import { Route as AppAkaryakitDolumlarYeniRouteImport } from "./routes/_app/akaryakit/dolumlar/yeni";
import { Route as AppAkaryakitSiparislerIndexRouteImport } from "./routes/_app/akaryakit/siparisler/index";
import { Route as AppAkaryakitSiparislerIdRouteImport } from "./routes/_app/akaryakit/siparisler/$id";
import { Route as AppAkaryakitSiparislerYeniRouteImport } from "./routes/_app/akaryakit/siparisler/yeni";
import { Route as AppAyarlarIstasyonlarIndexRouteImport } from "./routes/_app/ayarlar/istasyonlar/index";
import { Route as AppAyarlarIstasyonlarStationIdRouteImport } from "./routes/_app/ayarlar/istasyonlar/$stationId";
import { Route as AppBakimIsEmirleriIndexRouteImport } from "./routes/_app/bakim/is-emirleri/index";
import { Route as AppBakimIsEmirleriIdRouteImport } from "./routes/_app/bakim/is-emirleri/$id";
import { Route as AppBakimVarliklarIndexRouteImport } from "./routes/_app/bakim/varliklar/index";
import { Route as AppCariIdIndexRouteImport } from "./routes/_app/cari/$id/index";
import { Route as AppCariIdDuzenleRouteImport } from "./routes/_app/cari/$id/duzenle";
import { Route as AppCekSenetBordrolarIndexRouteImport } from "./routes/_app/cek-senet/bordrolar/index";
import { Route as AppCekSenetBordrolarIdRouteImport } from "./routes/_app/cek-senet/bordrolar/$id";
import { Route as AppFaturalarIdIndexRouteImport } from "./routes/_app/faturalar/$id/index";
import { Route as AppFaturalarIdDuzenleRouteImport } from "./routes/_app/faturalar/$id/duzenle";
import { Route as AppFaturalarGelenKutusuIndexRouteImport } from "./routes/_app/faturalar/gelen-kutusu/index";
import { Route as AppFaturalarGelenKutusuIdRouteImport } from "./routes/_app/faturalar/gelen-kutusu/$id";
import { Route as AppFaturalarIrsaliyelerIndexRouteImport } from "./routes/_app/faturalar/irsaliyeler/index";
import { Route as AppFaturalarIrsaliyelerIdRouteImport } from "./routes/_app/faturalar/irsaliyeler/$id";
import { Route as AppFaturalarIrsaliyelerYeniRouteImport } from "./routes/_app/faturalar/irsaliyeler/yeni";
import { Route as AppFinansBankalarIndexRouteImport } from "./routes/_app/finans/bankalar/index";
import { Route as AppFinansBankalarIdRouteImport } from "./routes/_app/finans/bankalar/$id";
import { Route as AppFinansKasalarIndexRouteImport } from "./routes/_app/finans/kasalar/index";
import { Route as AppFinansKasalarIdRouteImport } from "./routes/_app/finans/kasalar/$id";
import { Route as AppGiderlerIdIndexRouteImport } from "./routes/_app/giderler/$id/index";
import { Route as AppGiderlerIdDuzenleRouteImport } from "./routes/_app/giderler/$id/duzenle";
import { Route as AppKasaSatislarIndexRouteImport } from "./routes/_app/kasa/satislar/index";
import { Route as AppKasaSatislarIdRouteImport } from "./routes/_app/kasa/satislar/$id";
import { Route as AppKvkkBasvurularIndexRouteImport } from "./routes/_app/kvkk/basvurular/index";
import { Route as AppKvkkBasvurularIdRouteImport } from "./routes/_app/kvkk/basvurular/$id";
import { Route as AppMarketEslestirmeIndexRouteImport } from "./routes/_app/market/eslestirme/index";
import { Route as AppMarketEslestirmeIdRouteImport } from "./routes/_app/market/eslestirme/$id";
import { Route as AppMarketFirelerIndexRouteImport } from "./routes/_app/market/fireler/index";
import { Route as AppMarketFirelerIdRouteImport } from "./routes/_app/market/fireler/$id";
import { Route as AppMarketMalKabulIndexRouteImport } from "./routes/_app/market/mal-kabul/index";
import { Route as AppMarketMalKabulIdRouteImport } from "./routes/_app/market/mal-kabul/$id";
import { Route as AppMarketSayimlarIndexRouteImport } from "./routes/_app/market/sayimlar/index";
import { Route as AppMarketSayimlarIdRouteImport } from "./routes/_app/market/sayimlar/$id";
import { Route as AppMarketSiparislerIndexRouteImport } from "./routes/_app/market/siparisler/index";
import { Route as AppMarketSiparislerIdRouteImport } from "./routes/_app/market/siparisler/$id";
import { Route as AppMarketStokIndexRouteImport } from "./routes/_app/market/stok/index";
import { Route as AppMarketStokProductIdRouteImport } from "./routes/_app/market/stok/$productId";
import { Route as AppMarketTransferlerIndexRouteImport } from "./routes/_app/market/transferler/index";
import { Route as AppMarketTransferlerIdRouteImport } from "./routes/_app/market/transferler/$id";
import { Route as AppMuhasebeFislerIndexRouteImport } from "./routes/_app/muhasebe/fisler/index";
import { Route as AppMuhasebeFislerYeniRouteImport } from "./routes/_app/muhasebe/fisler/yeni";
import { Route as AppSadakatAboneliklerIndexRouteImport } from "./routes/_app/sadakat/abonelikler/index";
import { Route as AppSadakatAboneliklerIdRouteImport } from "./routes/_app/sadakat/abonelikler/$id";
import { Route as AppSadakatKuponlarIndexRouteImport } from "./routes/_app/sadakat/kuponlar/index";
import { Route as AppSadakatKuponlarIdRouteImport } from "./routes/_app/sadakat/kuponlar/$id";
import { Route as AppSarjOturumlarIndexRouteImport } from "./routes/_app/sarj/oturumlar/index";
import { Route as AppSarjOturumlarIdRouteImport } from "./routes/_app/sarj/oturumlar/$id";
import { Route as AppSarjUnitelerIndexRouteImport } from "./routes/_app/sarj/uniteler/index";
import { Route as AppSarjUnitelerIdRouteImport } from "./routes/_app/sarj/uniteler/$id";
import { Route as AppUyumBelgelerIndexRouteImport } from "./routes/_app/uyum/belgeler/index";
import { Route as AppUyumBelgelerIdRouteImport } from "./routes/_app/uyum/belgeler/$id";
import { Route as AppUyumDenetimlerIndexRouteImport } from "./routes/_app/uyum/denetimler/index";
import { Route as AppUyumDenetimlerIdRouteImport } from "./routes/_app/uyum/denetimler/$id";
import { Route as AppVardiyaGunSonuIndexRouteImport } from "./routes/_app/vardiya/gun-sonu/index";
import { Route as AppVardiyaGunSonuIdRouteImport } from "./routes/_app/vardiya/gun-sonu/$id";
import { Route as AppVardiyaVardiyalarIndexRouteImport } from "./routes/_app/vardiya/vardiyalar/index";
import { Route as AppYikamaIsEmirleriIndexRouteImport } from "./routes/_app/yikama/is-emirleri/index";
import { Route as AppYikamaIsEmirleriIdRouteImport } from "./routes/_app/yikama/is-emirleri/$id";
import { Route as AppYikamaKredilerIndexRouteImport } from "./routes/_app/yikama/krediler/index";
import { Route as AppYikamaKredilerIdRouteImport } from "./routes/_app/yikama/krediler/$id";
import { Route as AppBakimVarliklarKindIdRouteImport } from "./routes/_app/bakim/varliklar/$kind/$id";
import { Route as AppMuhasebeFislerIdIndexRouteImport } from "./routes/_app/muhasebe/fisler/$id/index";
import { Route as AppMuhasebeFislerIdDuzenleRouteImport } from "./routes/_app/muhasebe/fisler/$id/duzenle";
import { Route as AppVardiyaVardiyalarIdIndexRouteImport } from "./routes/_app/vardiya/vardiyalar/$id/index";
import { Route as AppVardiyaVardiyalarIdHesapMemberIdRouteImport } from "./routes/_app/vardiya/vardiyalar/$id/hesap/$memberId";

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const DavetRoute = DavetRouteImport.update({
  id: "/davet",
  path: "/davet",
  getParentRoute: () => rootRouteImport,
} as any);
const GirisRoute = GirisRouteImport.update({
  id: "/giris",
  path: "/giris",
  getParentRoute: () => rootRouteImport,
} as any);
const ParolaSifirlaRoute = ParolaSifirlaRouteImport.update({
  id: "/parola-sifirla",
  path: "/parola-sifirla",
  getParentRoute: () => rootRouteImport,
} as any);
const ParolaUnuttumRoute = ParolaUnuttumRouteImport.update({
  id: "/parola-unuttum",
  path: "/parola-unuttum",
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformRoute = PlatformRouteImport.update({
  id: "/platform",
  path: "/platform",
  getParentRoute: () => rootRouteImport,
} as any);
const PortalRoute = PortalRouteImport.update({
  id: "/portal",
  path: "/portal",
  getParentRoute: () => rootRouteImport,
} as any);
const SiraEkraniRoute = SiraEkraniRouteImport.update({
  id: "/sira-ekrani",
  path: "/sira-ekrani",
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any);
const AppDuyurularRoute = AppDuyurularRouteImport.update({
  id: "/duyurular",
  path: "/duyurular",
  getParentRoute: () => AppRoute,
} as any);
const AppKurulumRoute = AppKurulumRouteImport.update({
  id: "/kurulum",
  path: "/kurulum",
  getParentRoute: () => AppRoute,
} as any);
const DevUiShowcaseRoute = DevUiShowcaseRouteImport.update({
  id: "/dev/ui-showcase",
  path: "/dev/ui-showcase",
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformAyarlarRoute = PlatformAyarlarRouteImport.update({
  id: "/ayarlar",
  path: "/ayarlar",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformDestekRoute = PlatformDestekRouteImport.update({
  id: "/destek",
  path: "/destek",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformDevirlerRoute = PlatformDevirlerRouteImport.update({
  id: "/devirler",
  path: "/devirler",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformDuyurularRoute = PlatformDuyurularRouteImport.update({
  id: "/duyurular",
  path: "/duyurular",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformPersonelRoute = PlatformPersonelRouteImport.update({
  id: "/personel",
  path: "/personel",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformPlanlarRoute = PlatformPlanlarRouteImport.update({
  id: "/planlar",
  path: "/planlar",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformSaglikRoute = PlatformSaglikRouteImport.update({
  id: "/saglik",
  path: "/saglik",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformTahsilatRoute = PlatformTahsilatRouteImport.update({
  id: "/tahsilat",
  path: "/tahsilat",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformYayinlarRoute = PlatformYayinlarRouteImport.update({
  id: "/yayinlar",
  path: "/yayinlar",
  getParentRoute: () => PlatformRoute,
} as any);
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PortalRoute,
} as any);
const PortalAraclarRoute = PortalAraclarRouteImport.update({
  id: "/araclar",
  path: "/araclar",
  getParentRoute: () => PortalRoute,
} as any);
const PortalFaturalarRoute = PortalFaturalarRouteImport.update({
  id: "/faturalar",
  path: "/faturalar",
  getParentRoute: () => PortalRoute,
} as any);
const PortalIslemlerRoute = PortalIslemlerRouteImport.update({
  id: "/islemler",
  path: "/islemler",
  getParentRoute: () => PortalRoute,
} as any);
const PortalTaleplerRoute = PortalTaleplerRouteImport.update({
  id: "/talepler",
  path: "/talepler",
  getParentRoute: () => PortalRoute,
} as any);
const SiraEkraniYikamaRoute = SiraEkraniYikamaRouteImport.update({
  id: "/yikama",
  path: "/yikama",
  getParentRoute: () => SiraEkraniRoute,
} as any);
const AppAjanlarIndexRoute = AppAjanlarIndexRouteImport.update({
  id: "/ajanlar/",
  path: "/ajanlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppAjanlarIdRoute = AppAjanlarIdRouteImport.update({
  id: "/ajanlar/$id",
  path: "/ajanlar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitAyarlarRoute = AppAkaryakitAyarlarRouteImport.update({
  id: "/akaryakit/ayarlar",
  path: "/akaryakit/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitEndeksRoute = AppAkaryakitEndeksRouteImport.update({
  id: "/akaryakit/endeks",
  path: "/akaryakit/endeks",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitFireRaporuRoute = AppAkaryakitFireRaporuRouteImport.update({
  id: "/akaryakit/fire-raporu",
  path: "/akaryakit/fire-raporu",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitFiyatFarkiRoute = AppAkaryakitFiyatFarkiRouteImport.update({
  id: "/akaryakit/fiyat-farki",
  path: "/akaryakit/fiyat-farki",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitMaliyetRoute = AppAkaryakitMaliyetRouteImport.update({
  id: "/akaryakit/maliyet",
  path: "/akaryakit/maliyet",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitMutabakatRoute = AppAkaryakitMutabakatRouteImport.update({
  id: "/akaryakit/mutabakat",
  path: "/akaryakit/mutabakat",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitSatislarRoute = AppAkaryakitSatislarRouteImport.update({
  id: "/akaryakit/satislar",
  path: "/akaryakit/satislar",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitSiparisOnerileriRoute =
  AppAkaryakitSiparisOnerileriRouteImport.update({
    id: "/akaryakit/siparis-onerileri",
    path: "/akaryakit/siparis-onerileri",
    getParentRoute: () => AppRoute,
  } as any);
const AppAkaryakitTanklarRoute = AppAkaryakitTanklarRouteImport.update({
  id: "/akaryakit/tanklar",
  path: "/akaryakit/tanklar",
  getParentRoute: () => AppRoute,
} as any);
const AppAlarmlarIndexRoute = AppAlarmlarIndexRouteImport.update({
  id: "/alarmlar/",
  path: "/alarmlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppAlarmlarAlarmIdRoute = AppAlarmlarAlarmIdRouteImport.update({
  id: "/alarmlar/$alarmId",
  path: "/alarmlar/$alarmId",
  getParentRoute: () => AppRoute,
} as any);
const AppAlarmlarKurallarRoute = AppAlarmlarKurallarRouteImport.update({
  id: "/alarmlar/kurallar",
  path: "/alarmlar/kurallar",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarAbonelikRoute = AppAyarlarAbonelikRouteImport.update({
  id: "/ayarlar/abonelik",
  path: "/ayarlar/abonelik",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarBolgelerRoute = AppAyarlarBolgelerRouteImport.update({
  id: "/ayarlar/bolgeler",
  path: "/ayarlar/bolgeler",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarDestekErisimiRoute = AppAyarlarDestekErisimiRouteImport.update({
  id: "/ayarlar/destek-erisimi",
  path: "/ayarlar/destek-erisimi",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarGuvenlikRoute = AppAyarlarGuvenlikRouteImport.update({
  id: "/ayarlar/guvenlik",
  path: "/ayarlar/guvenlik",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarIstasyonDevirleriRoute =
  AppAyarlarIstasyonDevirleriRouteImport.update({
    id: "/ayarlar/istasyon-devirleri",
    path: "/ayarlar/istasyon-devirleri",
    getParentRoute: () => AppRoute,
  } as any);
const AppAyarlarKullanicilarRoute = AppAyarlarKullanicilarRouteImport.update({
  id: "/ayarlar/kullanicilar",
  path: "/ayarlar/kullanicilar",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarProfilRoute = AppAyarlarProfilRouteImport.update({
  id: "/ayarlar/profil",
  path: "/ayarlar/profil",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarRollerRoute = AppAyarlarRollerRouteImport.update({
  id: "/ayarlar/roller",
  path: "/ayarlar/roller",
  getParentRoute: () => AppRoute,
} as any);
const AppAyarlarSirketlerRoute = AppAyarlarSirketlerRouteImport.update({
  id: "/ayarlar/sirketler",
  path: "/ayarlar/sirketler",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimAyarlarRoute = AppBakimAyarlarRouteImport.update({
  id: "/bakim/ayarlar",
  path: "/bakim/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimPlanlarRoute = AppBakimPlanlarRouteImport.update({
  id: "/bakim/planlar",
  path: "/bakim/planlar",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimRaporlarRoute = AppBakimRaporlarRouteImport.update({
  id: "/bakim/raporlar",
  path: "/bakim/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppBildirimlerIndexRoute = AppBildirimlerIndexRouteImport.update({
  id: "/bildirimler/",
  path: "/bildirimler/",
  getParentRoute: () => AppRoute,
} as any);
const AppBildirimlerTercihlerRoute = AppBildirimlerTercihlerRouteImport.update({
  id: "/bildirimler/tercihler",
  path: "/bildirimler/tercihler",
  getParentRoute: () => AppRoute,
} as any);
const AppButceIndexRoute = AppButceIndexRouteImport.update({
  id: "/butce/",
  path: "/butce/",
  getParentRoute: () => AppRoute,
} as any);
const AppButceIdRoute = AppButceIdRouteImport.update({
  id: "/butce/$id",
  path: "/butce/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppButceRaporRoute = AppButceRaporRouteImport.update({
  id: "/butce/rapor",
  path: "/butce/rapor",
  getParentRoute: () => AppRoute,
} as any);
const AppCariIndexRoute = AppCariIndexRouteImport.update({
  id: "/cari/",
  path: "/cari/",
  getParentRoute: () => AppRoute,
} as any);
const AppCariAcilisAktarimiRoute = AppCariAcilisAktarimiRouteImport.update({
  id: "/cari/acilis-aktarimi",
  path: "/cari/acilis-aktarimi",
  getParentRoute: () => AppRoute,
} as any);
const AppCariHareketYeniRoute = AppCariHareketYeniRouteImport.update({
  id: "/cari/hareket-yeni",
  path: "/cari/hareket-yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppCariRaporlarRoute = AppCariRaporlarRouteImport.update({
  id: "/cari/raporlar",
  path: "/cari/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppCariRiskRoute = AppCariRiskRouteImport.update({
  id: "/cari/risk",
  path: "/cari/risk",
  getParentRoute: () => AppRoute,
} as any);
const AppCariYeniRoute = AppCariYeniRouteImport.update({
  id: "/cari/yeni",
  path: "/cari/yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetIndexRoute = AppCekSenetIndexRouteImport.update({
  id: "/cek-senet/",
  path: "/cek-senet/",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetIdRoute = AppCekSenetIdRouteImport.update({
  id: "/cek-senet/$id",
  path: "/cek-senet/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetAyarlarRoute = AppCekSenetAyarlarRouteImport.update({
  id: "/cek-senet/ayarlar",
  path: "/cek-senet/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetBordroYeniRoute = AppCekSenetBordroYeniRouteImport.update({
  id: "/cek-senet/bordro-yeni",
  path: "/cek-senet/bordro-yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetKarnelerRoute = AppCekSenetKarnelerRouteImport.update({
  id: "/cek-senet/karneler",
  path: "/cek-senet/karneler",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetRaporlarRoute = AppCekSenetRaporlarRouteImport.update({
  id: "/cek-senet/raporlar",
  path: "/cek-senet/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetTakvimRoute = AppCekSenetTakvimRouteImport.update({
  id: "/cek-senet/takvim",
  path: "/cek-senet/takvim",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarIndexRoute = AppFaturalarIndexRouteImport.update({
  id: "/faturalar/",
  path: "/faturalar/",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarAyarlarRoute = AppFaturalarAyarlarRouteImport.update({
  id: "/faturalar/ayarlar",
  path: "/faturalar/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarEArsivTalepleriRoute =
  AppFaturalarEArsivTalepleriRouteImport.update({
    id: "/faturalar/e-arsiv-talepleri",
    path: "/faturalar/e-arsiv-talepleri",
    getParentRoute: () => AppRoute,
  } as any);
const AppFaturalarYeniRoute = AppFaturalarYeniRouteImport.update({
  id: "/faturalar/yeni",
  path: "/faturalar/yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppFiloIndexRoute = AppFiloIndexRouteImport.update({
  id: "/filo/",
  path: "/filo/",
  getParentRoute: () => AppRoute,
} as any);
const AppFiloCounterpartyIdRoute = AppFiloCounterpartyIdRouteImport.update({
  id: "/filo/$counterpartyId",
  path: "/filo/$counterpartyId",
  getParentRoute: () => AppRoute,
} as any);
const AppFiloAracTalepleriRoute = AppFiloAracTalepleriRouteImport.update({
  id: "/filo/arac-talepleri",
  path: "/filo/arac-talepleri",
  getParentRoute: () => AppRoute,
} as any);
const AppFiloTuketimRoute = AppFiloTuketimRouteImport.update({
  id: "/filo/tuketim",
  path: "/filo/tuketim",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansIndexRoute = AppFinansIndexRouteImport.update({
  id: "/finans/",
  path: "/finans/",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansAyarlarRoute = AppFinansAyarlarRouteImport.update({
  id: "/finans/ayarlar",
  path: "/finans/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansDbsRoute = AppFinansDbsRouteImport.update({
  id: "/finans/dbs",
  path: "/finans/dbs",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansEkstreRoute = AppFinansEkstreRouteImport.update({
  id: "/finans/ekstre",
  path: "/finans/ekstre",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansHareketYeniRoute = AppFinansHareketYeniRouteImport.update({
  id: "/finans/hareket-yeni",
  path: "/finans/hareket-yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansHareketlerRoute = AppFinansHareketlerRouteImport.update({
  id: "/finans/hareketler",
  path: "/finans/hareketler",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansKredilerRoute = AppFinansKredilerRouteImport.update({
  id: "/finans/krediler",
  path: "/finans/krediler",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansPosRoute = AppFinansPosRouteImport.update({
  id: "/finans/pos",
  path: "/finans/pos",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansTeminatlarRoute = AppFinansTeminatlarRouteImport.update({
  id: "/finans/teminatlar",
  path: "/finans/teminatlar",
  getParentRoute: () => AppRoute,
} as any);
const AppFiyatlarIndexRoute = AppFiyatlarIndexRouteImport.update({
  id: "/fiyatlar/",
  path: "/fiyatlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppFiyatlarTopluDegisiklikRoute =
  AppFiyatlarTopluDegisiklikRouteImport.update({
    id: "/fiyatlar/toplu-degisiklik",
    path: "/fiyatlar/toplu-degisiklik",
    getParentRoute: () => AppRoute,
  } as any);
const AppGiderlerIndexRoute = AppGiderlerIndexRouteImport.update({
  id: "/giderler/",
  path: "/giderler/",
  getParentRoute: () => AppRoute,
} as any);
const AppGiderlerTanimlarRoute = AppGiderlerTanimlarRouteImport.update({
  id: "/giderler/tanimlar",
  path: "/giderler/tanimlar",
  getParentRoute: () => AppRoute,
} as any);
const AppGiderlerYeniRoute = AppGiderlerYeniRouteImport.update({
  id: "/giderler/yeni",
  path: "/giderler/yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppKasaAyarlarRoute = AppKasaAyarlarRouteImport.update({
  id: "/kasa/ayarlar",
  path: "/kasa/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppKasaKampanyalarRoute = AppKasaKampanyalarRouteImport.update({
  id: "/kasa/kampanyalar",
  path: "/kasa/kampanyalar",
  getParentRoute: () => AppRoute,
} as any);
const AppKatalogUrunlerRoute = AppKatalogUrunlerRouteImport.update({
  id: "/katalog/urunler",
  path: "/katalog/urunler",
  getParentRoute: () => AppRoute,
} as any);
const AppKvkkAyarlarRoute = AppKvkkAyarlarRouteImport.update({
  id: "/kvkk/ayarlar",
  path: "/kvkk/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppKvkkMetinlerRoute = AppKvkkMetinlerRouteImport.update({
  id: "/kvkk/metinler",
  path: "/kvkk/metinler",
  getParentRoute: () => AppRoute,
} as any);
const AppKvkkPazarlamaRoute = AppKvkkPazarlamaRouteImport.update({
  id: "/kvkk/pazarlama",
  path: "/kvkk/pazarlama",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketAyarlarRoute = AppMarketAyarlarRouteImport.update({
  id: "/market/ayarlar",
  path: "/market/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketEtiketlerRoute = AppMarketEtiketlerRouteImport.update({
  id: "/market/etiketler",
  path: "/market/etiketler",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketFiyatOnerisiRoute = AppMarketFiyatOnerisiRouteImport.update({
  id: "/market/fiyat-onerisi",
  path: "/market/fiyat-onerisi",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketGunKapanislariRoute = AppMarketGunKapanislariRouteImport.update({
  id: "/market/gun-kapanislari",
  path: "/market/gun-kapanislari",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketHareketlerRoute = AppMarketHareketlerRouteImport.update({
  id: "/market/hareketler",
  path: "/market/hareketler",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketLisanslarRoute = AppMarketLisanslarRouteImport.update({
  id: "/market/lisanslar",
  path: "/market/lisanslar",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketPartilerRoute = AppMarketPartilerRouteImport.update({
  id: "/market/partiler",
  path: "/market/partiler",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketRaporlarRoute = AppMarketRaporlarRouteImport.update({
  id: "/market/raporlar",
  path: "/market/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketSiparisOnerisiRoute = AppMarketSiparisOnerisiRouteImport.update({
  id: "/market/siparis-onerisi",
  path: "/market/siparis-onerisi",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeAraclarRoute = AppMuhasebeAraclarRouteImport.update({
  id: "/muhasebe/araclar",
  path: "/muhasebe/araclar",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeDonemlerRoute = AppMuhasebeDonemlerRouteImport.update({
  id: "/muhasebe/donemler",
  path: "/muhasebe/donemler",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeEslestirmelerRoute =
  AppMuhasebeEslestirmelerRouteImport.update({
    id: "/muhasebe/eslestirmeler",
    path: "/muhasebe/eslestirmeler",
    getParentRoute: () => AppRoute,
  } as any);
const AppMuhasebeHesapPlaniRoute = AppMuhasebeHesapPlaniRouteImport.update({
  id: "/muhasebe/hesap-plani",
  path: "/muhasebe/hesap-plani",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeRaporlarRoute = AppMuhasebeRaporlarRouteImport.update({
  id: "/muhasebe/raporlar",
  path: "/muhasebe/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppMusterilerIndexRoute = AppMusterilerIndexRouteImport.update({
  id: "/musteriler/",
  path: "/musteriler/",
  getParentRoute: () => AppRoute,
} as any);
const AppMusterilerIdRoute = AppMusterilerIdRouteImport.update({
  id: "/musteriler/$id",
  path: "/musteriler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMusterilerYeniRoute = AppMusterilerYeniRouteImport.update({
  id: "/musteriler/yeni",
  path: "/musteriler/yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppNakitAkisIndexRoute = AppNakitAkisIndexRouteImport.update({
  id: "/nakit-akis/",
  path: "/nakit-akis/",
  getParentRoute: () => AppRoute,
} as any);
const AppOdemelerIndexRoute = AppOdemelerIndexRouteImport.update({
  id: "/odemeler/",
  path: "/odemeler/",
  getParentRoute: () => AppRoute,
} as any);
const AppOdemelerIdRoute = AppOdemelerIdRouteImport.update({
  id: "/odemeler/$id",
  path: "/odemeler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppOnaylarIndexRoute = AppOnaylarIndexRouteImport.update({
  id: "/onaylar/",
  path: "/onaylar/",
  getParentRoute: () => AppRoute,
} as any);
const AppOnaylarIdRoute = AppOnaylarIdRouteImport.update({
  id: "/onaylar/$id",
  path: "/onaylar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppOnaylarPolitikalarRoute = AppOnaylarPolitikalarRouteImport.update({
  id: "/onaylar/politikalar",
  path: "/onaylar/politikalar",
  getParentRoute: () => AppRoute,
} as any);
const AppOnaylarVekaletlerRoute = AppOnaylarVekaletlerRouteImport.update({
  id: "/onaylar/vekaletler",
  path: "/onaylar/vekaletler",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarIndexRoute = AppRaporlarIndexRouteImport.update({
  id: "/raporlar/",
  path: "/raporlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarAkaryakitRoute = AppRaporlarAkaryakitRouteImport.update({
  id: "/raporlar/akaryakit",
  path: "/raporlar/akaryakit",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarAyarlarRoute = AppRaporlarAyarlarRouteImport.update({
  id: "/raporlar/ayarlar",
  path: "/raporlar/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarFinansRoute = AppRaporlarFinansRouteImport.update({
  id: "/raporlar/finans",
  path: "/raporlar/finans",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarKarlilikRoute = AppRaporlarKarlilikRouteImport.update({
  id: "/raporlar/karlilik",
  path: "/raporlar/karlilik",
  getParentRoute: () => AppRoute,
} as any);
const AppRaporlarKarsilastirmaRoute =
  AppRaporlarKarsilastirmaRouteImport.update({
    id: "/raporlar/karsilastirma",
    path: "/raporlar/karsilastirma",
    getParentRoute: () => AppRoute,
  } as any);
const AppRaporlarZamanlanmisRoute = AppRaporlarZamanlanmisRouteImport.update({
  id: "/raporlar/zamanlanmis",
  path: "/raporlar/zamanlanmis",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatIncelemeRoute = AppSadakatIncelemeRouteImport.update({
  id: "/sadakat/inceleme",
  path: "/sadakat/inceleme",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatKurallarRoute = AppSadakatKurallarRouteImport.update({
  id: "/sadakat/kurallar",
  path: "/sadakat/kurallar",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatProgramRoute = AppSadakatProgramRouteImport.update({
  id: "/sadakat/program",
  path: "/sadakat/program",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatRaporlarRoute = AppSadakatRaporlarRouteImport.update({
  id: "/sadakat/raporlar",
  path: "/sadakat/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatSeviyelerRoute = AppSadakatSeviyelerRouteImport.update({
  id: "/sadakat/seviyeler",
  path: "/sadakat/seviyeler",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjAgAktarimlariRoute = AppSarjAgAktarimlariRouteImport.update({
  id: "/sarj/ag-aktarimlari",
  path: "/sarj/ag-aktarimlari",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjAyarlarRoute = AppSarjAyarlarRouteImport.update({
  id: "/sarj/ayarlar",
  path: "/sarj/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjDisaAktarimRoute = AppSarjDisaAktarimRouteImport.update({
  id: "/sarj/disa-aktarim",
  path: "/sarj/disa-aktarim",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjPanoRoute = AppSarjPanoRouteImport.update({
  id: "/sarj/pano",
  path: "/sarj/pano",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjRaporlarRoute = AppSarjRaporlarRouteImport.update({
  id: "/sarj/raporlar",
  path: "/sarj/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjTarifelerRoute = AppSarjTarifelerRouteImport.update({
  id: "/sarj/tarifeler",
  path: "/sarj/tarifeler",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumIndexRoute = AppUyumIndexRouteImport.update({
  id: "/uyum/",
  path: "/uyum/",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumTurlerRoute = AppUyumTurlerRouteImport.update({
  id: "/uyum/turler",
  path: "/uyum/turler",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaAyarlarRoute = AppVardiyaAyarlarRouteImport.update({
  id: "/vardiya/ayarlar",
  path: "/vardiya/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaPanoRoute = AppVardiyaPanoRouteImport.update({
  id: "/vardiya/pano",
  path: "/vardiya/pano",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaPersonelRoute = AppVardiyaPersonelRouteImport.update({
  id: "/vardiya/personel",
  path: "/vardiya/personel",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaRaporlarRoute = AppVardiyaRaporlarRouteImport.update({
  id: "/vardiya/raporlar",
  path: "/vardiya/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaSablonlarRoute = AppVardiyaSablonlarRouteImport.update({
  id: "/vardiya/sablonlar",
  path: "/vardiya/sablonlar",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaZRaporlariRoute = AppVardiyaZRaporlariRouteImport.update({
  id: "/vardiya/z-raporlari",
  path: "/vardiya/z-raporlari",
  getParentRoute: () => AppRoute,
} as any);
const AppVergiTakvimiIndexRoute = AppVergiTakvimiIndexRouteImport.update({
  id: "/vergi-takvimi/",
  path: "/vergi-takvimi/",
  getParentRoute: () => AppRoute,
} as any);
const AppVergiTakvimiKdvOzetiRoute = AppVergiTakvimiKdvOzetiRouteImport.update({
  id: "/vergi-takvimi/kdv-ozeti",
  path: "/vergi-takvimi/kdv-ozeti",
  getParentRoute: () => AppRoute,
} as any);
const AppVergiTakvimiKurallarRoute = AppVergiTakvimiKurallarRouteImport.update({
  id: "/vergi-takvimi/kurallar",
  path: "/vergi-takvimi/kurallar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaAyarlarRoute = AppYikamaAyarlarRouteImport.update({
  id: "/yikama/ayarlar",
  path: "/yikama/ayarlar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaCalismalarRoute = AppYikamaCalismalarRouteImport.update({
  id: "/yikama/calismalar",
  path: "/yikama/calismalar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaKimyasallarRoute = AppYikamaKimyasallarRouteImport.update({
  id: "/yikama/kimyasallar",
  path: "/yikama/kimyasallar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaProgramlarRoute = AppYikamaProgramlarRouteImport.update({
  id: "/yikama/programlar",
  path: "/yikama/programlar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaRandevularRoute = AppYikamaRandevularRouteImport.update({
  id: "/yikama/randevular",
  path: "/yikama/randevular",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaRaporlarRoute = AppYikamaRaporlarRouteImport.update({
  id: "/yikama/raporlar",
  path: "/yikama/raporlar",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaSiraRoute = AppYikamaSiraRouteImport.update({
  id: "/yikama/sira",
  path: "/yikama/sira",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaUnitelerRoute = AppYikamaUnitelerRouteImport.update({
  id: "/yikama/uniteler",
  path: "/yikama/uniteler",
  getParentRoute: () => AppRoute,
} as any);
const PlatformFaturalarIndexRoute = PlatformFaturalarIndexRouteImport.update({
  id: "/faturalar/",
  path: "/faturalar/",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformFaturalarIdRoute = PlatformFaturalarIdRouteImport.update({
  id: "/faturalar/$id",
  path: "/faturalar/$id",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformKiracilarIndexRoute = PlatformKiracilarIndexRouteImport.update({
  id: "/kiracilar/",
  path: "/kiracilar/",
  getParentRoute: () => PlatformRoute,
} as any);
const PlatformKiracilarIdRoute = PlatformKiracilarIdRouteImport.update({
  id: "/kiracilar/$id",
  path: "/kiracilar/$id",
  getParentRoute: () => PlatformRoute,
} as any);
const AppAkaryakitDolumlarIndexRoute =
  AppAkaryakitDolumlarIndexRouteImport.update({
    id: "/akaryakit/dolumlar/",
    path: "/akaryakit/dolumlar/",
    getParentRoute: () => AppRoute,
  } as any);
const AppAkaryakitDolumlarIdRoute = AppAkaryakitDolumlarIdRouteImport.update({
  id: "/akaryakit/dolumlar/$id",
  path: "/akaryakit/dolumlar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppAkaryakitDolumlarYeniRoute =
  AppAkaryakitDolumlarYeniRouteImport.update({
    id: "/akaryakit/dolumlar/yeni",
    path: "/akaryakit/dolumlar/yeni",
    getParentRoute: () => AppRoute,
  } as any);
const AppAkaryakitSiparislerIndexRoute =
  AppAkaryakitSiparislerIndexRouteImport.update({
    id: "/akaryakit/siparisler/",
    path: "/akaryakit/siparisler/",
    getParentRoute: () => AppRoute,
  } as any);
const AppAkaryakitSiparislerIdRoute =
  AppAkaryakitSiparislerIdRouteImport.update({
    id: "/akaryakit/siparisler/$id",
    path: "/akaryakit/siparisler/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppAkaryakitSiparislerYeniRoute =
  AppAkaryakitSiparislerYeniRouteImport.update({
    id: "/akaryakit/siparisler/yeni",
    path: "/akaryakit/siparisler/yeni",
    getParentRoute: () => AppRoute,
  } as any);
const AppAyarlarIstasyonlarIndexRoute =
  AppAyarlarIstasyonlarIndexRouteImport.update({
    id: "/ayarlar/istasyonlar/",
    path: "/ayarlar/istasyonlar/",
    getParentRoute: () => AppRoute,
  } as any);
const AppAyarlarIstasyonlarStationIdRoute =
  AppAyarlarIstasyonlarStationIdRouteImport.update({
    id: "/ayarlar/istasyonlar/$stationId",
    path: "/ayarlar/istasyonlar/$stationId",
    getParentRoute: () => AppRoute,
  } as any);
const AppBakimIsEmirleriIndexRoute = AppBakimIsEmirleriIndexRouteImport.update({
  id: "/bakim/is-emirleri/",
  path: "/bakim/is-emirleri/",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimIsEmirleriIdRoute = AppBakimIsEmirleriIdRouteImport.update({
  id: "/bakim/is-emirleri/$id",
  path: "/bakim/is-emirleri/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimVarliklarIndexRoute = AppBakimVarliklarIndexRouteImport.update({
  id: "/bakim/varliklar/",
  path: "/bakim/varliklar/",
  getParentRoute: () => AppRoute,
} as any);
const AppCariIdIndexRoute = AppCariIdIndexRouteImport.update({
  id: "/cari/$id/",
  path: "/cari/$id/",
  getParentRoute: () => AppRoute,
} as any);
const AppCariIdDuzenleRoute = AppCariIdDuzenleRouteImport.update({
  id: "/cari/$id/duzenle",
  path: "/cari/$id/duzenle",
  getParentRoute: () => AppRoute,
} as any);
const AppCekSenetBordrolarIndexRoute =
  AppCekSenetBordrolarIndexRouteImport.update({
    id: "/cek-senet/bordrolar/",
    path: "/cek-senet/bordrolar/",
    getParentRoute: () => AppRoute,
  } as any);
const AppCekSenetBordrolarIdRoute = AppCekSenetBordrolarIdRouteImport.update({
  id: "/cek-senet/bordrolar/$id",
  path: "/cek-senet/bordrolar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarIdIndexRoute = AppFaturalarIdIndexRouteImport.update({
  id: "/faturalar/$id/",
  path: "/faturalar/$id/",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarIdDuzenleRoute = AppFaturalarIdDuzenleRouteImport.update({
  id: "/faturalar/$id/duzenle",
  path: "/faturalar/$id/duzenle",
  getParentRoute: () => AppRoute,
} as any);
const AppFaturalarGelenKutusuIndexRoute =
  AppFaturalarGelenKutusuIndexRouteImport.update({
    id: "/faturalar/gelen-kutusu/",
    path: "/faturalar/gelen-kutusu/",
    getParentRoute: () => AppRoute,
  } as any);
const AppFaturalarGelenKutusuIdRoute =
  AppFaturalarGelenKutusuIdRouteImport.update({
    id: "/faturalar/gelen-kutusu/$id",
    path: "/faturalar/gelen-kutusu/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppFaturalarIrsaliyelerIndexRoute =
  AppFaturalarIrsaliyelerIndexRouteImport.update({
    id: "/faturalar/irsaliyeler/",
    path: "/faturalar/irsaliyeler/",
    getParentRoute: () => AppRoute,
  } as any);
const AppFaturalarIrsaliyelerIdRoute =
  AppFaturalarIrsaliyelerIdRouteImport.update({
    id: "/faturalar/irsaliyeler/$id",
    path: "/faturalar/irsaliyeler/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppFaturalarIrsaliyelerYeniRoute =
  AppFaturalarIrsaliyelerYeniRouteImport.update({
    id: "/faturalar/irsaliyeler/yeni",
    path: "/faturalar/irsaliyeler/yeni",
    getParentRoute: () => AppRoute,
  } as any);
const AppFinansBankalarIndexRoute = AppFinansBankalarIndexRouteImport.update({
  id: "/finans/bankalar/",
  path: "/finans/bankalar/",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansBankalarIdRoute = AppFinansBankalarIdRouteImport.update({
  id: "/finans/bankalar/$id",
  path: "/finans/bankalar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansKasalarIndexRoute = AppFinansKasalarIndexRouteImport.update({
  id: "/finans/kasalar/",
  path: "/finans/kasalar/",
  getParentRoute: () => AppRoute,
} as any);
const AppFinansKasalarIdRoute = AppFinansKasalarIdRouteImport.update({
  id: "/finans/kasalar/$id",
  path: "/finans/kasalar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppGiderlerIdIndexRoute = AppGiderlerIdIndexRouteImport.update({
  id: "/giderler/$id/",
  path: "/giderler/$id/",
  getParentRoute: () => AppRoute,
} as any);
const AppGiderlerIdDuzenleRoute = AppGiderlerIdDuzenleRouteImport.update({
  id: "/giderler/$id/duzenle",
  path: "/giderler/$id/duzenle",
  getParentRoute: () => AppRoute,
} as any);
const AppKasaSatislarIndexRoute = AppKasaSatislarIndexRouteImport.update({
  id: "/kasa/satislar/",
  path: "/kasa/satislar/",
  getParentRoute: () => AppRoute,
} as any);
const AppKasaSatislarIdRoute = AppKasaSatislarIdRouteImport.update({
  id: "/kasa/satislar/$id",
  path: "/kasa/satislar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppKvkkBasvurularIndexRoute = AppKvkkBasvurularIndexRouteImport.update({
  id: "/kvkk/basvurular/",
  path: "/kvkk/basvurular/",
  getParentRoute: () => AppRoute,
} as any);
const AppKvkkBasvurularIdRoute = AppKvkkBasvurularIdRouteImport.update({
  id: "/kvkk/basvurular/$id",
  path: "/kvkk/basvurular/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketEslestirmeIndexRoute =
  AppMarketEslestirmeIndexRouteImport.update({
    id: "/market/eslestirme/",
    path: "/market/eslestirme/",
    getParentRoute: () => AppRoute,
  } as any);
const AppMarketEslestirmeIdRoute = AppMarketEslestirmeIdRouteImport.update({
  id: "/market/eslestirme/$id",
  path: "/market/eslestirme/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketFirelerIndexRoute = AppMarketFirelerIndexRouteImport.update({
  id: "/market/fireler/",
  path: "/market/fireler/",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketFirelerIdRoute = AppMarketFirelerIdRouteImport.update({
  id: "/market/fireler/$id",
  path: "/market/fireler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketMalKabulIndexRoute = AppMarketMalKabulIndexRouteImport.update({
  id: "/market/mal-kabul/",
  path: "/market/mal-kabul/",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketMalKabulIdRoute = AppMarketMalKabulIdRouteImport.update({
  id: "/market/mal-kabul/$id",
  path: "/market/mal-kabul/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketSayimlarIndexRoute = AppMarketSayimlarIndexRouteImport.update({
  id: "/market/sayimlar/",
  path: "/market/sayimlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketSayimlarIdRoute = AppMarketSayimlarIdRouteImport.update({
  id: "/market/sayimlar/$id",
  path: "/market/sayimlar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketSiparislerIndexRoute =
  AppMarketSiparislerIndexRouteImport.update({
    id: "/market/siparisler/",
    path: "/market/siparisler/",
    getParentRoute: () => AppRoute,
  } as any);
const AppMarketSiparislerIdRoute = AppMarketSiparislerIdRouteImport.update({
  id: "/market/siparisler/$id",
  path: "/market/siparisler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketStokIndexRoute = AppMarketStokIndexRouteImport.update({
  id: "/market/stok/",
  path: "/market/stok/",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketStokProductIdRoute = AppMarketStokProductIdRouteImport.update({
  id: "/market/stok/$productId",
  path: "/market/stok/$productId",
  getParentRoute: () => AppRoute,
} as any);
const AppMarketTransferlerIndexRoute =
  AppMarketTransferlerIndexRouteImport.update({
    id: "/market/transferler/",
    path: "/market/transferler/",
    getParentRoute: () => AppRoute,
  } as any);
const AppMarketTransferlerIdRoute = AppMarketTransferlerIdRouteImport.update({
  id: "/market/transferler/$id",
  path: "/market/transferler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeFislerIndexRoute = AppMuhasebeFislerIndexRouteImport.update({
  id: "/muhasebe/fisler/",
  path: "/muhasebe/fisler/",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeFislerYeniRoute = AppMuhasebeFislerYeniRouteImport.update({
  id: "/muhasebe/fisler/yeni",
  path: "/muhasebe/fisler/yeni",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatAboneliklerIndexRoute =
  AppSadakatAboneliklerIndexRouteImport.update({
    id: "/sadakat/abonelikler/",
    path: "/sadakat/abonelikler/",
    getParentRoute: () => AppRoute,
  } as any);
const AppSadakatAboneliklerIdRoute = AppSadakatAboneliklerIdRouteImport.update({
  id: "/sadakat/abonelikler/$id",
  path: "/sadakat/abonelikler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatKuponlarIndexRoute = AppSadakatKuponlarIndexRouteImport.update({
  id: "/sadakat/kuponlar/",
  path: "/sadakat/kuponlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppSadakatKuponlarIdRoute = AppSadakatKuponlarIdRouteImport.update({
  id: "/sadakat/kuponlar/$id",
  path: "/sadakat/kuponlar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjOturumlarIndexRoute = AppSarjOturumlarIndexRouteImport.update({
  id: "/sarj/oturumlar/",
  path: "/sarj/oturumlar/",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjOturumlarIdRoute = AppSarjOturumlarIdRouteImport.update({
  id: "/sarj/oturumlar/$id",
  path: "/sarj/oturumlar/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjUnitelerIndexRoute = AppSarjUnitelerIndexRouteImport.update({
  id: "/sarj/uniteler/",
  path: "/sarj/uniteler/",
  getParentRoute: () => AppRoute,
} as any);
const AppSarjUnitelerIdRoute = AppSarjUnitelerIdRouteImport.update({
  id: "/sarj/uniteler/$id",
  path: "/sarj/uniteler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumBelgelerIndexRoute = AppUyumBelgelerIndexRouteImport.update({
  id: "/uyum/belgeler/",
  path: "/uyum/belgeler/",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumBelgelerIdRoute = AppUyumBelgelerIdRouteImport.update({
  id: "/uyum/belgeler/$id",
  path: "/uyum/belgeler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumDenetimlerIndexRoute = AppUyumDenetimlerIndexRouteImport.update({
  id: "/uyum/denetimler/",
  path: "/uyum/denetimler/",
  getParentRoute: () => AppRoute,
} as any);
const AppUyumDenetimlerIdRoute = AppUyumDenetimlerIdRouteImport.update({
  id: "/uyum/denetimler/$id",
  path: "/uyum/denetimler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaGunSonuIndexRoute = AppVardiyaGunSonuIndexRouteImport.update({
  id: "/vardiya/gun-sonu/",
  path: "/vardiya/gun-sonu/",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaGunSonuIdRoute = AppVardiyaGunSonuIdRouteImport.update({
  id: "/vardiya/gun-sonu/$id",
  path: "/vardiya/gun-sonu/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppVardiyaVardiyalarIndexRoute =
  AppVardiyaVardiyalarIndexRouteImport.update({
    id: "/vardiya/vardiyalar/",
    path: "/vardiya/vardiyalar/",
    getParentRoute: () => AppRoute,
  } as any);
const AppYikamaIsEmirleriIndexRoute =
  AppYikamaIsEmirleriIndexRouteImport.update({
    id: "/yikama/is-emirleri/",
    path: "/yikama/is-emirleri/",
    getParentRoute: () => AppRoute,
  } as any);
const AppYikamaIsEmirleriIdRoute = AppYikamaIsEmirleriIdRouteImport.update({
  id: "/yikama/is-emirleri/$id",
  path: "/yikama/is-emirleri/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaKredilerIndexRoute = AppYikamaKredilerIndexRouteImport.update({
  id: "/yikama/krediler/",
  path: "/yikama/krediler/",
  getParentRoute: () => AppRoute,
} as any);
const AppYikamaKredilerIdRoute = AppYikamaKredilerIdRouteImport.update({
  id: "/yikama/krediler/$id",
  path: "/yikama/krediler/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppBakimVarliklarKindIdRoute = AppBakimVarliklarKindIdRouteImport.update({
  id: "/bakim/varliklar/$kind/$id",
  path: "/bakim/varliklar/$kind/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMuhasebeFislerIdIndexRoute =
  AppMuhasebeFislerIdIndexRouteImport.update({
    id: "/muhasebe/fisler/$id/",
    path: "/muhasebe/fisler/$id/",
    getParentRoute: () => AppRoute,
  } as any);
const AppMuhasebeFislerIdDuzenleRoute =
  AppMuhasebeFislerIdDuzenleRouteImport.update({
    id: "/muhasebe/fisler/$id/duzenle",
    path: "/muhasebe/fisler/$id/duzenle",
    getParentRoute: () => AppRoute,
  } as any);
const AppVardiyaVardiyalarIdIndexRoute =
  AppVardiyaVardiyalarIdIndexRouteImport.update({
    id: "/vardiya/vardiyalar/$id/",
    path: "/vardiya/vardiyalar/$id/",
    getParentRoute: () => AppRoute,
  } as any);
const AppVardiyaVardiyalarIdHesapMemberIdRoute =
  AppVardiyaVardiyalarIdHesapMemberIdRouteImport.update({
    id: "/vardiya/vardiyalar/$id/hesap/$memberId",
    path: "/vardiya/vardiyalar/$id/hesap/$memberId",
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute;
  "/davet": typeof DavetRoute;
  "/giris": typeof GirisRoute;
  "/parola-sifirla": typeof ParolaSifirlaRoute;
  "/parola-unuttum": typeof ParolaUnuttumRoute;
  "/platform": typeof PlatformRouteWithChildren;
  "/portal": typeof PortalRouteWithChildren;
  "/sira-ekrani": typeof SiraEkraniRouteWithChildren;
  "/duyurular": typeof AppDuyurularRoute;
  "/kurulum": typeof AppKurulumRoute;
  "/dev/ui-showcase": typeof DevUiShowcaseRoute;
  "/platform/ayarlar": typeof PlatformAyarlarRoute;
  "/platform/destek": typeof PlatformDestekRoute;
  "/platform/devirler": typeof PlatformDevirlerRoute;
  "/platform/duyurular": typeof PlatformDuyurularRoute;
  "/platform/personel": typeof PlatformPersonelRoute;
  "/platform/planlar": typeof PlatformPlanlarRoute;
  "/platform/saglik": typeof PlatformSaglikRoute;
  "/platform/tahsilat": typeof PlatformTahsilatRoute;
  "/platform/yayinlar": typeof PlatformYayinlarRoute;
  "/portal/araclar": typeof PortalAraclarRoute;
  "/portal/faturalar": typeof PortalFaturalarRoute;
  "/portal/islemler": typeof PortalIslemlerRoute;
  "/portal/talepler": typeof PortalTaleplerRoute;
  "/sira-ekrani/yikama": typeof SiraEkraniYikamaRoute;
  "/platform/": typeof PlatformIndexRoute;
  "/portal/": typeof PortalIndexRoute;
  "/ajanlar/$id": typeof AppAjanlarIdRoute;
  "/akaryakit/ayarlar": typeof AppAkaryakitAyarlarRoute;
  "/akaryakit/endeks": typeof AppAkaryakitEndeksRoute;
  "/akaryakit/fire-raporu": typeof AppAkaryakitFireRaporuRoute;
  "/akaryakit/fiyat-farki": typeof AppAkaryakitFiyatFarkiRoute;
  "/akaryakit/maliyet": typeof AppAkaryakitMaliyetRoute;
  "/akaryakit/mutabakat": typeof AppAkaryakitMutabakatRoute;
  "/akaryakit/satislar": typeof AppAkaryakitSatislarRoute;
  "/akaryakit/siparis-onerileri": typeof AppAkaryakitSiparisOnerileriRoute;
  "/akaryakit/tanklar": typeof AppAkaryakitTanklarRoute;
  "/alarmlar/$alarmId": typeof AppAlarmlarAlarmIdRoute;
  "/alarmlar/kurallar": typeof AppAlarmlarKurallarRoute;
  "/ayarlar/abonelik": typeof AppAyarlarAbonelikRoute;
  "/ayarlar/bolgeler": typeof AppAyarlarBolgelerRoute;
  "/ayarlar/destek-erisimi": typeof AppAyarlarDestekErisimiRoute;
  "/ayarlar/guvenlik": typeof AppAyarlarGuvenlikRoute;
  "/ayarlar/istasyon-devirleri": typeof AppAyarlarIstasyonDevirleriRoute;
  "/ayarlar/kullanicilar": typeof AppAyarlarKullanicilarRoute;
  "/ayarlar/profil": typeof AppAyarlarProfilRoute;
  "/ayarlar/roller": typeof AppAyarlarRollerRoute;
  "/ayarlar/sirketler": typeof AppAyarlarSirketlerRoute;
  "/bakim/ayarlar": typeof AppBakimAyarlarRoute;
  "/bakim/planlar": typeof AppBakimPlanlarRoute;
  "/bakim/raporlar": typeof AppBakimRaporlarRoute;
  "/bildirimler/tercihler": typeof AppBildirimlerTercihlerRoute;
  "/butce/$id": typeof AppButceIdRoute;
  "/butce/rapor": typeof AppButceRaporRoute;
  "/cari/acilis-aktarimi": typeof AppCariAcilisAktarimiRoute;
  "/cari/hareket-yeni": typeof AppCariHareketYeniRoute;
  "/cari/raporlar": typeof AppCariRaporlarRoute;
  "/cari/risk": typeof AppCariRiskRoute;
  "/cari/yeni": typeof AppCariYeniRoute;
  "/cek-senet/$id": typeof AppCekSenetIdRoute;
  "/cek-senet/ayarlar": typeof AppCekSenetAyarlarRoute;
  "/cek-senet/bordro-yeni": typeof AppCekSenetBordroYeniRoute;
  "/cek-senet/karneler": typeof AppCekSenetKarnelerRoute;
  "/cek-senet/raporlar": typeof AppCekSenetRaporlarRoute;
  "/cek-senet/takvim": typeof AppCekSenetTakvimRoute;
  "/faturalar/ayarlar": typeof AppFaturalarAyarlarRoute;
  "/faturalar/e-arsiv-talepleri": typeof AppFaturalarEArsivTalepleriRoute;
  "/faturalar/yeni": typeof AppFaturalarYeniRoute;
  "/filo/$counterpartyId": typeof AppFiloCounterpartyIdRoute;
  "/filo/arac-talepleri": typeof AppFiloAracTalepleriRoute;
  "/filo/tuketim": typeof AppFiloTuketimRoute;
  "/finans/ayarlar": typeof AppFinansAyarlarRoute;
  "/finans/dbs": typeof AppFinansDbsRoute;
  "/finans/ekstre": typeof AppFinansEkstreRoute;
  "/finans/hareket-yeni": typeof AppFinansHareketYeniRoute;
  "/finans/hareketler": typeof AppFinansHareketlerRoute;
  "/finans/krediler": typeof AppFinansKredilerRoute;
  "/finans/pos": typeof AppFinansPosRoute;
  "/finans/teminatlar": typeof AppFinansTeminatlarRoute;
  "/fiyatlar/toplu-degisiklik": typeof AppFiyatlarTopluDegisiklikRoute;
  "/giderler/tanimlar": typeof AppGiderlerTanimlarRoute;
  "/giderler/yeni": typeof AppGiderlerYeniRoute;
  "/kasa/ayarlar": typeof AppKasaAyarlarRoute;
  "/kasa/kampanyalar": typeof AppKasaKampanyalarRoute;
  "/katalog/urunler": typeof AppKatalogUrunlerRoute;
  "/kvkk/ayarlar": typeof AppKvkkAyarlarRoute;
  "/kvkk/metinler": typeof AppKvkkMetinlerRoute;
  "/kvkk/pazarlama": typeof AppKvkkPazarlamaRoute;
  "/market/ayarlar": typeof AppMarketAyarlarRoute;
  "/market/etiketler": typeof AppMarketEtiketlerRoute;
  "/market/fiyat-onerisi": typeof AppMarketFiyatOnerisiRoute;
  "/market/gun-kapanislari": typeof AppMarketGunKapanislariRoute;
  "/market/hareketler": typeof AppMarketHareketlerRoute;
  "/market/lisanslar": typeof AppMarketLisanslarRoute;
  "/market/partiler": typeof AppMarketPartilerRoute;
  "/market/raporlar": typeof AppMarketRaporlarRoute;
  "/market/siparis-onerisi": typeof AppMarketSiparisOnerisiRoute;
  "/muhasebe/araclar": typeof AppMuhasebeAraclarRoute;
  "/muhasebe/donemler": typeof AppMuhasebeDonemlerRoute;
  "/muhasebe/eslestirmeler": typeof AppMuhasebeEslestirmelerRoute;
  "/muhasebe/hesap-plani": typeof AppMuhasebeHesapPlaniRoute;
  "/muhasebe/raporlar": typeof AppMuhasebeRaporlarRoute;
  "/musteriler/$id": typeof AppMusterilerIdRoute;
  "/musteriler/yeni": typeof AppMusterilerYeniRoute;
  "/odemeler/$id": typeof AppOdemelerIdRoute;
  "/onaylar/$id": typeof AppOnaylarIdRoute;
  "/onaylar/politikalar": typeof AppOnaylarPolitikalarRoute;
  "/onaylar/vekaletler": typeof AppOnaylarVekaletlerRoute;
  "/raporlar/akaryakit": typeof AppRaporlarAkaryakitRoute;
  "/raporlar/ayarlar": typeof AppRaporlarAyarlarRoute;
  "/raporlar/finans": typeof AppRaporlarFinansRoute;
  "/raporlar/karlilik": typeof AppRaporlarKarlilikRoute;
  "/raporlar/karsilastirma": typeof AppRaporlarKarsilastirmaRoute;
  "/raporlar/zamanlanmis": typeof AppRaporlarZamanlanmisRoute;
  "/sadakat/inceleme": typeof AppSadakatIncelemeRoute;
  "/sadakat/kurallar": typeof AppSadakatKurallarRoute;
  "/sadakat/program": typeof AppSadakatProgramRoute;
  "/sadakat/raporlar": typeof AppSadakatRaporlarRoute;
  "/sadakat/seviyeler": typeof AppSadakatSeviyelerRoute;
  "/sarj/ag-aktarimlari": typeof AppSarjAgAktarimlariRoute;
  "/sarj/ayarlar": typeof AppSarjAyarlarRoute;
  "/sarj/disa-aktarim": typeof AppSarjDisaAktarimRoute;
  "/sarj/pano": typeof AppSarjPanoRoute;
  "/sarj/raporlar": typeof AppSarjRaporlarRoute;
  "/sarj/tarifeler": typeof AppSarjTarifelerRoute;
  "/uyum/turler": typeof AppUyumTurlerRoute;
  "/vardiya/ayarlar": typeof AppVardiyaAyarlarRoute;
  "/vardiya/pano": typeof AppVardiyaPanoRoute;
  "/vardiya/personel": typeof AppVardiyaPersonelRoute;
  "/vardiya/raporlar": typeof AppVardiyaRaporlarRoute;
  "/vardiya/sablonlar": typeof AppVardiyaSablonlarRoute;
  "/vardiya/z-raporlari": typeof AppVardiyaZRaporlariRoute;
  "/vergi-takvimi/kdv-ozeti": typeof AppVergiTakvimiKdvOzetiRoute;
  "/vergi-takvimi/kurallar": typeof AppVergiTakvimiKurallarRoute;
  "/yikama/ayarlar": typeof AppYikamaAyarlarRoute;
  "/yikama/calismalar": typeof AppYikamaCalismalarRoute;
  "/yikama/kimyasallar": typeof AppYikamaKimyasallarRoute;
  "/yikama/programlar": typeof AppYikamaProgramlarRoute;
  "/yikama/randevular": typeof AppYikamaRandevularRoute;
  "/yikama/raporlar": typeof AppYikamaRaporlarRoute;
  "/yikama/sira": typeof AppYikamaSiraRoute;
  "/yikama/uniteler": typeof AppYikamaUnitelerRoute;
  "/platform/faturalar/$id": typeof PlatformFaturalarIdRoute;
  "/platform/kiracilar/$id": typeof PlatformKiracilarIdRoute;
  "/ajanlar/": typeof AppAjanlarIndexRoute;
  "/alarmlar/": typeof AppAlarmlarIndexRoute;
  "/bildirimler/": typeof AppBildirimlerIndexRoute;
  "/butce/": typeof AppButceIndexRoute;
  "/cari/": typeof AppCariIndexRoute;
  "/cek-senet/": typeof AppCekSenetIndexRoute;
  "/faturalar/": typeof AppFaturalarIndexRoute;
  "/filo/": typeof AppFiloIndexRoute;
  "/finans/": typeof AppFinansIndexRoute;
  "/fiyatlar/": typeof AppFiyatlarIndexRoute;
  "/giderler/": typeof AppGiderlerIndexRoute;
  "/musteriler/": typeof AppMusterilerIndexRoute;
  "/nakit-akis/": typeof AppNakitAkisIndexRoute;
  "/odemeler/": typeof AppOdemelerIndexRoute;
  "/onaylar/": typeof AppOnaylarIndexRoute;
  "/raporlar/": typeof AppRaporlarIndexRoute;
  "/uyum/": typeof AppUyumIndexRoute;
  "/vergi-takvimi/": typeof AppVergiTakvimiIndexRoute;
  "/platform/faturalar/": typeof PlatformFaturalarIndexRoute;
  "/platform/kiracilar/": typeof PlatformKiracilarIndexRoute;
  "/akaryakit/dolumlar/$id": typeof AppAkaryakitDolumlarIdRoute;
  "/akaryakit/dolumlar/yeni": typeof AppAkaryakitDolumlarYeniRoute;
  "/akaryakit/siparisler/$id": typeof AppAkaryakitSiparislerIdRoute;
  "/akaryakit/siparisler/yeni": typeof AppAkaryakitSiparislerYeniRoute;
  "/ayarlar/istasyonlar/$stationId": typeof AppAyarlarIstasyonlarStationIdRoute;
  "/bakim/is-emirleri/$id": typeof AppBakimIsEmirleriIdRoute;
  "/cari/$id/duzenle": typeof AppCariIdDuzenleRoute;
  "/cek-senet/bordrolar/$id": typeof AppCekSenetBordrolarIdRoute;
  "/faturalar/$id/duzenle": typeof AppFaturalarIdDuzenleRoute;
  "/faturalar/gelen-kutusu/$id": typeof AppFaturalarGelenKutusuIdRoute;
  "/faturalar/irsaliyeler/$id": typeof AppFaturalarIrsaliyelerIdRoute;
  "/faturalar/irsaliyeler/yeni": typeof AppFaturalarIrsaliyelerYeniRoute;
  "/finans/bankalar/$id": typeof AppFinansBankalarIdRoute;
  "/finans/kasalar/$id": typeof AppFinansKasalarIdRoute;
  "/giderler/$id/duzenle": typeof AppGiderlerIdDuzenleRoute;
  "/kasa/satislar/$id": typeof AppKasaSatislarIdRoute;
  "/kvkk/basvurular/$id": typeof AppKvkkBasvurularIdRoute;
  "/market/eslestirme/$id": typeof AppMarketEslestirmeIdRoute;
  "/market/fireler/$id": typeof AppMarketFirelerIdRoute;
  "/market/mal-kabul/$id": typeof AppMarketMalKabulIdRoute;
  "/market/sayimlar/$id": typeof AppMarketSayimlarIdRoute;
  "/market/siparisler/$id": typeof AppMarketSiparislerIdRoute;
  "/market/stok/$productId": typeof AppMarketStokProductIdRoute;
  "/market/transferler/$id": typeof AppMarketTransferlerIdRoute;
  "/muhasebe/fisler/yeni": typeof AppMuhasebeFislerYeniRoute;
  "/sadakat/abonelikler/$id": typeof AppSadakatAboneliklerIdRoute;
  "/sadakat/kuponlar/$id": typeof AppSadakatKuponlarIdRoute;
  "/sarj/oturumlar/$id": typeof AppSarjOturumlarIdRoute;
  "/sarj/uniteler/$id": typeof AppSarjUnitelerIdRoute;
  "/uyum/belgeler/$id": typeof AppUyumBelgelerIdRoute;
  "/uyum/denetimler/$id": typeof AppUyumDenetimlerIdRoute;
  "/vardiya/gun-sonu/$id": typeof AppVardiyaGunSonuIdRoute;
  "/yikama/is-emirleri/$id": typeof AppYikamaIsEmirleriIdRoute;
  "/yikama/krediler/$id": typeof AppYikamaKredilerIdRoute;
  "/akaryakit/dolumlar/": typeof AppAkaryakitDolumlarIndexRoute;
  "/akaryakit/siparisler/": typeof AppAkaryakitSiparislerIndexRoute;
  "/ayarlar/istasyonlar/": typeof AppAyarlarIstasyonlarIndexRoute;
  "/bakim/is-emirleri/": typeof AppBakimIsEmirleriIndexRoute;
  "/bakim/varliklar/": typeof AppBakimVarliklarIndexRoute;
  "/cari/$id/": typeof AppCariIdIndexRoute;
  "/cek-senet/bordrolar/": typeof AppCekSenetBordrolarIndexRoute;
  "/faturalar/$id/": typeof AppFaturalarIdIndexRoute;
  "/faturalar/gelen-kutusu/": typeof AppFaturalarGelenKutusuIndexRoute;
  "/faturalar/irsaliyeler/": typeof AppFaturalarIrsaliyelerIndexRoute;
  "/finans/bankalar/": typeof AppFinansBankalarIndexRoute;
  "/finans/kasalar/": typeof AppFinansKasalarIndexRoute;
  "/giderler/$id/": typeof AppGiderlerIdIndexRoute;
  "/kasa/satislar/": typeof AppKasaSatislarIndexRoute;
  "/kvkk/basvurular/": typeof AppKvkkBasvurularIndexRoute;
  "/market/eslestirme/": typeof AppMarketEslestirmeIndexRoute;
  "/market/fireler/": typeof AppMarketFirelerIndexRoute;
  "/market/mal-kabul/": typeof AppMarketMalKabulIndexRoute;
  "/market/sayimlar/": typeof AppMarketSayimlarIndexRoute;
  "/market/siparisler/": typeof AppMarketSiparislerIndexRoute;
  "/market/stok/": typeof AppMarketStokIndexRoute;
  "/market/transferler/": typeof AppMarketTransferlerIndexRoute;
  "/muhasebe/fisler/": typeof AppMuhasebeFislerIndexRoute;
  "/sadakat/abonelikler/": typeof AppSadakatAboneliklerIndexRoute;
  "/sadakat/kuponlar/": typeof AppSadakatKuponlarIndexRoute;
  "/sarj/oturumlar/": typeof AppSarjOturumlarIndexRoute;
  "/sarj/uniteler/": typeof AppSarjUnitelerIndexRoute;
  "/uyum/belgeler/": typeof AppUyumBelgelerIndexRoute;
  "/uyum/denetimler/": typeof AppUyumDenetimlerIndexRoute;
  "/vardiya/gun-sonu/": typeof AppVardiyaGunSonuIndexRoute;
  "/vardiya/vardiyalar/": typeof AppVardiyaVardiyalarIndexRoute;
  "/yikama/is-emirleri/": typeof AppYikamaIsEmirleriIndexRoute;
  "/yikama/krediler/": typeof AppYikamaKredilerIndexRoute;
  "/bakim/varliklar/$kind/$id": typeof AppBakimVarliklarKindIdRoute;
  "/muhasebe/fisler/$id/duzenle": typeof AppMuhasebeFislerIdDuzenleRoute;
  "/muhasebe/fisler/$id/": typeof AppMuhasebeFislerIdIndexRoute;
  "/vardiya/vardiyalar/$id/": typeof AppVardiyaVardiyalarIdIndexRoute;
  "/vardiya/vardiyalar/$id/hesap/$memberId": typeof AppVardiyaVardiyalarIdHesapMemberIdRoute;
}
export interface FileRoutesByTo {
  "/davet": typeof DavetRoute;
  "/giris": typeof GirisRoute;
  "/parola-sifirla": typeof ParolaSifirlaRoute;
  "/parola-unuttum": typeof ParolaUnuttumRoute;
  "/sira-ekrani": typeof SiraEkraniRouteWithChildren;
  "/duyurular": typeof AppDuyurularRoute;
  "/kurulum": typeof AppKurulumRoute;
  "/dev/ui-showcase": typeof DevUiShowcaseRoute;
  "/platform/ayarlar": typeof PlatformAyarlarRoute;
  "/platform/destek": typeof PlatformDestekRoute;
  "/platform/devirler": typeof PlatformDevirlerRoute;
  "/platform/duyurular": typeof PlatformDuyurularRoute;
  "/platform/personel": typeof PlatformPersonelRoute;
  "/platform/planlar": typeof PlatformPlanlarRoute;
  "/platform/saglik": typeof PlatformSaglikRoute;
  "/platform/tahsilat": typeof PlatformTahsilatRoute;
  "/platform/yayinlar": typeof PlatformYayinlarRoute;
  "/portal/araclar": typeof PortalAraclarRoute;
  "/portal/faturalar": typeof PortalFaturalarRoute;
  "/portal/islemler": typeof PortalIslemlerRoute;
  "/portal/talepler": typeof PortalTaleplerRoute;
  "/sira-ekrani/yikama": typeof SiraEkraniYikamaRoute;
  "/": typeof AppIndexRoute;
  "/platform": typeof PlatformIndexRoute;
  "/portal": typeof PortalIndexRoute;
  "/ajanlar/$id": typeof AppAjanlarIdRoute;
  "/akaryakit/ayarlar": typeof AppAkaryakitAyarlarRoute;
  "/akaryakit/endeks": typeof AppAkaryakitEndeksRoute;
  "/akaryakit/fire-raporu": typeof AppAkaryakitFireRaporuRoute;
  "/akaryakit/fiyat-farki": typeof AppAkaryakitFiyatFarkiRoute;
  "/akaryakit/maliyet": typeof AppAkaryakitMaliyetRoute;
  "/akaryakit/mutabakat": typeof AppAkaryakitMutabakatRoute;
  "/akaryakit/satislar": typeof AppAkaryakitSatislarRoute;
  "/akaryakit/siparis-onerileri": typeof AppAkaryakitSiparisOnerileriRoute;
  "/akaryakit/tanklar": typeof AppAkaryakitTanklarRoute;
  "/alarmlar/$alarmId": typeof AppAlarmlarAlarmIdRoute;
  "/alarmlar/kurallar": typeof AppAlarmlarKurallarRoute;
  "/ayarlar/abonelik": typeof AppAyarlarAbonelikRoute;
  "/ayarlar/bolgeler": typeof AppAyarlarBolgelerRoute;
  "/ayarlar/destek-erisimi": typeof AppAyarlarDestekErisimiRoute;
  "/ayarlar/guvenlik": typeof AppAyarlarGuvenlikRoute;
  "/ayarlar/istasyon-devirleri": typeof AppAyarlarIstasyonDevirleriRoute;
  "/ayarlar/kullanicilar": typeof AppAyarlarKullanicilarRoute;
  "/ayarlar/profil": typeof AppAyarlarProfilRoute;
  "/ayarlar/roller": typeof AppAyarlarRollerRoute;
  "/ayarlar/sirketler": typeof AppAyarlarSirketlerRoute;
  "/bakim/ayarlar": typeof AppBakimAyarlarRoute;
  "/bakim/planlar": typeof AppBakimPlanlarRoute;
  "/bakim/raporlar": typeof AppBakimRaporlarRoute;
  "/bildirimler/tercihler": typeof AppBildirimlerTercihlerRoute;
  "/butce/$id": typeof AppButceIdRoute;
  "/butce/rapor": typeof AppButceRaporRoute;
  "/cari/acilis-aktarimi": typeof AppCariAcilisAktarimiRoute;
  "/cari/hareket-yeni": typeof AppCariHareketYeniRoute;
  "/cari/raporlar": typeof AppCariRaporlarRoute;
  "/cari/risk": typeof AppCariRiskRoute;
  "/cari/yeni": typeof AppCariYeniRoute;
  "/cek-senet/$id": typeof AppCekSenetIdRoute;
  "/cek-senet/ayarlar": typeof AppCekSenetAyarlarRoute;
  "/cek-senet/bordro-yeni": typeof AppCekSenetBordroYeniRoute;
  "/cek-senet/karneler": typeof AppCekSenetKarnelerRoute;
  "/cek-senet/raporlar": typeof AppCekSenetRaporlarRoute;
  "/cek-senet/takvim": typeof AppCekSenetTakvimRoute;
  "/faturalar/ayarlar": typeof AppFaturalarAyarlarRoute;
  "/faturalar/e-arsiv-talepleri": typeof AppFaturalarEArsivTalepleriRoute;
  "/faturalar/yeni": typeof AppFaturalarYeniRoute;
  "/filo/$counterpartyId": typeof AppFiloCounterpartyIdRoute;
  "/filo/arac-talepleri": typeof AppFiloAracTalepleriRoute;
  "/filo/tuketim": typeof AppFiloTuketimRoute;
  "/finans/ayarlar": typeof AppFinansAyarlarRoute;
  "/finans/dbs": typeof AppFinansDbsRoute;
  "/finans/ekstre": typeof AppFinansEkstreRoute;
  "/finans/hareket-yeni": typeof AppFinansHareketYeniRoute;
  "/finans/hareketler": typeof AppFinansHareketlerRoute;
  "/finans/krediler": typeof AppFinansKredilerRoute;
  "/finans/pos": typeof AppFinansPosRoute;
  "/finans/teminatlar": typeof AppFinansTeminatlarRoute;
  "/fiyatlar/toplu-degisiklik": typeof AppFiyatlarTopluDegisiklikRoute;
  "/giderler/tanimlar": typeof AppGiderlerTanimlarRoute;
  "/giderler/yeni": typeof AppGiderlerYeniRoute;
  "/kasa/ayarlar": typeof AppKasaAyarlarRoute;
  "/kasa/kampanyalar": typeof AppKasaKampanyalarRoute;
  "/katalog/urunler": typeof AppKatalogUrunlerRoute;
  "/kvkk/ayarlar": typeof AppKvkkAyarlarRoute;
  "/kvkk/metinler": typeof AppKvkkMetinlerRoute;
  "/kvkk/pazarlama": typeof AppKvkkPazarlamaRoute;
  "/market/ayarlar": typeof AppMarketAyarlarRoute;
  "/market/etiketler": typeof AppMarketEtiketlerRoute;
  "/market/fiyat-onerisi": typeof AppMarketFiyatOnerisiRoute;
  "/market/gun-kapanislari": typeof AppMarketGunKapanislariRoute;
  "/market/hareketler": typeof AppMarketHareketlerRoute;
  "/market/lisanslar": typeof AppMarketLisanslarRoute;
  "/market/partiler": typeof AppMarketPartilerRoute;
  "/market/raporlar": typeof AppMarketRaporlarRoute;
  "/market/siparis-onerisi": typeof AppMarketSiparisOnerisiRoute;
  "/muhasebe/araclar": typeof AppMuhasebeAraclarRoute;
  "/muhasebe/donemler": typeof AppMuhasebeDonemlerRoute;
  "/muhasebe/eslestirmeler": typeof AppMuhasebeEslestirmelerRoute;
  "/muhasebe/hesap-plani": typeof AppMuhasebeHesapPlaniRoute;
  "/muhasebe/raporlar": typeof AppMuhasebeRaporlarRoute;
  "/musteriler/$id": typeof AppMusterilerIdRoute;
  "/musteriler/yeni": typeof AppMusterilerYeniRoute;
  "/odemeler/$id": typeof AppOdemelerIdRoute;
  "/onaylar/$id": typeof AppOnaylarIdRoute;
  "/onaylar/politikalar": typeof AppOnaylarPolitikalarRoute;
  "/onaylar/vekaletler": typeof AppOnaylarVekaletlerRoute;
  "/raporlar/akaryakit": typeof AppRaporlarAkaryakitRoute;
  "/raporlar/ayarlar": typeof AppRaporlarAyarlarRoute;
  "/raporlar/finans": typeof AppRaporlarFinansRoute;
  "/raporlar/karlilik": typeof AppRaporlarKarlilikRoute;
  "/raporlar/karsilastirma": typeof AppRaporlarKarsilastirmaRoute;
  "/raporlar/zamanlanmis": typeof AppRaporlarZamanlanmisRoute;
  "/sadakat/inceleme": typeof AppSadakatIncelemeRoute;
  "/sadakat/kurallar": typeof AppSadakatKurallarRoute;
  "/sadakat/program": typeof AppSadakatProgramRoute;
  "/sadakat/raporlar": typeof AppSadakatRaporlarRoute;
  "/sadakat/seviyeler": typeof AppSadakatSeviyelerRoute;
  "/sarj/ag-aktarimlari": typeof AppSarjAgAktarimlariRoute;
  "/sarj/ayarlar": typeof AppSarjAyarlarRoute;
  "/sarj/disa-aktarim": typeof AppSarjDisaAktarimRoute;
  "/sarj/pano": typeof AppSarjPanoRoute;
  "/sarj/raporlar": typeof AppSarjRaporlarRoute;
  "/sarj/tarifeler": typeof AppSarjTarifelerRoute;
  "/uyum/turler": typeof AppUyumTurlerRoute;
  "/vardiya/ayarlar": typeof AppVardiyaAyarlarRoute;
  "/vardiya/pano": typeof AppVardiyaPanoRoute;
  "/vardiya/personel": typeof AppVardiyaPersonelRoute;
  "/vardiya/raporlar": typeof AppVardiyaRaporlarRoute;
  "/vardiya/sablonlar": typeof AppVardiyaSablonlarRoute;
  "/vardiya/z-raporlari": typeof AppVardiyaZRaporlariRoute;
  "/vergi-takvimi/kdv-ozeti": typeof AppVergiTakvimiKdvOzetiRoute;
  "/vergi-takvimi/kurallar": typeof AppVergiTakvimiKurallarRoute;
  "/yikama/ayarlar": typeof AppYikamaAyarlarRoute;
  "/yikama/calismalar": typeof AppYikamaCalismalarRoute;
  "/yikama/kimyasallar": typeof AppYikamaKimyasallarRoute;
  "/yikama/programlar": typeof AppYikamaProgramlarRoute;
  "/yikama/randevular": typeof AppYikamaRandevularRoute;
  "/yikama/raporlar": typeof AppYikamaRaporlarRoute;
  "/yikama/sira": typeof AppYikamaSiraRoute;
  "/yikama/uniteler": typeof AppYikamaUnitelerRoute;
  "/platform/faturalar/$id": typeof PlatformFaturalarIdRoute;
  "/platform/kiracilar/$id": typeof PlatformKiracilarIdRoute;
  "/ajanlar": typeof AppAjanlarIndexRoute;
  "/alarmlar": typeof AppAlarmlarIndexRoute;
  "/bildirimler": typeof AppBildirimlerIndexRoute;
  "/butce": typeof AppButceIndexRoute;
  "/cari": typeof AppCariIndexRoute;
  "/cek-senet": typeof AppCekSenetIndexRoute;
  "/faturalar": typeof AppFaturalarIndexRoute;
  "/filo": typeof AppFiloIndexRoute;
  "/finans": typeof AppFinansIndexRoute;
  "/fiyatlar": typeof AppFiyatlarIndexRoute;
  "/giderler": typeof AppGiderlerIndexRoute;
  "/musteriler": typeof AppMusterilerIndexRoute;
  "/nakit-akis": typeof AppNakitAkisIndexRoute;
  "/odemeler": typeof AppOdemelerIndexRoute;
  "/onaylar": typeof AppOnaylarIndexRoute;
  "/raporlar": typeof AppRaporlarIndexRoute;
  "/uyum": typeof AppUyumIndexRoute;
  "/vergi-takvimi": typeof AppVergiTakvimiIndexRoute;
  "/platform/faturalar": typeof PlatformFaturalarIndexRoute;
  "/platform/kiracilar": typeof PlatformKiracilarIndexRoute;
  "/akaryakit/dolumlar/$id": typeof AppAkaryakitDolumlarIdRoute;
  "/akaryakit/dolumlar/yeni": typeof AppAkaryakitDolumlarYeniRoute;
  "/akaryakit/siparisler/$id": typeof AppAkaryakitSiparislerIdRoute;
  "/akaryakit/siparisler/yeni": typeof AppAkaryakitSiparislerYeniRoute;
  "/ayarlar/istasyonlar/$stationId": typeof AppAyarlarIstasyonlarStationIdRoute;
  "/bakim/is-emirleri/$id": typeof AppBakimIsEmirleriIdRoute;
  "/cari/$id/duzenle": typeof AppCariIdDuzenleRoute;
  "/cek-senet/bordrolar/$id": typeof AppCekSenetBordrolarIdRoute;
  "/faturalar/$id/duzenle": typeof AppFaturalarIdDuzenleRoute;
  "/faturalar/gelen-kutusu/$id": typeof AppFaturalarGelenKutusuIdRoute;
  "/faturalar/irsaliyeler/$id": typeof AppFaturalarIrsaliyelerIdRoute;
  "/faturalar/irsaliyeler/yeni": typeof AppFaturalarIrsaliyelerYeniRoute;
  "/finans/bankalar/$id": typeof AppFinansBankalarIdRoute;
  "/finans/kasalar/$id": typeof AppFinansKasalarIdRoute;
  "/giderler/$id/duzenle": typeof AppGiderlerIdDuzenleRoute;
  "/kasa/satislar/$id": typeof AppKasaSatislarIdRoute;
  "/kvkk/basvurular/$id": typeof AppKvkkBasvurularIdRoute;
  "/market/eslestirme/$id": typeof AppMarketEslestirmeIdRoute;
  "/market/fireler/$id": typeof AppMarketFirelerIdRoute;
  "/market/mal-kabul/$id": typeof AppMarketMalKabulIdRoute;
  "/market/sayimlar/$id": typeof AppMarketSayimlarIdRoute;
  "/market/siparisler/$id": typeof AppMarketSiparislerIdRoute;
  "/market/stok/$productId": typeof AppMarketStokProductIdRoute;
  "/market/transferler/$id": typeof AppMarketTransferlerIdRoute;
  "/muhasebe/fisler/yeni": typeof AppMuhasebeFislerYeniRoute;
  "/sadakat/abonelikler/$id": typeof AppSadakatAboneliklerIdRoute;
  "/sadakat/kuponlar/$id": typeof AppSadakatKuponlarIdRoute;
  "/sarj/oturumlar/$id": typeof AppSarjOturumlarIdRoute;
  "/sarj/uniteler/$id": typeof AppSarjUnitelerIdRoute;
  "/uyum/belgeler/$id": typeof AppUyumBelgelerIdRoute;
  "/uyum/denetimler/$id": typeof AppUyumDenetimlerIdRoute;
  "/vardiya/gun-sonu/$id": typeof AppVardiyaGunSonuIdRoute;
  "/yikama/is-emirleri/$id": typeof AppYikamaIsEmirleriIdRoute;
  "/yikama/krediler/$id": typeof AppYikamaKredilerIdRoute;
  "/akaryakit/dolumlar": typeof AppAkaryakitDolumlarIndexRoute;
  "/akaryakit/siparisler": typeof AppAkaryakitSiparislerIndexRoute;
  "/ayarlar/istasyonlar": typeof AppAyarlarIstasyonlarIndexRoute;
  "/bakim/is-emirleri": typeof AppBakimIsEmirleriIndexRoute;
  "/bakim/varliklar": typeof AppBakimVarliklarIndexRoute;
  "/cari/$id": typeof AppCariIdIndexRoute;
  "/cek-senet/bordrolar": typeof AppCekSenetBordrolarIndexRoute;
  "/faturalar/$id": typeof AppFaturalarIdIndexRoute;
  "/faturalar/gelen-kutusu": typeof AppFaturalarGelenKutusuIndexRoute;
  "/faturalar/irsaliyeler": typeof AppFaturalarIrsaliyelerIndexRoute;
  "/finans/bankalar": typeof AppFinansBankalarIndexRoute;
  "/finans/kasalar": typeof AppFinansKasalarIndexRoute;
  "/giderler/$id": typeof AppGiderlerIdIndexRoute;
  "/kasa/satislar": typeof AppKasaSatislarIndexRoute;
  "/kvkk/basvurular": typeof AppKvkkBasvurularIndexRoute;
  "/market/eslestirme": typeof AppMarketEslestirmeIndexRoute;
  "/market/fireler": typeof AppMarketFirelerIndexRoute;
  "/market/mal-kabul": typeof AppMarketMalKabulIndexRoute;
  "/market/sayimlar": typeof AppMarketSayimlarIndexRoute;
  "/market/siparisler": typeof AppMarketSiparislerIndexRoute;
  "/market/stok": typeof AppMarketStokIndexRoute;
  "/market/transferler": typeof AppMarketTransferlerIndexRoute;
  "/muhasebe/fisler": typeof AppMuhasebeFislerIndexRoute;
  "/sadakat/abonelikler": typeof AppSadakatAboneliklerIndexRoute;
  "/sadakat/kuponlar": typeof AppSadakatKuponlarIndexRoute;
  "/sarj/oturumlar": typeof AppSarjOturumlarIndexRoute;
  "/sarj/uniteler": typeof AppSarjUnitelerIndexRoute;
  "/uyum/belgeler": typeof AppUyumBelgelerIndexRoute;
  "/uyum/denetimler": typeof AppUyumDenetimlerIndexRoute;
  "/vardiya/gun-sonu": typeof AppVardiyaGunSonuIndexRoute;
  "/vardiya/vardiyalar": typeof AppVardiyaVardiyalarIndexRoute;
  "/yikama/is-emirleri": typeof AppYikamaIsEmirleriIndexRoute;
  "/yikama/krediler": typeof AppYikamaKredilerIndexRoute;
  "/bakim/varliklar/$kind/$id": typeof AppBakimVarliklarKindIdRoute;
  "/muhasebe/fisler/$id/duzenle": typeof AppMuhasebeFislerIdDuzenleRoute;
  "/muhasebe/fisler/$id": typeof AppMuhasebeFislerIdIndexRoute;
  "/vardiya/vardiyalar/$id": typeof AppVardiyaVardiyalarIdIndexRoute;
  "/vardiya/vardiyalar/$id/hesap/$memberId": typeof AppVardiyaVardiyalarIdHesapMemberIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_app": typeof AppRouteWithChildren;
  "/davet": typeof DavetRoute;
  "/giris": typeof GirisRoute;
  "/parola-sifirla": typeof ParolaSifirlaRoute;
  "/parola-unuttum": typeof ParolaUnuttumRoute;
  "/platform": typeof PlatformRouteWithChildren;
  "/portal": typeof PortalRouteWithChildren;
  "/sira-ekrani": typeof SiraEkraniRouteWithChildren;
  "/_app/duyurular": typeof AppDuyurularRoute;
  "/_app/kurulum": typeof AppKurulumRoute;
  "/dev/ui-showcase": typeof DevUiShowcaseRoute;
  "/platform/ayarlar": typeof PlatformAyarlarRoute;
  "/platform/destek": typeof PlatformDestekRoute;
  "/platform/devirler": typeof PlatformDevirlerRoute;
  "/platform/duyurular": typeof PlatformDuyurularRoute;
  "/platform/personel": typeof PlatformPersonelRoute;
  "/platform/planlar": typeof PlatformPlanlarRoute;
  "/platform/saglik": typeof PlatformSaglikRoute;
  "/platform/tahsilat": typeof PlatformTahsilatRoute;
  "/platform/yayinlar": typeof PlatformYayinlarRoute;
  "/portal/araclar": typeof PortalAraclarRoute;
  "/portal/faturalar": typeof PortalFaturalarRoute;
  "/portal/islemler": typeof PortalIslemlerRoute;
  "/portal/talepler": typeof PortalTaleplerRoute;
  "/sira-ekrani/yikama": typeof SiraEkraniYikamaRoute;
  "/_app/": typeof AppIndexRoute;
  "/platform/": typeof PlatformIndexRoute;
  "/portal/": typeof PortalIndexRoute;
  "/_app/ajanlar/$id": typeof AppAjanlarIdRoute;
  "/_app/akaryakit/ayarlar": typeof AppAkaryakitAyarlarRoute;
  "/_app/akaryakit/endeks": typeof AppAkaryakitEndeksRoute;
  "/_app/akaryakit/fire-raporu": typeof AppAkaryakitFireRaporuRoute;
  "/_app/akaryakit/fiyat-farki": typeof AppAkaryakitFiyatFarkiRoute;
  "/_app/akaryakit/maliyet": typeof AppAkaryakitMaliyetRoute;
  "/_app/akaryakit/mutabakat": typeof AppAkaryakitMutabakatRoute;
  "/_app/akaryakit/satislar": typeof AppAkaryakitSatislarRoute;
  "/_app/akaryakit/siparis-onerileri": typeof AppAkaryakitSiparisOnerileriRoute;
  "/_app/akaryakit/tanklar": typeof AppAkaryakitTanklarRoute;
  "/_app/alarmlar/$alarmId": typeof AppAlarmlarAlarmIdRoute;
  "/_app/alarmlar/kurallar": typeof AppAlarmlarKurallarRoute;
  "/_app/ayarlar/abonelik": typeof AppAyarlarAbonelikRoute;
  "/_app/ayarlar/bolgeler": typeof AppAyarlarBolgelerRoute;
  "/_app/ayarlar/destek-erisimi": typeof AppAyarlarDestekErisimiRoute;
  "/_app/ayarlar/guvenlik": typeof AppAyarlarGuvenlikRoute;
  "/_app/ayarlar/istasyon-devirleri": typeof AppAyarlarIstasyonDevirleriRoute;
  "/_app/ayarlar/kullanicilar": typeof AppAyarlarKullanicilarRoute;
  "/_app/ayarlar/profil": typeof AppAyarlarProfilRoute;
  "/_app/ayarlar/roller": typeof AppAyarlarRollerRoute;
  "/_app/ayarlar/sirketler": typeof AppAyarlarSirketlerRoute;
  "/_app/bakim/ayarlar": typeof AppBakimAyarlarRoute;
  "/_app/bakim/planlar": typeof AppBakimPlanlarRoute;
  "/_app/bakim/raporlar": typeof AppBakimRaporlarRoute;
  "/_app/bildirimler/tercihler": typeof AppBildirimlerTercihlerRoute;
  "/_app/butce/$id": typeof AppButceIdRoute;
  "/_app/butce/rapor": typeof AppButceRaporRoute;
  "/_app/cari/acilis-aktarimi": typeof AppCariAcilisAktarimiRoute;
  "/_app/cari/hareket-yeni": typeof AppCariHareketYeniRoute;
  "/_app/cari/raporlar": typeof AppCariRaporlarRoute;
  "/_app/cari/risk": typeof AppCariRiskRoute;
  "/_app/cari/yeni": typeof AppCariYeniRoute;
  "/_app/cek-senet/$id": typeof AppCekSenetIdRoute;
  "/_app/cek-senet/ayarlar": typeof AppCekSenetAyarlarRoute;
  "/_app/cek-senet/bordro-yeni": typeof AppCekSenetBordroYeniRoute;
  "/_app/cek-senet/karneler": typeof AppCekSenetKarnelerRoute;
  "/_app/cek-senet/raporlar": typeof AppCekSenetRaporlarRoute;
  "/_app/cek-senet/takvim": typeof AppCekSenetTakvimRoute;
  "/_app/faturalar/ayarlar": typeof AppFaturalarAyarlarRoute;
  "/_app/faturalar/e-arsiv-talepleri": typeof AppFaturalarEArsivTalepleriRoute;
  "/_app/faturalar/yeni": typeof AppFaturalarYeniRoute;
  "/_app/filo/$counterpartyId": typeof AppFiloCounterpartyIdRoute;
  "/_app/filo/arac-talepleri": typeof AppFiloAracTalepleriRoute;
  "/_app/filo/tuketim": typeof AppFiloTuketimRoute;
  "/_app/finans/ayarlar": typeof AppFinansAyarlarRoute;
  "/_app/finans/dbs": typeof AppFinansDbsRoute;
  "/_app/finans/ekstre": typeof AppFinansEkstreRoute;
  "/_app/finans/hareket-yeni": typeof AppFinansHareketYeniRoute;
  "/_app/finans/hareketler": typeof AppFinansHareketlerRoute;
  "/_app/finans/krediler": typeof AppFinansKredilerRoute;
  "/_app/finans/pos": typeof AppFinansPosRoute;
  "/_app/finans/teminatlar": typeof AppFinansTeminatlarRoute;
  "/_app/fiyatlar/toplu-degisiklik": typeof AppFiyatlarTopluDegisiklikRoute;
  "/_app/giderler/tanimlar": typeof AppGiderlerTanimlarRoute;
  "/_app/giderler/yeni": typeof AppGiderlerYeniRoute;
  "/_app/kasa/ayarlar": typeof AppKasaAyarlarRoute;
  "/_app/kasa/kampanyalar": typeof AppKasaKampanyalarRoute;
  "/_app/katalog/urunler": typeof AppKatalogUrunlerRoute;
  "/_app/kvkk/ayarlar": typeof AppKvkkAyarlarRoute;
  "/_app/kvkk/metinler": typeof AppKvkkMetinlerRoute;
  "/_app/kvkk/pazarlama": typeof AppKvkkPazarlamaRoute;
  "/_app/market/ayarlar": typeof AppMarketAyarlarRoute;
  "/_app/market/etiketler": typeof AppMarketEtiketlerRoute;
  "/_app/market/fiyat-onerisi": typeof AppMarketFiyatOnerisiRoute;
  "/_app/market/gun-kapanislari": typeof AppMarketGunKapanislariRoute;
  "/_app/market/hareketler": typeof AppMarketHareketlerRoute;
  "/_app/market/lisanslar": typeof AppMarketLisanslarRoute;
  "/_app/market/partiler": typeof AppMarketPartilerRoute;
  "/_app/market/raporlar": typeof AppMarketRaporlarRoute;
  "/_app/market/siparis-onerisi": typeof AppMarketSiparisOnerisiRoute;
  "/_app/muhasebe/araclar": typeof AppMuhasebeAraclarRoute;
  "/_app/muhasebe/donemler": typeof AppMuhasebeDonemlerRoute;
  "/_app/muhasebe/eslestirmeler": typeof AppMuhasebeEslestirmelerRoute;
  "/_app/muhasebe/hesap-plani": typeof AppMuhasebeHesapPlaniRoute;
  "/_app/muhasebe/raporlar": typeof AppMuhasebeRaporlarRoute;
  "/_app/musteriler/$id": typeof AppMusterilerIdRoute;
  "/_app/musteriler/yeni": typeof AppMusterilerYeniRoute;
  "/_app/odemeler/$id": typeof AppOdemelerIdRoute;
  "/_app/onaylar/$id": typeof AppOnaylarIdRoute;
  "/_app/onaylar/politikalar": typeof AppOnaylarPolitikalarRoute;
  "/_app/onaylar/vekaletler": typeof AppOnaylarVekaletlerRoute;
  "/_app/raporlar/akaryakit": typeof AppRaporlarAkaryakitRoute;
  "/_app/raporlar/ayarlar": typeof AppRaporlarAyarlarRoute;
  "/_app/raporlar/finans": typeof AppRaporlarFinansRoute;
  "/_app/raporlar/karlilik": typeof AppRaporlarKarlilikRoute;
  "/_app/raporlar/karsilastirma": typeof AppRaporlarKarsilastirmaRoute;
  "/_app/raporlar/zamanlanmis": typeof AppRaporlarZamanlanmisRoute;
  "/_app/sadakat/inceleme": typeof AppSadakatIncelemeRoute;
  "/_app/sadakat/kurallar": typeof AppSadakatKurallarRoute;
  "/_app/sadakat/program": typeof AppSadakatProgramRoute;
  "/_app/sadakat/raporlar": typeof AppSadakatRaporlarRoute;
  "/_app/sadakat/seviyeler": typeof AppSadakatSeviyelerRoute;
  "/_app/sarj/ag-aktarimlari": typeof AppSarjAgAktarimlariRoute;
  "/_app/sarj/ayarlar": typeof AppSarjAyarlarRoute;
  "/_app/sarj/disa-aktarim": typeof AppSarjDisaAktarimRoute;
  "/_app/sarj/pano": typeof AppSarjPanoRoute;
  "/_app/sarj/raporlar": typeof AppSarjRaporlarRoute;
  "/_app/sarj/tarifeler": typeof AppSarjTarifelerRoute;
  "/_app/uyum/turler": typeof AppUyumTurlerRoute;
  "/_app/vardiya/ayarlar": typeof AppVardiyaAyarlarRoute;
  "/_app/vardiya/pano": typeof AppVardiyaPanoRoute;
  "/_app/vardiya/personel": typeof AppVardiyaPersonelRoute;
  "/_app/vardiya/raporlar": typeof AppVardiyaRaporlarRoute;
  "/_app/vardiya/sablonlar": typeof AppVardiyaSablonlarRoute;
  "/_app/vardiya/z-raporlari": typeof AppVardiyaZRaporlariRoute;
  "/_app/vergi-takvimi/kdv-ozeti": typeof AppVergiTakvimiKdvOzetiRoute;
  "/_app/vergi-takvimi/kurallar": typeof AppVergiTakvimiKurallarRoute;
  "/_app/yikama/ayarlar": typeof AppYikamaAyarlarRoute;
  "/_app/yikama/calismalar": typeof AppYikamaCalismalarRoute;
  "/_app/yikama/kimyasallar": typeof AppYikamaKimyasallarRoute;
  "/_app/yikama/programlar": typeof AppYikamaProgramlarRoute;
  "/_app/yikama/randevular": typeof AppYikamaRandevularRoute;
  "/_app/yikama/raporlar": typeof AppYikamaRaporlarRoute;
  "/_app/yikama/sira": typeof AppYikamaSiraRoute;
  "/_app/yikama/uniteler": typeof AppYikamaUnitelerRoute;
  "/platform/faturalar/$id": typeof PlatformFaturalarIdRoute;
  "/platform/kiracilar/$id": typeof PlatformKiracilarIdRoute;
  "/_app/ajanlar/": typeof AppAjanlarIndexRoute;
  "/_app/alarmlar/": typeof AppAlarmlarIndexRoute;
  "/_app/bildirimler/": typeof AppBildirimlerIndexRoute;
  "/_app/butce/": typeof AppButceIndexRoute;
  "/_app/cari/": typeof AppCariIndexRoute;
  "/_app/cek-senet/": typeof AppCekSenetIndexRoute;
  "/_app/faturalar/": typeof AppFaturalarIndexRoute;
  "/_app/filo/": typeof AppFiloIndexRoute;
  "/_app/finans/": typeof AppFinansIndexRoute;
  "/_app/fiyatlar/": typeof AppFiyatlarIndexRoute;
  "/_app/giderler/": typeof AppGiderlerIndexRoute;
  "/_app/musteriler/": typeof AppMusterilerIndexRoute;
  "/_app/nakit-akis/": typeof AppNakitAkisIndexRoute;
  "/_app/odemeler/": typeof AppOdemelerIndexRoute;
  "/_app/onaylar/": typeof AppOnaylarIndexRoute;
  "/_app/raporlar/": typeof AppRaporlarIndexRoute;
  "/_app/uyum/": typeof AppUyumIndexRoute;
  "/_app/vergi-takvimi/": typeof AppVergiTakvimiIndexRoute;
  "/platform/faturalar/": typeof PlatformFaturalarIndexRoute;
  "/platform/kiracilar/": typeof PlatformKiracilarIndexRoute;
  "/_app/akaryakit/dolumlar/$id": typeof AppAkaryakitDolumlarIdRoute;
  "/_app/akaryakit/dolumlar/yeni": typeof AppAkaryakitDolumlarYeniRoute;
  "/_app/akaryakit/siparisler/$id": typeof AppAkaryakitSiparislerIdRoute;
  "/_app/akaryakit/siparisler/yeni": typeof AppAkaryakitSiparislerYeniRoute;
  "/_app/ayarlar/istasyonlar/$stationId": typeof AppAyarlarIstasyonlarStationIdRoute;
  "/_app/bakim/is-emirleri/$id": typeof AppBakimIsEmirleriIdRoute;
  "/_app/cari/$id/duzenle": typeof AppCariIdDuzenleRoute;
  "/_app/cek-senet/bordrolar/$id": typeof AppCekSenetBordrolarIdRoute;
  "/_app/faturalar/$id/duzenle": typeof AppFaturalarIdDuzenleRoute;
  "/_app/faturalar/gelen-kutusu/$id": typeof AppFaturalarGelenKutusuIdRoute;
  "/_app/faturalar/irsaliyeler/$id": typeof AppFaturalarIrsaliyelerIdRoute;
  "/_app/faturalar/irsaliyeler/yeni": typeof AppFaturalarIrsaliyelerYeniRoute;
  "/_app/finans/bankalar/$id": typeof AppFinansBankalarIdRoute;
  "/_app/finans/kasalar/$id": typeof AppFinansKasalarIdRoute;
  "/_app/giderler/$id/duzenle": typeof AppGiderlerIdDuzenleRoute;
  "/_app/kasa/satislar/$id": typeof AppKasaSatislarIdRoute;
  "/_app/kvkk/basvurular/$id": typeof AppKvkkBasvurularIdRoute;
  "/_app/market/eslestirme/$id": typeof AppMarketEslestirmeIdRoute;
  "/_app/market/fireler/$id": typeof AppMarketFirelerIdRoute;
  "/_app/market/mal-kabul/$id": typeof AppMarketMalKabulIdRoute;
  "/_app/market/sayimlar/$id": typeof AppMarketSayimlarIdRoute;
  "/_app/market/siparisler/$id": typeof AppMarketSiparislerIdRoute;
  "/_app/market/stok/$productId": typeof AppMarketStokProductIdRoute;
  "/_app/market/transferler/$id": typeof AppMarketTransferlerIdRoute;
  "/_app/muhasebe/fisler/yeni": typeof AppMuhasebeFislerYeniRoute;
  "/_app/sadakat/abonelikler/$id": typeof AppSadakatAboneliklerIdRoute;
  "/_app/sadakat/kuponlar/$id": typeof AppSadakatKuponlarIdRoute;
  "/_app/sarj/oturumlar/$id": typeof AppSarjOturumlarIdRoute;
  "/_app/sarj/uniteler/$id": typeof AppSarjUnitelerIdRoute;
  "/_app/uyum/belgeler/$id": typeof AppUyumBelgelerIdRoute;
  "/_app/uyum/denetimler/$id": typeof AppUyumDenetimlerIdRoute;
  "/_app/vardiya/gun-sonu/$id": typeof AppVardiyaGunSonuIdRoute;
  "/_app/yikama/is-emirleri/$id": typeof AppYikamaIsEmirleriIdRoute;
  "/_app/yikama/krediler/$id": typeof AppYikamaKredilerIdRoute;
  "/_app/akaryakit/dolumlar/": typeof AppAkaryakitDolumlarIndexRoute;
  "/_app/akaryakit/siparisler/": typeof AppAkaryakitSiparislerIndexRoute;
  "/_app/ayarlar/istasyonlar/": typeof AppAyarlarIstasyonlarIndexRoute;
  "/_app/bakim/is-emirleri/": typeof AppBakimIsEmirleriIndexRoute;
  "/_app/bakim/varliklar/": typeof AppBakimVarliklarIndexRoute;
  "/_app/cari/$id/": typeof AppCariIdIndexRoute;
  "/_app/cek-senet/bordrolar/": typeof AppCekSenetBordrolarIndexRoute;
  "/_app/faturalar/$id/": typeof AppFaturalarIdIndexRoute;
  "/_app/faturalar/gelen-kutusu/": typeof AppFaturalarGelenKutusuIndexRoute;
  "/_app/faturalar/irsaliyeler/": typeof AppFaturalarIrsaliyelerIndexRoute;
  "/_app/finans/bankalar/": typeof AppFinansBankalarIndexRoute;
  "/_app/finans/kasalar/": typeof AppFinansKasalarIndexRoute;
  "/_app/giderler/$id/": typeof AppGiderlerIdIndexRoute;
  "/_app/kasa/satislar/": typeof AppKasaSatislarIndexRoute;
  "/_app/kvkk/basvurular/": typeof AppKvkkBasvurularIndexRoute;
  "/_app/market/eslestirme/": typeof AppMarketEslestirmeIndexRoute;
  "/_app/market/fireler/": typeof AppMarketFirelerIndexRoute;
  "/_app/market/mal-kabul/": typeof AppMarketMalKabulIndexRoute;
  "/_app/market/sayimlar/": typeof AppMarketSayimlarIndexRoute;
  "/_app/market/siparisler/": typeof AppMarketSiparislerIndexRoute;
  "/_app/market/stok/": typeof AppMarketStokIndexRoute;
  "/_app/market/transferler/": typeof AppMarketTransferlerIndexRoute;
  "/_app/muhasebe/fisler/": typeof AppMuhasebeFislerIndexRoute;
  "/_app/sadakat/abonelikler/": typeof AppSadakatAboneliklerIndexRoute;
  "/_app/sadakat/kuponlar/": typeof AppSadakatKuponlarIndexRoute;
  "/_app/sarj/oturumlar/": typeof AppSarjOturumlarIndexRoute;
  "/_app/sarj/uniteler/": typeof AppSarjUnitelerIndexRoute;
  "/_app/uyum/belgeler/": typeof AppUyumBelgelerIndexRoute;
  "/_app/uyum/denetimler/": typeof AppUyumDenetimlerIndexRoute;
  "/_app/vardiya/gun-sonu/": typeof AppVardiyaGunSonuIndexRoute;
  "/_app/vardiya/vardiyalar/": typeof AppVardiyaVardiyalarIndexRoute;
  "/_app/yikama/is-emirleri/": typeof AppYikamaIsEmirleriIndexRoute;
  "/_app/yikama/krediler/": typeof AppYikamaKredilerIndexRoute;
  "/_app/bakim/varliklar/$kind/$id": typeof AppBakimVarliklarKindIdRoute;
  "/_app/muhasebe/fisler/$id/duzenle": typeof AppMuhasebeFislerIdDuzenleRoute;
  "/_app/muhasebe/fisler/$id/": typeof AppMuhasebeFislerIdIndexRoute;
  "/_app/vardiya/vardiyalar/$id/": typeof AppVardiyaVardiyalarIdIndexRoute;
  "/_app/vardiya/vardiyalar/$id/hesap/$memberId": typeof AppVardiyaVardiyalarIdHesapMemberIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/davet"
    | "/giris"
    | "/parola-sifirla"
    | "/parola-unuttum"
    | "/platform"
    | "/portal"
    | "/sira-ekrani"
    | "/duyurular"
    | "/kurulum"
    | "/dev/ui-showcase"
    | "/platform/ayarlar"
    | "/platform/destek"
    | "/platform/devirler"
    | "/platform/duyurular"
    | "/platform/personel"
    | "/platform/planlar"
    | "/platform/saglik"
    | "/platform/tahsilat"
    | "/platform/yayinlar"
    | "/portal/araclar"
    | "/portal/faturalar"
    | "/portal/islemler"
    | "/portal/talepler"
    | "/sira-ekrani/yikama"
    | "/platform/"
    | "/portal/"
    | "/ajanlar/$id"
    | "/akaryakit/ayarlar"
    | "/akaryakit/endeks"
    | "/akaryakit/fire-raporu"
    | "/akaryakit/fiyat-farki"
    | "/akaryakit/maliyet"
    | "/akaryakit/mutabakat"
    | "/akaryakit/satislar"
    | "/akaryakit/siparis-onerileri"
    | "/akaryakit/tanklar"
    | "/alarmlar/$alarmId"
    | "/alarmlar/kurallar"
    | "/ayarlar/abonelik"
    | "/ayarlar/bolgeler"
    | "/ayarlar/destek-erisimi"
    | "/ayarlar/guvenlik"
    | "/ayarlar/istasyon-devirleri"
    | "/ayarlar/kullanicilar"
    | "/ayarlar/profil"
    | "/ayarlar/roller"
    | "/ayarlar/sirketler"
    | "/bakim/ayarlar"
    | "/bakim/planlar"
    | "/bakim/raporlar"
    | "/bildirimler/tercihler"
    | "/butce/$id"
    | "/butce/rapor"
    | "/cari/acilis-aktarimi"
    | "/cari/hareket-yeni"
    | "/cari/raporlar"
    | "/cari/risk"
    | "/cari/yeni"
    | "/cek-senet/$id"
    | "/cek-senet/ayarlar"
    | "/cek-senet/bordro-yeni"
    | "/cek-senet/karneler"
    | "/cek-senet/raporlar"
    | "/cek-senet/takvim"
    | "/faturalar/ayarlar"
    | "/faturalar/e-arsiv-talepleri"
    | "/faturalar/yeni"
    | "/filo/$counterpartyId"
    | "/filo/arac-talepleri"
    | "/filo/tuketim"
    | "/finans/ayarlar"
    | "/finans/dbs"
    | "/finans/ekstre"
    | "/finans/hareket-yeni"
    | "/finans/hareketler"
    | "/finans/krediler"
    | "/finans/pos"
    | "/finans/teminatlar"
    | "/fiyatlar/toplu-degisiklik"
    | "/giderler/tanimlar"
    | "/giderler/yeni"
    | "/kasa/ayarlar"
    | "/kasa/kampanyalar"
    | "/katalog/urunler"
    | "/kvkk/ayarlar"
    | "/kvkk/metinler"
    | "/kvkk/pazarlama"
    | "/market/ayarlar"
    | "/market/etiketler"
    | "/market/fiyat-onerisi"
    | "/market/gun-kapanislari"
    | "/market/hareketler"
    | "/market/lisanslar"
    | "/market/partiler"
    | "/market/raporlar"
    | "/market/siparis-onerisi"
    | "/muhasebe/araclar"
    | "/muhasebe/donemler"
    | "/muhasebe/eslestirmeler"
    | "/muhasebe/hesap-plani"
    | "/muhasebe/raporlar"
    | "/musteriler/$id"
    | "/musteriler/yeni"
    | "/odemeler/$id"
    | "/onaylar/$id"
    | "/onaylar/politikalar"
    | "/onaylar/vekaletler"
    | "/raporlar/akaryakit"
    | "/raporlar/ayarlar"
    | "/raporlar/finans"
    | "/raporlar/karlilik"
    | "/raporlar/karsilastirma"
    | "/raporlar/zamanlanmis"
    | "/sadakat/inceleme"
    | "/sadakat/kurallar"
    | "/sadakat/program"
    | "/sadakat/raporlar"
    | "/sadakat/seviyeler"
    | "/sarj/ag-aktarimlari"
    | "/sarj/ayarlar"
    | "/sarj/disa-aktarim"
    | "/sarj/pano"
    | "/sarj/raporlar"
    | "/sarj/tarifeler"
    | "/uyum/turler"
    | "/vardiya/ayarlar"
    | "/vardiya/pano"
    | "/vardiya/personel"
    | "/vardiya/raporlar"
    | "/vardiya/sablonlar"
    | "/vardiya/z-raporlari"
    | "/vergi-takvimi/kdv-ozeti"
    | "/vergi-takvimi/kurallar"
    | "/yikama/ayarlar"
    | "/yikama/calismalar"
    | "/yikama/kimyasallar"
    | "/yikama/programlar"
    | "/yikama/randevular"
    | "/yikama/raporlar"
    | "/yikama/sira"
    | "/yikama/uniteler"
    | "/platform/faturalar/$id"
    | "/platform/kiracilar/$id"
    | "/ajanlar/"
    | "/alarmlar/"
    | "/bildirimler/"
    | "/butce/"
    | "/cari/"
    | "/cek-senet/"
    | "/faturalar/"
    | "/filo/"
    | "/finans/"
    | "/fiyatlar/"
    | "/giderler/"
    | "/musteriler/"
    | "/nakit-akis/"
    | "/odemeler/"
    | "/onaylar/"
    | "/raporlar/"
    | "/uyum/"
    | "/vergi-takvimi/"
    | "/platform/faturalar/"
    | "/platform/kiracilar/"
    | "/akaryakit/dolumlar/$id"
    | "/akaryakit/dolumlar/yeni"
    | "/akaryakit/siparisler/$id"
    | "/akaryakit/siparisler/yeni"
    | "/ayarlar/istasyonlar/$stationId"
    | "/bakim/is-emirleri/$id"
    | "/cari/$id/duzenle"
    | "/cek-senet/bordrolar/$id"
    | "/faturalar/$id/duzenle"
    | "/faturalar/gelen-kutusu/$id"
    | "/faturalar/irsaliyeler/$id"
    | "/faturalar/irsaliyeler/yeni"
    | "/finans/bankalar/$id"
    | "/finans/kasalar/$id"
    | "/giderler/$id/duzenle"
    | "/kasa/satislar/$id"
    | "/kvkk/basvurular/$id"
    | "/market/eslestirme/$id"
    | "/market/fireler/$id"
    | "/market/mal-kabul/$id"
    | "/market/sayimlar/$id"
    | "/market/siparisler/$id"
    | "/market/stok/$productId"
    | "/market/transferler/$id"
    | "/muhasebe/fisler/yeni"
    | "/sadakat/abonelikler/$id"
    | "/sadakat/kuponlar/$id"
    | "/sarj/oturumlar/$id"
    | "/sarj/uniteler/$id"
    | "/uyum/belgeler/$id"
    | "/uyum/denetimler/$id"
    | "/vardiya/gun-sonu/$id"
    | "/yikama/is-emirleri/$id"
    | "/yikama/krediler/$id"
    | "/akaryakit/dolumlar/"
    | "/akaryakit/siparisler/"
    | "/ayarlar/istasyonlar/"
    | "/bakim/is-emirleri/"
    | "/bakim/varliklar/"
    | "/cari/$id/"
    | "/cek-senet/bordrolar/"
    | "/faturalar/$id/"
    | "/faturalar/gelen-kutusu/"
    | "/faturalar/irsaliyeler/"
    | "/finans/bankalar/"
    | "/finans/kasalar/"
    | "/giderler/$id/"
    | "/kasa/satislar/"
    | "/kvkk/basvurular/"
    | "/market/eslestirme/"
    | "/market/fireler/"
    | "/market/mal-kabul/"
    | "/market/sayimlar/"
    | "/market/siparisler/"
    | "/market/stok/"
    | "/market/transferler/"
    | "/muhasebe/fisler/"
    | "/sadakat/abonelikler/"
    | "/sadakat/kuponlar/"
    | "/sarj/oturumlar/"
    | "/sarj/uniteler/"
    | "/uyum/belgeler/"
    | "/uyum/denetimler/"
    | "/vardiya/gun-sonu/"
    | "/vardiya/vardiyalar/"
    | "/yikama/is-emirleri/"
    | "/yikama/krediler/"
    | "/bakim/varliklar/$kind/$id"
    | "/muhasebe/fisler/$id/duzenle"
    | "/muhasebe/fisler/$id/"
    | "/vardiya/vardiyalar/$id/"
    | "/vardiya/vardiyalar/$id/hesap/$memberId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/davet"
    | "/giris"
    | "/parola-sifirla"
    | "/parola-unuttum"
    | "/sira-ekrani"
    | "/duyurular"
    | "/kurulum"
    | "/dev/ui-showcase"
    | "/platform/ayarlar"
    | "/platform/destek"
    | "/platform/devirler"
    | "/platform/duyurular"
    | "/platform/personel"
    | "/platform/planlar"
    | "/platform/saglik"
    | "/platform/tahsilat"
    | "/platform/yayinlar"
    | "/portal/araclar"
    | "/portal/faturalar"
    | "/portal/islemler"
    | "/portal/talepler"
    | "/sira-ekrani/yikama"
    | "/"
    | "/platform"
    | "/portal"
    | "/ajanlar/$id"
    | "/akaryakit/ayarlar"
    | "/akaryakit/endeks"
    | "/akaryakit/fire-raporu"
    | "/akaryakit/fiyat-farki"
    | "/akaryakit/maliyet"
    | "/akaryakit/mutabakat"
    | "/akaryakit/satislar"
    | "/akaryakit/siparis-onerileri"
    | "/akaryakit/tanklar"
    | "/alarmlar/$alarmId"
    | "/alarmlar/kurallar"
    | "/ayarlar/abonelik"
    | "/ayarlar/bolgeler"
    | "/ayarlar/destek-erisimi"
    | "/ayarlar/guvenlik"
    | "/ayarlar/istasyon-devirleri"
    | "/ayarlar/kullanicilar"
    | "/ayarlar/profil"
    | "/ayarlar/roller"
    | "/ayarlar/sirketler"
    | "/bakim/ayarlar"
    | "/bakim/planlar"
    | "/bakim/raporlar"
    | "/bildirimler/tercihler"
    | "/butce/$id"
    | "/butce/rapor"
    | "/cari/acilis-aktarimi"
    | "/cari/hareket-yeni"
    | "/cari/raporlar"
    | "/cari/risk"
    | "/cari/yeni"
    | "/cek-senet/$id"
    | "/cek-senet/ayarlar"
    | "/cek-senet/bordro-yeni"
    | "/cek-senet/karneler"
    | "/cek-senet/raporlar"
    | "/cek-senet/takvim"
    | "/faturalar/ayarlar"
    | "/faturalar/e-arsiv-talepleri"
    | "/faturalar/yeni"
    | "/filo/$counterpartyId"
    | "/filo/arac-talepleri"
    | "/filo/tuketim"
    | "/finans/ayarlar"
    | "/finans/dbs"
    | "/finans/ekstre"
    | "/finans/hareket-yeni"
    | "/finans/hareketler"
    | "/finans/krediler"
    | "/finans/pos"
    | "/finans/teminatlar"
    | "/fiyatlar/toplu-degisiklik"
    | "/giderler/tanimlar"
    | "/giderler/yeni"
    | "/kasa/ayarlar"
    | "/kasa/kampanyalar"
    | "/katalog/urunler"
    | "/kvkk/ayarlar"
    | "/kvkk/metinler"
    | "/kvkk/pazarlama"
    | "/market/ayarlar"
    | "/market/etiketler"
    | "/market/fiyat-onerisi"
    | "/market/gun-kapanislari"
    | "/market/hareketler"
    | "/market/lisanslar"
    | "/market/partiler"
    | "/market/raporlar"
    | "/market/siparis-onerisi"
    | "/muhasebe/araclar"
    | "/muhasebe/donemler"
    | "/muhasebe/eslestirmeler"
    | "/muhasebe/hesap-plani"
    | "/muhasebe/raporlar"
    | "/musteriler/$id"
    | "/musteriler/yeni"
    | "/odemeler/$id"
    | "/onaylar/$id"
    | "/onaylar/politikalar"
    | "/onaylar/vekaletler"
    | "/raporlar/akaryakit"
    | "/raporlar/ayarlar"
    | "/raporlar/finans"
    | "/raporlar/karlilik"
    | "/raporlar/karsilastirma"
    | "/raporlar/zamanlanmis"
    | "/sadakat/inceleme"
    | "/sadakat/kurallar"
    | "/sadakat/program"
    | "/sadakat/raporlar"
    | "/sadakat/seviyeler"
    | "/sarj/ag-aktarimlari"
    | "/sarj/ayarlar"
    | "/sarj/disa-aktarim"
    | "/sarj/pano"
    | "/sarj/raporlar"
    | "/sarj/tarifeler"
    | "/uyum/turler"
    | "/vardiya/ayarlar"
    | "/vardiya/pano"
    | "/vardiya/personel"
    | "/vardiya/raporlar"
    | "/vardiya/sablonlar"
    | "/vardiya/z-raporlari"
    | "/vergi-takvimi/kdv-ozeti"
    | "/vergi-takvimi/kurallar"
    | "/yikama/ayarlar"
    | "/yikama/calismalar"
    | "/yikama/kimyasallar"
    | "/yikama/programlar"
    | "/yikama/randevular"
    | "/yikama/raporlar"
    | "/yikama/sira"
    | "/yikama/uniteler"
    | "/platform/faturalar/$id"
    | "/platform/kiracilar/$id"
    | "/ajanlar"
    | "/alarmlar"
    | "/bildirimler"
    | "/butce"
    | "/cari"
    | "/cek-senet"
    | "/faturalar"
    | "/filo"
    | "/finans"
    | "/fiyatlar"
    | "/giderler"
    | "/musteriler"
    | "/nakit-akis"
    | "/odemeler"
    | "/onaylar"
    | "/raporlar"
    | "/uyum"
    | "/vergi-takvimi"
    | "/platform/faturalar"
    | "/platform/kiracilar"
    | "/akaryakit/dolumlar/$id"
    | "/akaryakit/dolumlar/yeni"
    | "/akaryakit/siparisler/$id"
    | "/akaryakit/siparisler/yeni"
    | "/ayarlar/istasyonlar/$stationId"
    | "/bakim/is-emirleri/$id"
    | "/cari/$id/duzenle"
    | "/cek-senet/bordrolar/$id"
    | "/faturalar/$id/duzenle"
    | "/faturalar/gelen-kutusu/$id"
    | "/faturalar/irsaliyeler/$id"
    | "/faturalar/irsaliyeler/yeni"
    | "/finans/bankalar/$id"
    | "/finans/kasalar/$id"
    | "/giderler/$id/duzenle"
    | "/kasa/satislar/$id"
    | "/kvkk/basvurular/$id"
    | "/market/eslestirme/$id"
    | "/market/fireler/$id"
    | "/market/mal-kabul/$id"
    | "/market/sayimlar/$id"
    | "/market/siparisler/$id"
    | "/market/stok/$productId"
    | "/market/transferler/$id"
    | "/muhasebe/fisler/yeni"
    | "/sadakat/abonelikler/$id"
    | "/sadakat/kuponlar/$id"
    | "/sarj/oturumlar/$id"
    | "/sarj/uniteler/$id"
    | "/uyum/belgeler/$id"
    | "/uyum/denetimler/$id"
    | "/vardiya/gun-sonu/$id"
    | "/yikama/is-emirleri/$id"
    | "/yikama/krediler/$id"
    | "/akaryakit/dolumlar"
    | "/akaryakit/siparisler"
    | "/ayarlar/istasyonlar"
    | "/bakim/is-emirleri"
    | "/bakim/varliklar"
    | "/cari/$id"
    | "/cek-senet/bordrolar"
    | "/faturalar/$id"
    | "/faturalar/gelen-kutusu"
    | "/faturalar/irsaliyeler"
    | "/finans/bankalar"
    | "/finans/kasalar"
    | "/giderler/$id"
    | "/kasa/satislar"
    | "/kvkk/basvurular"
    | "/market/eslestirme"
    | "/market/fireler"
    | "/market/mal-kabul"
    | "/market/sayimlar"
    | "/market/siparisler"
    | "/market/stok"
    | "/market/transferler"
    | "/muhasebe/fisler"
    | "/sadakat/abonelikler"
    | "/sadakat/kuponlar"
    | "/sarj/oturumlar"
    | "/sarj/uniteler"
    | "/uyum/belgeler"
    | "/uyum/denetimler"
    | "/vardiya/gun-sonu"
    | "/vardiya/vardiyalar"
    | "/yikama/is-emirleri"
    | "/yikama/krediler"
    | "/bakim/varliklar/$kind/$id"
    | "/muhasebe/fisler/$id/duzenle"
    | "/muhasebe/fisler/$id"
    | "/vardiya/vardiyalar/$id"
    | "/vardiya/vardiyalar/$id/hesap/$memberId";
  id:
    | "__root__"
    | "/_app"
    | "/davet"
    | "/giris"
    | "/parola-sifirla"
    | "/parola-unuttum"
    | "/platform"
    | "/portal"
    | "/sira-ekrani"
    | "/_app/duyurular"
    | "/_app/kurulum"
    | "/dev/ui-showcase"
    | "/platform/ayarlar"
    | "/platform/destek"
    | "/platform/devirler"
    | "/platform/duyurular"
    | "/platform/personel"
    | "/platform/planlar"
    | "/platform/saglik"
    | "/platform/tahsilat"
    | "/platform/yayinlar"
    | "/portal/araclar"
    | "/portal/faturalar"
    | "/portal/islemler"
    | "/portal/talepler"
    | "/sira-ekrani/yikama"
    | "/_app/"
    | "/platform/"
    | "/portal/"
    | "/_app/ajanlar/$id"
    | "/_app/akaryakit/ayarlar"
    | "/_app/akaryakit/endeks"
    | "/_app/akaryakit/fire-raporu"
    | "/_app/akaryakit/fiyat-farki"
    | "/_app/akaryakit/maliyet"
    | "/_app/akaryakit/mutabakat"
    | "/_app/akaryakit/satislar"
    | "/_app/akaryakit/siparis-onerileri"
    | "/_app/akaryakit/tanklar"
    | "/_app/alarmlar/$alarmId"
    | "/_app/alarmlar/kurallar"
    | "/_app/ayarlar/abonelik"
    | "/_app/ayarlar/bolgeler"
    | "/_app/ayarlar/destek-erisimi"
    | "/_app/ayarlar/guvenlik"
    | "/_app/ayarlar/istasyon-devirleri"
    | "/_app/ayarlar/kullanicilar"
    | "/_app/ayarlar/profil"
    | "/_app/ayarlar/roller"
    | "/_app/ayarlar/sirketler"
    | "/_app/bakim/ayarlar"
    | "/_app/bakim/planlar"
    | "/_app/bakim/raporlar"
    | "/_app/bildirimler/tercihler"
    | "/_app/butce/$id"
    | "/_app/butce/rapor"
    | "/_app/cari/acilis-aktarimi"
    | "/_app/cari/hareket-yeni"
    | "/_app/cari/raporlar"
    | "/_app/cari/risk"
    | "/_app/cari/yeni"
    | "/_app/cek-senet/$id"
    | "/_app/cek-senet/ayarlar"
    | "/_app/cek-senet/bordro-yeni"
    | "/_app/cek-senet/karneler"
    | "/_app/cek-senet/raporlar"
    | "/_app/cek-senet/takvim"
    | "/_app/faturalar/ayarlar"
    | "/_app/faturalar/e-arsiv-talepleri"
    | "/_app/faturalar/yeni"
    | "/_app/filo/$counterpartyId"
    | "/_app/filo/arac-talepleri"
    | "/_app/filo/tuketim"
    | "/_app/finans/ayarlar"
    | "/_app/finans/dbs"
    | "/_app/finans/ekstre"
    | "/_app/finans/hareket-yeni"
    | "/_app/finans/hareketler"
    | "/_app/finans/krediler"
    | "/_app/finans/pos"
    | "/_app/finans/teminatlar"
    | "/_app/fiyatlar/toplu-degisiklik"
    | "/_app/giderler/tanimlar"
    | "/_app/giderler/yeni"
    | "/_app/kasa/ayarlar"
    | "/_app/kasa/kampanyalar"
    | "/_app/katalog/urunler"
    | "/_app/kvkk/ayarlar"
    | "/_app/kvkk/metinler"
    | "/_app/kvkk/pazarlama"
    | "/_app/market/ayarlar"
    | "/_app/market/etiketler"
    | "/_app/market/fiyat-onerisi"
    | "/_app/market/gun-kapanislari"
    | "/_app/market/hareketler"
    | "/_app/market/lisanslar"
    | "/_app/market/partiler"
    | "/_app/market/raporlar"
    | "/_app/market/siparis-onerisi"
    | "/_app/muhasebe/araclar"
    | "/_app/muhasebe/donemler"
    | "/_app/muhasebe/eslestirmeler"
    | "/_app/muhasebe/hesap-plani"
    | "/_app/muhasebe/raporlar"
    | "/_app/musteriler/$id"
    | "/_app/musteriler/yeni"
    | "/_app/odemeler/$id"
    | "/_app/onaylar/$id"
    | "/_app/onaylar/politikalar"
    | "/_app/onaylar/vekaletler"
    | "/_app/raporlar/akaryakit"
    | "/_app/raporlar/ayarlar"
    | "/_app/raporlar/finans"
    | "/_app/raporlar/karlilik"
    | "/_app/raporlar/karsilastirma"
    | "/_app/raporlar/zamanlanmis"
    | "/_app/sadakat/inceleme"
    | "/_app/sadakat/kurallar"
    | "/_app/sadakat/program"
    | "/_app/sadakat/raporlar"
    | "/_app/sadakat/seviyeler"
    | "/_app/sarj/ag-aktarimlari"
    | "/_app/sarj/ayarlar"
    | "/_app/sarj/disa-aktarim"
    | "/_app/sarj/pano"
    | "/_app/sarj/raporlar"
    | "/_app/sarj/tarifeler"
    | "/_app/uyum/turler"
    | "/_app/vardiya/ayarlar"
    | "/_app/vardiya/pano"
    | "/_app/vardiya/personel"
    | "/_app/vardiya/raporlar"
    | "/_app/vardiya/sablonlar"
    | "/_app/vardiya/z-raporlari"
    | "/_app/vergi-takvimi/kdv-ozeti"
    | "/_app/vergi-takvimi/kurallar"
    | "/_app/yikama/ayarlar"
    | "/_app/yikama/calismalar"
    | "/_app/yikama/kimyasallar"
    | "/_app/yikama/programlar"
    | "/_app/yikama/randevular"
    | "/_app/yikama/raporlar"
    | "/_app/yikama/sira"
    | "/_app/yikama/uniteler"
    | "/platform/faturalar/$id"
    | "/platform/kiracilar/$id"
    | "/_app/ajanlar/"
    | "/_app/alarmlar/"
    | "/_app/bildirimler/"
    | "/_app/butce/"
    | "/_app/cari/"
    | "/_app/cek-senet/"
    | "/_app/faturalar/"
    | "/_app/filo/"
    | "/_app/finans/"
    | "/_app/fiyatlar/"
    | "/_app/giderler/"
    | "/_app/musteriler/"
    | "/_app/nakit-akis/"
    | "/_app/odemeler/"
    | "/_app/onaylar/"
    | "/_app/raporlar/"
    | "/_app/uyum/"
    | "/_app/vergi-takvimi/"
    | "/platform/faturalar/"
    | "/platform/kiracilar/"
    | "/_app/akaryakit/dolumlar/$id"
    | "/_app/akaryakit/dolumlar/yeni"
    | "/_app/akaryakit/siparisler/$id"
    | "/_app/akaryakit/siparisler/yeni"
    | "/_app/ayarlar/istasyonlar/$stationId"
    | "/_app/bakim/is-emirleri/$id"
    | "/_app/cari/$id/duzenle"
    | "/_app/cek-senet/bordrolar/$id"
    | "/_app/faturalar/$id/duzenle"
    | "/_app/faturalar/gelen-kutusu/$id"
    | "/_app/faturalar/irsaliyeler/$id"
    | "/_app/faturalar/irsaliyeler/yeni"
    | "/_app/finans/bankalar/$id"
    | "/_app/finans/kasalar/$id"
    | "/_app/giderler/$id/duzenle"
    | "/_app/kasa/satislar/$id"
    | "/_app/kvkk/basvurular/$id"
    | "/_app/market/eslestirme/$id"
    | "/_app/market/fireler/$id"
    | "/_app/market/mal-kabul/$id"
    | "/_app/market/sayimlar/$id"
    | "/_app/market/siparisler/$id"
    | "/_app/market/stok/$productId"
    | "/_app/market/transferler/$id"
    | "/_app/muhasebe/fisler/yeni"
    | "/_app/sadakat/abonelikler/$id"
    | "/_app/sadakat/kuponlar/$id"
    | "/_app/sarj/oturumlar/$id"
    | "/_app/sarj/uniteler/$id"
    | "/_app/uyum/belgeler/$id"
    | "/_app/uyum/denetimler/$id"
    | "/_app/vardiya/gun-sonu/$id"
    | "/_app/yikama/is-emirleri/$id"
    | "/_app/yikama/krediler/$id"
    | "/_app/akaryakit/dolumlar/"
    | "/_app/akaryakit/siparisler/"
    | "/_app/ayarlar/istasyonlar/"
    | "/_app/bakim/is-emirleri/"
    | "/_app/bakim/varliklar/"
    | "/_app/cari/$id/"
    | "/_app/cek-senet/bordrolar/"
    | "/_app/faturalar/$id/"
    | "/_app/faturalar/gelen-kutusu/"
    | "/_app/faturalar/irsaliyeler/"
    | "/_app/finans/bankalar/"
    | "/_app/finans/kasalar/"
    | "/_app/giderler/$id/"
    | "/_app/kasa/satislar/"
    | "/_app/kvkk/basvurular/"
    | "/_app/market/eslestirme/"
    | "/_app/market/fireler/"
    | "/_app/market/mal-kabul/"
    | "/_app/market/sayimlar/"
    | "/_app/market/siparisler/"
    | "/_app/market/stok/"
    | "/_app/market/transferler/"
    | "/_app/muhasebe/fisler/"
    | "/_app/sadakat/abonelikler/"
    | "/_app/sadakat/kuponlar/"
    | "/_app/sarj/oturumlar/"
    | "/_app/sarj/uniteler/"
    | "/_app/uyum/belgeler/"
    | "/_app/uyum/denetimler/"
    | "/_app/vardiya/gun-sonu/"
    | "/_app/vardiya/vardiyalar/"
    | "/_app/yikama/is-emirleri/"
    | "/_app/yikama/krediler/"
    | "/_app/bakim/varliklar/$kind/$id"
    | "/_app/muhasebe/fisler/$id/duzenle"
    | "/_app/muhasebe/fisler/$id/"
    | "/_app/vardiya/vardiyalar/$id/"
    | "/_app/vardiya/vardiyalar/$id/hesap/$memberId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  DavetRoute: typeof DavetRoute;
  GirisRoute: typeof GirisRoute;
  ParolaSifirlaRoute: typeof ParolaSifirlaRoute;
  ParolaUnuttumRoute: typeof ParolaUnuttumRoute;
  PlatformRoute: typeof PlatformRouteWithChildren;
  PortalRoute: typeof PortalRouteWithChildren;
  SiraEkraniRoute: typeof SiraEkraniRouteWithChildren;
  DevUiShowcaseRoute: typeof DevUiShowcaseRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/davet": {
      id: "/davet";
      path: "/davet";
      fullPath: "/davet";
      preLoaderRoute: typeof DavetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/giris": {
      id: "/giris";
      path: "/giris";
      fullPath: "/giris";
      preLoaderRoute: typeof GirisRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/parola-sifirla": {
      id: "/parola-sifirla";
      path: "/parola-sifirla";
      fullPath: "/parola-sifirla";
      preLoaderRoute: typeof ParolaSifirlaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/parola-unuttum": {
      id: "/parola-unuttum";
      path: "/parola-unuttum";
      fullPath: "/parola-unuttum";
      preLoaderRoute: typeof ParolaUnuttumRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/platform": {
      id: "/platform";
      path: "/platform";
      fullPath: "/platform";
      preLoaderRoute: typeof PlatformRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/portal": {
      id: "/portal";
      path: "/portal";
      fullPath: "/portal";
      preLoaderRoute: typeof PortalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sira-ekrani": {
      id: "/sira-ekrani";
      path: "/sira-ekrani";
      fullPath: "/sira-ekrani";
      preLoaderRoute: typeof SiraEkraniRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/": {
      id: "/_app/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/duyurular": {
      id: "/_app/duyurular";
      path: "/duyurular";
      fullPath: "/duyurular";
      preLoaderRoute: typeof AppDuyurularRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kurulum": {
      id: "/_app/kurulum";
      path: "/kurulum";
      fullPath: "/kurulum";
      preLoaderRoute: typeof AppKurulumRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/dev/ui-showcase": {
      id: "/dev/ui-showcase";
      path: "/dev/ui-showcase";
      fullPath: "/dev/ui-showcase";
      preLoaderRoute: typeof DevUiShowcaseRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/platform/": {
      id: "/platform/";
      path: "/";
      fullPath: "/platform/";
      preLoaderRoute: typeof PlatformIndexRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/ayarlar": {
      id: "/platform/ayarlar";
      path: "/ayarlar";
      fullPath: "/platform/ayarlar";
      preLoaderRoute: typeof PlatformAyarlarRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/destek": {
      id: "/platform/destek";
      path: "/destek";
      fullPath: "/platform/destek";
      preLoaderRoute: typeof PlatformDestekRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/devirler": {
      id: "/platform/devirler";
      path: "/devirler";
      fullPath: "/platform/devirler";
      preLoaderRoute: typeof PlatformDevirlerRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/duyurular": {
      id: "/platform/duyurular";
      path: "/duyurular";
      fullPath: "/platform/duyurular";
      preLoaderRoute: typeof PlatformDuyurularRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/personel": {
      id: "/platform/personel";
      path: "/personel";
      fullPath: "/platform/personel";
      preLoaderRoute: typeof PlatformPersonelRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/planlar": {
      id: "/platform/planlar";
      path: "/planlar";
      fullPath: "/platform/planlar";
      preLoaderRoute: typeof PlatformPlanlarRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/saglik": {
      id: "/platform/saglik";
      path: "/saglik";
      fullPath: "/platform/saglik";
      preLoaderRoute: typeof PlatformSaglikRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/tahsilat": {
      id: "/platform/tahsilat";
      path: "/tahsilat";
      fullPath: "/platform/tahsilat";
      preLoaderRoute: typeof PlatformTahsilatRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/yayinlar": {
      id: "/platform/yayinlar";
      path: "/yayinlar";
      fullPath: "/platform/yayinlar";
      preLoaderRoute: typeof PlatformYayinlarRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/portal/": {
      id: "/portal/";
      path: "/";
      fullPath: "/portal/";
      preLoaderRoute: typeof PortalIndexRouteImport;
      parentRoute: typeof PortalRoute;
    };
    "/portal/araclar": {
      id: "/portal/araclar";
      path: "/araclar";
      fullPath: "/portal/araclar";
      preLoaderRoute: typeof PortalAraclarRouteImport;
      parentRoute: typeof PortalRoute;
    };
    "/portal/faturalar": {
      id: "/portal/faturalar";
      path: "/faturalar";
      fullPath: "/portal/faturalar";
      preLoaderRoute: typeof PortalFaturalarRouteImport;
      parentRoute: typeof PortalRoute;
    };
    "/portal/islemler": {
      id: "/portal/islemler";
      path: "/islemler";
      fullPath: "/portal/islemler";
      preLoaderRoute: typeof PortalIslemlerRouteImport;
      parentRoute: typeof PortalRoute;
    };
    "/portal/talepler": {
      id: "/portal/talepler";
      path: "/talepler";
      fullPath: "/portal/talepler";
      preLoaderRoute: typeof PortalTaleplerRouteImport;
      parentRoute: typeof PortalRoute;
    };
    "/sira-ekrani/yikama": {
      id: "/sira-ekrani/yikama";
      path: "/yikama";
      fullPath: "/sira-ekrani/yikama";
      preLoaderRoute: typeof SiraEkraniYikamaRouteImport;
      parentRoute: typeof SiraEkraniRoute;
    };
    "/_app/ajanlar/": {
      id: "/_app/ajanlar/";
      path: "/ajanlar";
      fullPath: "/ajanlar/";
      preLoaderRoute: typeof AppAjanlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ajanlar/$id": {
      id: "/_app/ajanlar/$id";
      path: "/ajanlar/$id";
      fullPath: "/ajanlar/$id";
      preLoaderRoute: typeof AppAjanlarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/ayarlar": {
      id: "/_app/akaryakit/ayarlar";
      path: "/akaryakit/ayarlar";
      fullPath: "/akaryakit/ayarlar";
      preLoaderRoute: typeof AppAkaryakitAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/endeks": {
      id: "/_app/akaryakit/endeks";
      path: "/akaryakit/endeks";
      fullPath: "/akaryakit/endeks";
      preLoaderRoute: typeof AppAkaryakitEndeksRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/fire-raporu": {
      id: "/_app/akaryakit/fire-raporu";
      path: "/akaryakit/fire-raporu";
      fullPath: "/akaryakit/fire-raporu";
      preLoaderRoute: typeof AppAkaryakitFireRaporuRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/fiyat-farki": {
      id: "/_app/akaryakit/fiyat-farki";
      path: "/akaryakit/fiyat-farki";
      fullPath: "/akaryakit/fiyat-farki";
      preLoaderRoute: typeof AppAkaryakitFiyatFarkiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/maliyet": {
      id: "/_app/akaryakit/maliyet";
      path: "/akaryakit/maliyet";
      fullPath: "/akaryakit/maliyet";
      preLoaderRoute: typeof AppAkaryakitMaliyetRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/mutabakat": {
      id: "/_app/akaryakit/mutabakat";
      path: "/akaryakit/mutabakat";
      fullPath: "/akaryakit/mutabakat";
      preLoaderRoute: typeof AppAkaryakitMutabakatRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/satislar": {
      id: "/_app/akaryakit/satislar";
      path: "/akaryakit/satislar";
      fullPath: "/akaryakit/satislar";
      preLoaderRoute: typeof AppAkaryakitSatislarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/siparis-onerileri": {
      id: "/_app/akaryakit/siparis-onerileri";
      path: "/akaryakit/siparis-onerileri";
      fullPath: "/akaryakit/siparis-onerileri";
      preLoaderRoute: typeof AppAkaryakitSiparisOnerileriRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/tanklar": {
      id: "/_app/akaryakit/tanklar";
      path: "/akaryakit/tanklar";
      fullPath: "/akaryakit/tanklar";
      preLoaderRoute: typeof AppAkaryakitTanklarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/alarmlar/": {
      id: "/_app/alarmlar/";
      path: "/alarmlar";
      fullPath: "/alarmlar/";
      preLoaderRoute: typeof AppAlarmlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/alarmlar/$alarmId": {
      id: "/_app/alarmlar/$alarmId";
      path: "/alarmlar/$alarmId";
      fullPath: "/alarmlar/$alarmId";
      preLoaderRoute: typeof AppAlarmlarAlarmIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/alarmlar/kurallar": {
      id: "/_app/alarmlar/kurallar";
      path: "/alarmlar/kurallar";
      fullPath: "/alarmlar/kurallar";
      preLoaderRoute: typeof AppAlarmlarKurallarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/abonelik": {
      id: "/_app/ayarlar/abonelik";
      path: "/ayarlar/abonelik";
      fullPath: "/ayarlar/abonelik";
      preLoaderRoute: typeof AppAyarlarAbonelikRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/bolgeler": {
      id: "/_app/ayarlar/bolgeler";
      path: "/ayarlar/bolgeler";
      fullPath: "/ayarlar/bolgeler";
      preLoaderRoute: typeof AppAyarlarBolgelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/destek-erisimi": {
      id: "/_app/ayarlar/destek-erisimi";
      path: "/ayarlar/destek-erisimi";
      fullPath: "/ayarlar/destek-erisimi";
      preLoaderRoute: typeof AppAyarlarDestekErisimiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/guvenlik": {
      id: "/_app/ayarlar/guvenlik";
      path: "/ayarlar/guvenlik";
      fullPath: "/ayarlar/guvenlik";
      preLoaderRoute: typeof AppAyarlarGuvenlikRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/istasyon-devirleri": {
      id: "/_app/ayarlar/istasyon-devirleri";
      path: "/ayarlar/istasyon-devirleri";
      fullPath: "/ayarlar/istasyon-devirleri";
      preLoaderRoute: typeof AppAyarlarIstasyonDevirleriRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/kullanicilar": {
      id: "/_app/ayarlar/kullanicilar";
      path: "/ayarlar/kullanicilar";
      fullPath: "/ayarlar/kullanicilar";
      preLoaderRoute: typeof AppAyarlarKullanicilarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/profil": {
      id: "/_app/ayarlar/profil";
      path: "/ayarlar/profil";
      fullPath: "/ayarlar/profil";
      preLoaderRoute: typeof AppAyarlarProfilRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/roller": {
      id: "/_app/ayarlar/roller";
      path: "/ayarlar/roller";
      fullPath: "/ayarlar/roller";
      preLoaderRoute: typeof AppAyarlarRollerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/sirketler": {
      id: "/_app/ayarlar/sirketler";
      path: "/ayarlar/sirketler";
      fullPath: "/ayarlar/sirketler";
      preLoaderRoute: typeof AppAyarlarSirketlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/ayarlar": {
      id: "/_app/bakim/ayarlar";
      path: "/bakim/ayarlar";
      fullPath: "/bakim/ayarlar";
      preLoaderRoute: typeof AppBakimAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/planlar": {
      id: "/_app/bakim/planlar";
      path: "/bakim/planlar";
      fullPath: "/bakim/planlar";
      preLoaderRoute: typeof AppBakimPlanlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/raporlar": {
      id: "/_app/bakim/raporlar";
      path: "/bakim/raporlar";
      fullPath: "/bakim/raporlar";
      preLoaderRoute: typeof AppBakimRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bildirimler/": {
      id: "/_app/bildirimler/";
      path: "/bildirimler";
      fullPath: "/bildirimler/";
      preLoaderRoute: typeof AppBildirimlerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bildirimler/tercihler": {
      id: "/_app/bildirimler/tercihler";
      path: "/bildirimler/tercihler";
      fullPath: "/bildirimler/tercihler";
      preLoaderRoute: typeof AppBildirimlerTercihlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/butce/": {
      id: "/_app/butce/";
      path: "/butce";
      fullPath: "/butce/";
      preLoaderRoute: typeof AppButceIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/butce/$id": {
      id: "/_app/butce/$id";
      path: "/butce/$id";
      fullPath: "/butce/$id";
      preLoaderRoute: typeof AppButceIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/butce/rapor": {
      id: "/_app/butce/rapor";
      path: "/butce/rapor";
      fullPath: "/butce/rapor";
      preLoaderRoute: typeof AppButceRaporRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/": {
      id: "/_app/cari/";
      path: "/cari";
      fullPath: "/cari/";
      preLoaderRoute: typeof AppCariIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/acilis-aktarimi": {
      id: "/_app/cari/acilis-aktarimi";
      path: "/cari/acilis-aktarimi";
      fullPath: "/cari/acilis-aktarimi";
      preLoaderRoute: typeof AppCariAcilisAktarimiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/hareket-yeni": {
      id: "/_app/cari/hareket-yeni";
      path: "/cari/hareket-yeni";
      fullPath: "/cari/hareket-yeni";
      preLoaderRoute: typeof AppCariHareketYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/raporlar": {
      id: "/_app/cari/raporlar";
      path: "/cari/raporlar";
      fullPath: "/cari/raporlar";
      preLoaderRoute: typeof AppCariRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/risk": {
      id: "/_app/cari/risk";
      path: "/cari/risk";
      fullPath: "/cari/risk";
      preLoaderRoute: typeof AppCariRiskRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/yeni": {
      id: "/_app/cari/yeni";
      path: "/cari/yeni";
      fullPath: "/cari/yeni";
      preLoaderRoute: typeof AppCariYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/": {
      id: "/_app/cek-senet/";
      path: "/cek-senet";
      fullPath: "/cek-senet/";
      preLoaderRoute: typeof AppCekSenetIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/$id": {
      id: "/_app/cek-senet/$id";
      path: "/cek-senet/$id";
      fullPath: "/cek-senet/$id";
      preLoaderRoute: typeof AppCekSenetIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/ayarlar": {
      id: "/_app/cek-senet/ayarlar";
      path: "/cek-senet/ayarlar";
      fullPath: "/cek-senet/ayarlar";
      preLoaderRoute: typeof AppCekSenetAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/bordro-yeni": {
      id: "/_app/cek-senet/bordro-yeni";
      path: "/cek-senet/bordro-yeni";
      fullPath: "/cek-senet/bordro-yeni";
      preLoaderRoute: typeof AppCekSenetBordroYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/karneler": {
      id: "/_app/cek-senet/karneler";
      path: "/cek-senet/karneler";
      fullPath: "/cek-senet/karneler";
      preLoaderRoute: typeof AppCekSenetKarnelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/raporlar": {
      id: "/_app/cek-senet/raporlar";
      path: "/cek-senet/raporlar";
      fullPath: "/cek-senet/raporlar";
      preLoaderRoute: typeof AppCekSenetRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/takvim": {
      id: "/_app/cek-senet/takvim";
      path: "/cek-senet/takvim";
      fullPath: "/cek-senet/takvim";
      preLoaderRoute: typeof AppCekSenetTakvimRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/": {
      id: "/_app/faturalar/";
      path: "/faturalar";
      fullPath: "/faturalar/";
      preLoaderRoute: typeof AppFaturalarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/ayarlar": {
      id: "/_app/faturalar/ayarlar";
      path: "/faturalar/ayarlar";
      fullPath: "/faturalar/ayarlar";
      preLoaderRoute: typeof AppFaturalarAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/e-arsiv-talepleri": {
      id: "/_app/faturalar/e-arsiv-talepleri";
      path: "/faturalar/e-arsiv-talepleri";
      fullPath: "/faturalar/e-arsiv-talepleri";
      preLoaderRoute: typeof AppFaturalarEArsivTalepleriRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/yeni": {
      id: "/_app/faturalar/yeni";
      path: "/faturalar/yeni";
      fullPath: "/faturalar/yeni";
      preLoaderRoute: typeof AppFaturalarYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/filo/": {
      id: "/_app/filo/";
      path: "/filo";
      fullPath: "/filo/";
      preLoaderRoute: typeof AppFiloIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/filo/$counterpartyId": {
      id: "/_app/filo/$counterpartyId";
      path: "/filo/$counterpartyId";
      fullPath: "/filo/$counterpartyId";
      preLoaderRoute: typeof AppFiloCounterpartyIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/filo/arac-talepleri": {
      id: "/_app/filo/arac-talepleri";
      path: "/filo/arac-talepleri";
      fullPath: "/filo/arac-talepleri";
      preLoaderRoute: typeof AppFiloAracTalepleriRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/filo/tuketim": {
      id: "/_app/filo/tuketim";
      path: "/filo/tuketim";
      fullPath: "/filo/tuketim";
      preLoaderRoute: typeof AppFiloTuketimRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/": {
      id: "/_app/finans/";
      path: "/finans";
      fullPath: "/finans/";
      preLoaderRoute: typeof AppFinansIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/ayarlar": {
      id: "/_app/finans/ayarlar";
      path: "/finans/ayarlar";
      fullPath: "/finans/ayarlar";
      preLoaderRoute: typeof AppFinansAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/dbs": {
      id: "/_app/finans/dbs";
      path: "/finans/dbs";
      fullPath: "/finans/dbs";
      preLoaderRoute: typeof AppFinansDbsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/ekstre": {
      id: "/_app/finans/ekstre";
      path: "/finans/ekstre";
      fullPath: "/finans/ekstre";
      preLoaderRoute: typeof AppFinansEkstreRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/hareket-yeni": {
      id: "/_app/finans/hareket-yeni";
      path: "/finans/hareket-yeni";
      fullPath: "/finans/hareket-yeni";
      preLoaderRoute: typeof AppFinansHareketYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/hareketler": {
      id: "/_app/finans/hareketler";
      path: "/finans/hareketler";
      fullPath: "/finans/hareketler";
      preLoaderRoute: typeof AppFinansHareketlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/krediler": {
      id: "/_app/finans/krediler";
      path: "/finans/krediler";
      fullPath: "/finans/krediler";
      preLoaderRoute: typeof AppFinansKredilerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/pos": {
      id: "/_app/finans/pos";
      path: "/finans/pos";
      fullPath: "/finans/pos";
      preLoaderRoute: typeof AppFinansPosRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/teminatlar": {
      id: "/_app/finans/teminatlar";
      path: "/finans/teminatlar";
      fullPath: "/finans/teminatlar";
      preLoaderRoute: typeof AppFinansTeminatlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/fiyatlar/": {
      id: "/_app/fiyatlar/";
      path: "/fiyatlar";
      fullPath: "/fiyatlar/";
      preLoaderRoute: typeof AppFiyatlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/fiyatlar/toplu-degisiklik": {
      id: "/_app/fiyatlar/toplu-degisiklik";
      path: "/fiyatlar/toplu-degisiklik";
      fullPath: "/fiyatlar/toplu-degisiklik";
      preLoaderRoute: typeof AppFiyatlarTopluDegisiklikRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/giderler/": {
      id: "/_app/giderler/";
      path: "/giderler";
      fullPath: "/giderler/";
      preLoaderRoute: typeof AppGiderlerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/giderler/tanimlar": {
      id: "/_app/giderler/tanimlar";
      path: "/giderler/tanimlar";
      fullPath: "/giderler/tanimlar";
      preLoaderRoute: typeof AppGiderlerTanimlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/giderler/yeni": {
      id: "/_app/giderler/yeni";
      path: "/giderler/yeni";
      fullPath: "/giderler/yeni";
      preLoaderRoute: typeof AppGiderlerYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kasa/ayarlar": {
      id: "/_app/kasa/ayarlar";
      path: "/kasa/ayarlar";
      fullPath: "/kasa/ayarlar";
      preLoaderRoute: typeof AppKasaAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kasa/kampanyalar": {
      id: "/_app/kasa/kampanyalar";
      path: "/kasa/kampanyalar";
      fullPath: "/kasa/kampanyalar";
      preLoaderRoute: typeof AppKasaKampanyalarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/katalog/urunler": {
      id: "/_app/katalog/urunler";
      path: "/katalog/urunler";
      fullPath: "/katalog/urunler";
      preLoaderRoute: typeof AppKatalogUrunlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kvkk/ayarlar": {
      id: "/_app/kvkk/ayarlar";
      path: "/kvkk/ayarlar";
      fullPath: "/kvkk/ayarlar";
      preLoaderRoute: typeof AppKvkkAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kvkk/metinler": {
      id: "/_app/kvkk/metinler";
      path: "/kvkk/metinler";
      fullPath: "/kvkk/metinler";
      preLoaderRoute: typeof AppKvkkMetinlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kvkk/pazarlama": {
      id: "/_app/kvkk/pazarlama";
      path: "/kvkk/pazarlama";
      fullPath: "/kvkk/pazarlama";
      preLoaderRoute: typeof AppKvkkPazarlamaRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/ayarlar": {
      id: "/_app/market/ayarlar";
      path: "/market/ayarlar";
      fullPath: "/market/ayarlar";
      preLoaderRoute: typeof AppMarketAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/etiketler": {
      id: "/_app/market/etiketler";
      path: "/market/etiketler";
      fullPath: "/market/etiketler";
      preLoaderRoute: typeof AppMarketEtiketlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/fiyat-onerisi": {
      id: "/_app/market/fiyat-onerisi";
      path: "/market/fiyat-onerisi";
      fullPath: "/market/fiyat-onerisi";
      preLoaderRoute: typeof AppMarketFiyatOnerisiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/gun-kapanislari": {
      id: "/_app/market/gun-kapanislari";
      path: "/market/gun-kapanislari";
      fullPath: "/market/gun-kapanislari";
      preLoaderRoute: typeof AppMarketGunKapanislariRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/hareketler": {
      id: "/_app/market/hareketler";
      path: "/market/hareketler";
      fullPath: "/market/hareketler";
      preLoaderRoute: typeof AppMarketHareketlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/lisanslar": {
      id: "/_app/market/lisanslar";
      path: "/market/lisanslar";
      fullPath: "/market/lisanslar";
      preLoaderRoute: typeof AppMarketLisanslarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/partiler": {
      id: "/_app/market/partiler";
      path: "/market/partiler";
      fullPath: "/market/partiler";
      preLoaderRoute: typeof AppMarketPartilerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/raporlar": {
      id: "/_app/market/raporlar";
      path: "/market/raporlar";
      fullPath: "/market/raporlar";
      preLoaderRoute: typeof AppMarketRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/siparis-onerisi": {
      id: "/_app/market/siparis-onerisi";
      path: "/market/siparis-onerisi";
      fullPath: "/market/siparis-onerisi";
      preLoaderRoute: typeof AppMarketSiparisOnerisiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/araclar": {
      id: "/_app/muhasebe/araclar";
      path: "/muhasebe/araclar";
      fullPath: "/muhasebe/araclar";
      preLoaderRoute: typeof AppMuhasebeAraclarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/donemler": {
      id: "/_app/muhasebe/donemler";
      path: "/muhasebe/donemler";
      fullPath: "/muhasebe/donemler";
      preLoaderRoute: typeof AppMuhasebeDonemlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/eslestirmeler": {
      id: "/_app/muhasebe/eslestirmeler";
      path: "/muhasebe/eslestirmeler";
      fullPath: "/muhasebe/eslestirmeler";
      preLoaderRoute: typeof AppMuhasebeEslestirmelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/hesap-plani": {
      id: "/_app/muhasebe/hesap-plani";
      path: "/muhasebe/hesap-plani";
      fullPath: "/muhasebe/hesap-plani";
      preLoaderRoute: typeof AppMuhasebeHesapPlaniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/raporlar": {
      id: "/_app/muhasebe/raporlar";
      path: "/muhasebe/raporlar";
      fullPath: "/muhasebe/raporlar";
      preLoaderRoute: typeof AppMuhasebeRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/musteriler/": {
      id: "/_app/musteriler/";
      path: "/musteriler";
      fullPath: "/musteriler/";
      preLoaderRoute: typeof AppMusterilerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/musteriler/$id": {
      id: "/_app/musteriler/$id";
      path: "/musteriler/$id";
      fullPath: "/musteriler/$id";
      preLoaderRoute: typeof AppMusterilerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/musteriler/yeni": {
      id: "/_app/musteriler/yeni";
      path: "/musteriler/yeni";
      fullPath: "/musteriler/yeni";
      preLoaderRoute: typeof AppMusterilerYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/nakit-akis/": {
      id: "/_app/nakit-akis/";
      path: "/nakit-akis";
      fullPath: "/nakit-akis/";
      preLoaderRoute: typeof AppNakitAkisIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/odemeler/": {
      id: "/_app/odemeler/";
      path: "/odemeler";
      fullPath: "/odemeler/";
      preLoaderRoute: typeof AppOdemelerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/odemeler/$id": {
      id: "/_app/odemeler/$id";
      path: "/odemeler/$id";
      fullPath: "/odemeler/$id";
      preLoaderRoute: typeof AppOdemelerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/onaylar/": {
      id: "/_app/onaylar/";
      path: "/onaylar";
      fullPath: "/onaylar/";
      preLoaderRoute: typeof AppOnaylarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/onaylar/$id": {
      id: "/_app/onaylar/$id";
      path: "/onaylar/$id";
      fullPath: "/onaylar/$id";
      preLoaderRoute: typeof AppOnaylarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/onaylar/politikalar": {
      id: "/_app/onaylar/politikalar";
      path: "/onaylar/politikalar";
      fullPath: "/onaylar/politikalar";
      preLoaderRoute: typeof AppOnaylarPolitikalarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/onaylar/vekaletler": {
      id: "/_app/onaylar/vekaletler";
      path: "/onaylar/vekaletler";
      fullPath: "/onaylar/vekaletler";
      preLoaderRoute: typeof AppOnaylarVekaletlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/": {
      id: "/_app/raporlar/";
      path: "/raporlar";
      fullPath: "/raporlar/";
      preLoaderRoute: typeof AppRaporlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/akaryakit": {
      id: "/_app/raporlar/akaryakit";
      path: "/raporlar/akaryakit";
      fullPath: "/raporlar/akaryakit";
      preLoaderRoute: typeof AppRaporlarAkaryakitRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/ayarlar": {
      id: "/_app/raporlar/ayarlar";
      path: "/raporlar/ayarlar";
      fullPath: "/raporlar/ayarlar";
      preLoaderRoute: typeof AppRaporlarAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/finans": {
      id: "/_app/raporlar/finans";
      path: "/raporlar/finans";
      fullPath: "/raporlar/finans";
      preLoaderRoute: typeof AppRaporlarFinansRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/karlilik": {
      id: "/_app/raporlar/karlilik";
      path: "/raporlar/karlilik";
      fullPath: "/raporlar/karlilik";
      preLoaderRoute: typeof AppRaporlarKarlilikRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/karsilastirma": {
      id: "/_app/raporlar/karsilastirma";
      path: "/raporlar/karsilastirma";
      fullPath: "/raporlar/karsilastirma";
      preLoaderRoute: typeof AppRaporlarKarsilastirmaRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/raporlar/zamanlanmis": {
      id: "/_app/raporlar/zamanlanmis";
      path: "/raporlar/zamanlanmis";
      fullPath: "/raporlar/zamanlanmis";
      preLoaderRoute: typeof AppRaporlarZamanlanmisRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/inceleme": {
      id: "/_app/sadakat/inceleme";
      path: "/sadakat/inceleme";
      fullPath: "/sadakat/inceleme";
      preLoaderRoute: typeof AppSadakatIncelemeRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/kurallar": {
      id: "/_app/sadakat/kurallar";
      path: "/sadakat/kurallar";
      fullPath: "/sadakat/kurallar";
      preLoaderRoute: typeof AppSadakatKurallarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/program": {
      id: "/_app/sadakat/program";
      path: "/sadakat/program";
      fullPath: "/sadakat/program";
      preLoaderRoute: typeof AppSadakatProgramRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/raporlar": {
      id: "/_app/sadakat/raporlar";
      path: "/sadakat/raporlar";
      fullPath: "/sadakat/raporlar";
      preLoaderRoute: typeof AppSadakatRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/seviyeler": {
      id: "/_app/sadakat/seviyeler";
      path: "/sadakat/seviyeler";
      fullPath: "/sadakat/seviyeler";
      preLoaderRoute: typeof AppSadakatSeviyelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/ag-aktarimlari": {
      id: "/_app/sarj/ag-aktarimlari";
      path: "/sarj/ag-aktarimlari";
      fullPath: "/sarj/ag-aktarimlari";
      preLoaderRoute: typeof AppSarjAgAktarimlariRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/ayarlar": {
      id: "/_app/sarj/ayarlar";
      path: "/sarj/ayarlar";
      fullPath: "/sarj/ayarlar";
      preLoaderRoute: typeof AppSarjAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/disa-aktarim": {
      id: "/_app/sarj/disa-aktarim";
      path: "/sarj/disa-aktarim";
      fullPath: "/sarj/disa-aktarim";
      preLoaderRoute: typeof AppSarjDisaAktarimRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/pano": {
      id: "/_app/sarj/pano";
      path: "/sarj/pano";
      fullPath: "/sarj/pano";
      preLoaderRoute: typeof AppSarjPanoRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/raporlar": {
      id: "/_app/sarj/raporlar";
      path: "/sarj/raporlar";
      fullPath: "/sarj/raporlar";
      preLoaderRoute: typeof AppSarjRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/tarifeler": {
      id: "/_app/sarj/tarifeler";
      path: "/sarj/tarifeler";
      fullPath: "/sarj/tarifeler";
      preLoaderRoute: typeof AppSarjTarifelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/": {
      id: "/_app/uyum/";
      path: "/uyum";
      fullPath: "/uyum/";
      preLoaderRoute: typeof AppUyumIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/turler": {
      id: "/_app/uyum/turler";
      path: "/uyum/turler";
      fullPath: "/uyum/turler";
      preLoaderRoute: typeof AppUyumTurlerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/ayarlar": {
      id: "/_app/vardiya/ayarlar";
      path: "/vardiya/ayarlar";
      fullPath: "/vardiya/ayarlar";
      preLoaderRoute: typeof AppVardiyaAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/pano": {
      id: "/_app/vardiya/pano";
      path: "/vardiya/pano";
      fullPath: "/vardiya/pano";
      preLoaderRoute: typeof AppVardiyaPanoRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/personel": {
      id: "/_app/vardiya/personel";
      path: "/vardiya/personel";
      fullPath: "/vardiya/personel";
      preLoaderRoute: typeof AppVardiyaPersonelRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/raporlar": {
      id: "/_app/vardiya/raporlar";
      path: "/vardiya/raporlar";
      fullPath: "/vardiya/raporlar";
      preLoaderRoute: typeof AppVardiyaRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/sablonlar": {
      id: "/_app/vardiya/sablonlar";
      path: "/vardiya/sablonlar";
      fullPath: "/vardiya/sablonlar";
      preLoaderRoute: typeof AppVardiyaSablonlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/z-raporlari": {
      id: "/_app/vardiya/z-raporlari";
      path: "/vardiya/z-raporlari";
      fullPath: "/vardiya/z-raporlari";
      preLoaderRoute: typeof AppVardiyaZRaporlariRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vergi-takvimi/": {
      id: "/_app/vergi-takvimi/";
      path: "/vergi-takvimi";
      fullPath: "/vergi-takvimi/";
      preLoaderRoute: typeof AppVergiTakvimiIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vergi-takvimi/kdv-ozeti": {
      id: "/_app/vergi-takvimi/kdv-ozeti";
      path: "/vergi-takvimi/kdv-ozeti";
      fullPath: "/vergi-takvimi/kdv-ozeti";
      preLoaderRoute: typeof AppVergiTakvimiKdvOzetiRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vergi-takvimi/kurallar": {
      id: "/_app/vergi-takvimi/kurallar";
      path: "/vergi-takvimi/kurallar";
      fullPath: "/vergi-takvimi/kurallar";
      preLoaderRoute: typeof AppVergiTakvimiKurallarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/ayarlar": {
      id: "/_app/yikama/ayarlar";
      path: "/yikama/ayarlar";
      fullPath: "/yikama/ayarlar";
      preLoaderRoute: typeof AppYikamaAyarlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/calismalar": {
      id: "/_app/yikama/calismalar";
      path: "/yikama/calismalar";
      fullPath: "/yikama/calismalar";
      preLoaderRoute: typeof AppYikamaCalismalarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/kimyasallar": {
      id: "/_app/yikama/kimyasallar";
      path: "/yikama/kimyasallar";
      fullPath: "/yikama/kimyasallar";
      preLoaderRoute: typeof AppYikamaKimyasallarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/programlar": {
      id: "/_app/yikama/programlar";
      path: "/yikama/programlar";
      fullPath: "/yikama/programlar";
      preLoaderRoute: typeof AppYikamaProgramlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/randevular": {
      id: "/_app/yikama/randevular";
      path: "/yikama/randevular";
      fullPath: "/yikama/randevular";
      preLoaderRoute: typeof AppYikamaRandevularRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/raporlar": {
      id: "/_app/yikama/raporlar";
      path: "/yikama/raporlar";
      fullPath: "/yikama/raporlar";
      preLoaderRoute: typeof AppYikamaRaporlarRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/sira": {
      id: "/_app/yikama/sira";
      path: "/yikama/sira";
      fullPath: "/yikama/sira";
      preLoaderRoute: typeof AppYikamaSiraRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/uniteler": {
      id: "/_app/yikama/uniteler";
      path: "/yikama/uniteler";
      fullPath: "/yikama/uniteler";
      preLoaderRoute: typeof AppYikamaUnitelerRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/platform/faturalar/": {
      id: "/platform/faturalar/";
      path: "/faturalar";
      fullPath: "/platform/faturalar/";
      preLoaderRoute: typeof PlatformFaturalarIndexRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/faturalar/$id": {
      id: "/platform/faturalar/$id";
      path: "/faturalar/$id";
      fullPath: "/platform/faturalar/$id";
      preLoaderRoute: typeof PlatformFaturalarIdRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/kiracilar/": {
      id: "/platform/kiracilar/";
      path: "/kiracilar";
      fullPath: "/platform/kiracilar/";
      preLoaderRoute: typeof PlatformKiracilarIndexRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/platform/kiracilar/$id": {
      id: "/platform/kiracilar/$id";
      path: "/kiracilar/$id";
      fullPath: "/platform/kiracilar/$id";
      preLoaderRoute: typeof PlatformKiracilarIdRouteImport;
      parentRoute: typeof PlatformRoute;
    };
    "/_app/akaryakit/dolumlar/": {
      id: "/_app/akaryakit/dolumlar/";
      path: "/akaryakit/dolumlar";
      fullPath: "/akaryakit/dolumlar/";
      preLoaderRoute: typeof AppAkaryakitDolumlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/dolumlar/$id": {
      id: "/_app/akaryakit/dolumlar/$id";
      path: "/akaryakit/dolumlar/$id";
      fullPath: "/akaryakit/dolumlar/$id";
      preLoaderRoute: typeof AppAkaryakitDolumlarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/dolumlar/yeni": {
      id: "/_app/akaryakit/dolumlar/yeni";
      path: "/akaryakit/dolumlar/yeni";
      fullPath: "/akaryakit/dolumlar/yeni";
      preLoaderRoute: typeof AppAkaryakitDolumlarYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/siparisler/": {
      id: "/_app/akaryakit/siparisler/";
      path: "/akaryakit/siparisler";
      fullPath: "/akaryakit/siparisler/";
      preLoaderRoute: typeof AppAkaryakitSiparislerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/siparisler/$id": {
      id: "/_app/akaryakit/siparisler/$id";
      path: "/akaryakit/siparisler/$id";
      fullPath: "/akaryakit/siparisler/$id";
      preLoaderRoute: typeof AppAkaryakitSiparislerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/akaryakit/siparisler/yeni": {
      id: "/_app/akaryakit/siparisler/yeni";
      path: "/akaryakit/siparisler/yeni";
      fullPath: "/akaryakit/siparisler/yeni";
      preLoaderRoute: typeof AppAkaryakitSiparislerYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/istasyonlar/": {
      id: "/_app/ayarlar/istasyonlar/";
      path: "/ayarlar/istasyonlar";
      fullPath: "/ayarlar/istasyonlar/";
      preLoaderRoute: typeof AppAyarlarIstasyonlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/ayarlar/istasyonlar/$stationId": {
      id: "/_app/ayarlar/istasyonlar/$stationId";
      path: "/ayarlar/istasyonlar/$stationId";
      fullPath: "/ayarlar/istasyonlar/$stationId";
      preLoaderRoute: typeof AppAyarlarIstasyonlarStationIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/is-emirleri/": {
      id: "/_app/bakim/is-emirleri/";
      path: "/bakim/is-emirleri";
      fullPath: "/bakim/is-emirleri/";
      preLoaderRoute: typeof AppBakimIsEmirleriIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/is-emirleri/$id": {
      id: "/_app/bakim/is-emirleri/$id";
      path: "/bakim/is-emirleri/$id";
      fullPath: "/bakim/is-emirleri/$id";
      preLoaderRoute: typeof AppBakimIsEmirleriIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/varliklar/": {
      id: "/_app/bakim/varliklar/";
      path: "/bakim/varliklar";
      fullPath: "/bakim/varliklar/";
      preLoaderRoute: typeof AppBakimVarliklarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/$id/": {
      id: "/_app/cari/$id/";
      path: "/cari/$id";
      fullPath: "/cari/$id/";
      preLoaderRoute: typeof AppCariIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cari/$id/duzenle": {
      id: "/_app/cari/$id/duzenle";
      path: "/cari/$id/duzenle";
      fullPath: "/cari/$id/duzenle";
      preLoaderRoute: typeof AppCariIdDuzenleRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/bordrolar/": {
      id: "/_app/cek-senet/bordrolar/";
      path: "/cek-senet/bordrolar";
      fullPath: "/cek-senet/bordrolar/";
      preLoaderRoute: typeof AppCekSenetBordrolarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cek-senet/bordrolar/$id": {
      id: "/_app/cek-senet/bordrolar/$id";
      path: "/cek-senet/bordrolar/$id";
      fullPath: "/cek-senet/bordrolar/$id";
      preLoaderRoute: typeof AppCekSenetBordrolarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/$id/": {
      id: "/_app/faturalar/$id/";
      path: "/faturalar/$id";
      fullPath: "/faturalar/$id/";
      preLoaderRoute: typeof AppFaturalarIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/$id/duzenle": {
      id: "/_app/faturalar/$id/duzenle";
      path: "/faturalar/$id/duzenle";
      fullPath: "/faturalar/$id/duzenle";
      preLoaderRoute: typeof AppFaturalarIdDuzenleRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/gelen-kutusu/": {
      id: "/_app/faturalar/gelen-kutusu/";
      path: "/faturalar/gelen-kutusu";
      fullPath: "/faturalar/gelen-kutusu/";
      preLoaderRoute: typeof AppFaturalarGelenKutusuIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/gelen-kutusu/$id": {
      id: "/_app/faturalar/gelen-kutusu/$id";
      path: "/faturalar/gelen-kutusu/$id";
      fullPath: "/faturalar/gelen-kutusu/$id";
      preLoaderRoute: typeof AppFaturalarGelenKutusuIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/irsaliyeler/": {
      id: "/_app/faturalar/irsaliyeler/";
      path: "/faturalar/irsaliyeler";
      fullPath: "/faturalar/irsaliyeler/";
      preLoaderRoute: typeof AppFaturalarIrsaliyelerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/irsaliyeler/$id": {
      id: "/_app/faturalar/irsaliyeler/$id";
      path: "/faturalar/irsaliyeler/$id";
      fullPath: "/faturalar/irsaliyeler/$id";
      preLoaderRoute: typeof AppFaturalarIrsaliyelerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/faturalar/irsaliyeler/yeni": {
      id: "/_app/faturalar/irsaliyeler/yeni";
      path: "/faturalar/irsaliyeler/yeni";
      fullPath: "/faturalar/irsaliyeler/yeni";
      preLoaderRoute: typeof AppFaturalarIrsaliyelerYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/bankalar/": {
      id: "/_app/finans/bankalar/";
      path: "/finans/bankalar";
      fullPath: "/finans/bankalar/";
      preLoaderRoute: typeof AppFinansBankalarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/bankalar/$id": {
      id: "/_app/finans/bankalar/$id";
      path: "/finans/bankalar/$id";
      fullPath: "/finans/bankalar/$id";
      preLoaderRoute: typeof AppFinansBankalarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/kasalar/": {
      id: "/_app/finans/kasalar/";
      path: "/finans/kasalar";
      fullPath: "/finans/kasalar/";
      preLoaderRoute: typeof AppFinansKasalarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/finans/kasalar/$id": {
      id: "/_app/finans/kasalar/$id";
      path: "/finans/kasalar/$id";
      fullPath: "/finans/kasalar/$id";
      preLoaderRoute: typeof AppFinansKasalarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/giderler/$id/": {
      id: "/_app/giderler/$id/";
      path: "/giderler/$id";
      fullPath: "/giderler/$id/";
      preLoaderRoute: typeof AppGiderlerIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/giderler/$id/duzenle": {
      id: "/_app/giderler/$id/duzenle";
      path: "/giderler/$id/duzenle";
      fullPath: "/giderler/$id/duzenle";
      preLoaderRoute: typeof AppGiderlerIdDuzenleRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kasa/satislar/": {
      id: "/_app/kasa/satislar/";
      path: "/kasa/satislar";
      fullPath: "/kasa/satislar/";
      preLoaderRoute: typeof AppKasaSatislarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kasa/satislar/$id": {
      id: "/_app/kasa/satislar/$id";
      path: "/kasa/satislar/$id";
      fullPath: "/kasa/satislar/$id";
      preLoaderRoute: typeof AppKasaSatislarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kvkk/basvurular/": {
      id: "/_app/kvkk/basvurular/";
      path: "/kvkk/basvurular";
      fullPath: "/kvkk/basvurular/";
      preLoaderRoute: typeof AppKvkkBasvurularIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/kvkk/basvurular/$id": {
      id: "/_app/kvkk/basvurular/$id";
      path: "/kvkk/basvurular/$id";
      fullPath: "/kvkk/basvurular/$id";
      preLoaderRoute: typeof AppKvkkBasvurularIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/eslestirme/": {
      id: "/_app/market/eslestirme/";
      path: "/market/eslestirme";
      fullPath: "/market/eslestirme/";
      preLoaderRoute: typeof AppMarketEslestirmeIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/eslestirme/$id": {
      id: "/_app/market/eslestirme/$id";
      path: "/market/eslestirme/$id";
      fullPath: "/market/eslestirme/$id";
      preLoaderRoute: typeof AppMarketEslestirmeIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/fireler/": {
      id: "/_app/market/fireler/";
      path: "/market/fireler";
      fullPath: "/market/fireler/";
      preLoaderRoute: typeof AppMarketFirelerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/fireler/$id": {
      id: "/_app/market/fireler/$id";
      path: "/market/fireler/$id";
      fullPath: "/market/fireler/$id";
      preLoaderRoute: typeof AppMarketFirelerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/mal-kabul/": {
      id: "/_app/market/mal-kabul/";
      path: "/market/mal-kabul";
      fullPath: "/market/mal-kabul/";
      preLoaderRoute: typeof AppMarketMalKabulIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/mal-kabul/$id": {
      id: "/_app/market/mal-kabul/$id";
      path: "/market/mal-kabul/$id";
      fullPath: "/market/mal-kabul/$id";
      preLoaderRoute: typeof AppMarketMalKabulIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/sayimlar/": {
      id: "/_app/market/sayimlar/";
      path: "/market/sayimlar";
      fullPath: "/market/sayimlar/";
      preLoaderRoute: typeof AppMarketSayimlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/sayimlar/$id": {
      id: "/_app/market/sayimlar/$id";
      path: "/market/sayimlar/$id";
      fullPath: "/market/sayimlar/$id";
      preLoaderRoute: typeof AppMarketSayimlarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/siparisler/": {
      id: "/_app/market/siparisler/";
      path: "/market/siparisler";
      fullPath: "/market/siparisler/";
      preLoaderRoute: typeof AppMarketSiparislerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/siparisler/$id": {
      id: "/_app/market/siparisler/$id";
      path: "/market/siparisler/$id";
      fullPath: "/market/siparisler/$id";
      preLoaderRoute: typeof AppMarketSiparislerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/stok/": {
      id: "/_app/market/stok/";
      path: "/market/stok";
      fullPath: "/market/stok/";
      preLoaderRoute: typeof AppMarketStokIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/stok/$productId": {
      id: "/_app/market/stok/$productId";
      path: "/market/stok/$productId";
      fullPath: "/market/stok/$productId";
      preLoaderRoute: typeof AppMarketStokProductIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/transferler/": {
      id: "/_app/market/transferler/";
      path: "/market/transferler";
      fullPath: "/market/transferler/";
      preLoaderRoute: typeof AppMarketTransferlerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/market/transferler/$id": {
      id: "/_app/market/transferler/$id";
      path: "/market/transferler/$id";
      fullPath: "/market/transferler/$id";
      preLoaderRoute: typeof AppMarketTransferlerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/fisler/": {
      id: "/_app/muhasebe/fisler/";
      path: "/muhasebe/fisler";
      fullPath: "/muhasebe/fisler/";
      preLoaderRoute: typeof AppMuhasebeFislerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/fisler/yeni": {
      id: "/_app/muhasebe/fisler/yeni";
      path: "/muhasebe/fisler/yeni";
      fullPath: "/muhasebe/fisler/yeni";
      preLoaderRoute: typeof AppMuhasebeFislerYeniRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/abonelikler/": {
      id: "/_app/sadakat/abonelikler/";
      path: "/sadakat/abonelikler";
      fullPath: "/sadakat/abonelikler/";
      preLoaderRoute: typeof AppSadakatAboneliklerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/abonelikler/$id": {
      id: "/_app/sadakat/abonelikler/$id";
      path: "/sadakat/abonelikler/$id";
      fullPath: "/sadakat/abonelikler/$id";
      preLoaderRoute: typeof AppSadakatAboneliklerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/kuponlar/": {
      id: "/_app/sadakat/kuponlar/";
      path: "/sadakat/kuponlar";
      fullPath: "/sadakat/kuponlar/";
      preLoaderRoute: typeof AppSadakatKuponlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sadakat/kuponlar/$id": {
      id: "/_app/sadakat/kuponlar/$id";
      path: "/sadakat/kuponlar/$id";
      fullPath: "/sadakat/kuponlar/$id";
      preLoaderRoute: typeof AppSadakatKuponlarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/oturumlar/": {
      id: "/_app/sarj/oturumlar/";
      path: "/sarj/oturumlar";
      fullPath: "/sarj/oturumlar/";
      preLoaderRoute: typeof AppSarjOturumlarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/oturumlar/$id": {
      id: "/_app/sarj/oturumlar/$id";
      path: "/sarj/oturumlar/$id";
      fullPath: "/sarj/oturumlar/$id";
      preLoaderRoute: typeof AppSarjOturumlarIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/uniteler/": {
      id: "/_app/sarj/uniteler/";
      path: "/sarj/uniteler";
      fullPath: "/sarj/uniteler/";
      preLoaderRoute: typeof AppSarjUnitelerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sarj/uniteler/$id": {
      id: "/_app/sarj/uniteler/$id";
      path: "/sarj/uniteler/$id";
      fullPath: "/sarj/uniteler/$id";
      preLoaderRoute: typeof AppSarjUnitelerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/belgeler/": {
      id: "/_app/uyum/belgeler/";
      path: "/uyum/belgeler";
      fullPath: "/uyum/belgeler/";
      preLoaderRoute: typeof AppUyumBelgelerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/belgeler/$id": {
      id: "/_app/uyum/belgeler/$id";
      path: "/uyum/belgeler/$id";
      fullPath: "/uyum/belgeler/$id";
      preLoaderRoute: typeof AppUyumBelgelerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/denetimler/": {
      id: "/_app/uyum/denetimler/";
      path: "/uyum/denetimler";
      fullPath: "/uyum/denetimler/";
      preLoaderRoute: typeof AppUyumDenetimlerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/uyum/denetimler/$id": {
      id: "/_app/uyum/denetimler/$id";
      path: "/uyum/denetimler/$id";
      fullPath: "/uyum/denetimler/$id";
      preLoaderRoute: typeof AppUyumDenetimlerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/gun-sonu/": {
      id: "/_app/vardiya/gun-sonu/";
      path: "/vardiya/gun-sonu";
      fullPath: "/vardiya/gun-sonu/";
      preLoaderRoute: typeof AppVardiyaGunSonuIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/gun-sonu/$id": {
      id: "/_app/vardiya/gun-sonu/$id";
      path: "/vardiya/gun-sonu/$id";
      fullPath: "/vardiya/gun-sonu/$id";
      preLoaderRoute: typeof AppVardiyaGunSonuIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/vardiyalar/": {
      id: "/_app/vardiya/vardiyalar/";
      path: "/vardiya/vardiyalar";
      fullPath: "/vardiya/vardiyalar/";
      preLoaderRoute: typeof AppVardiyaVardiyalarIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/is-emirleri/": {
      id: "/_app/yikama/is-emirleri/";
      path: "/yikama/is-emirleri";
      fullPath: "/yikama/is-emirleri/";
      preLoaderRoute: typeof AppYikamaIsEmirleriIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/is-emirleri/$id": {
      id: "/_app/yikama/is-emirleri/$id";
      path: "/yikama/is-emirleri/$id";
      fullPath: "/yikama/is-emirleri/$id";
      preLoaderRoute: typeof AppYikamaIsEmirleriIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/krediler/": {
      id: "/_app/yikama/krediler/";
      path: "/yikama/krediler";
      fullPath: "/yikama/krediler/";
      preLoaderRoute: typeof AppYikamaKredilerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/yikama/krediler/$id": {
      id: "/_app/yikama/krediler/$id";
      path: "/yikama/krediler/$id";
      fullPath: "/yikama/krediler/$id";
      preLoaderRoute: typeof AppYikamaKredilerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/bakim/varliklar/$kind/$id": {
      id: "/_app/bakim/varliklar/$kind/$id";
      path: "/bakim/varliklar/$kind/$id";
      fullPath: "/bakim/varliklar/$kind/$id";
      preLoaderRoute: typeof AppBakimVarliklarKindIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/fisler/$id/": {
      id: "/_app/muhasebe/fisler/$id/";
      path: "/muhasebe/fisler/$id";
      fullPath: "/muhasebe/fisler/$id/";
      preLoaderRoute: typeof AppMuhasebeFislerIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/muhasebe/fisler/$id/duzenle": {
      id: "/_app/muhasebe/fisler/$id/duzenle";
      path: "/muhasebe/fisler/$id/duzenle";
      fullPath: "/muhasebe/fisler/$id/duzenle";
      preLoaderRoute: typeof AppMuhasebeFislerIdDuzenleRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/vardiyalar/$id/": {
      id: "/_app/vardiya/vardiyalar/$id/";
      path: "/vardiya/vardiyalar/$id";
      fullPath: "/vardiya/vardiyalar/$id/";
      preLoaderRoute: typeof AppVardiyaVardiyalarIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/vardiya/vardiyalar/$id/hesap/$memberId": {
      id: "/_app/vardiya/vardiyalar/$id/hesap/$memberId";
      path: "/vardiya/vardiyalar/$id/hesap/$memberId";
      fullPath: "/vardiya/vardiyalar/$id/hesap/$memberId";
      preLoaderRoute: typeof AppVardiyaVardiyalarIdHesapMemberIdRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppDuyurularRoute: typeof AppDuyurularRoute;
  AppKurulumRoute: typeof AppKurulumRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppAjanlarIdRoute: typeof AppAjanlarIdRoute;
  AppAkaryakitAyarlarRoute: typeof AppAkaryakitAyarlarRoute;
  AppAkaryakitEndeksRoute: typeof AppAkaryakitEndeksRoute;
  AppAkaryakitFireRaporuRoute: typeof AppAkaryakitFireRaporuRoute;
  AppAkaryakitFiyatFarkiRoute: typeof AppAkaryakitFiyatFarkiRoute;
  AppAkaryakitMaliyetRoute: typeof AppAkaryakitMaliyetRoute;
  AppAkaryakitMutabakatRoute: typeof AppAkaryakitMutabakatRoute;
  AppAkaryakitSatislarRoute: typeof AppAkaryakitSatislarRoute;
  AppAkaryakitSiparisOnerileriRoute: typeof AppAkaryakitSiparisOnerileriRoute;
  AppAkaryakitTanklarRoute: typeof AppAkaryakitTanklarRoute;
  AppAlarmlarAlarmIdRoute: typeof AppAlarmlarAlarmIdRoute;
  AppAlarmlarKurallarRoute: typeof AppAlarmlarKurallarRoute;
  AppAyarlarAbonelikRoute: typeof AppAyarlarAbonelikRoute;
  AppAyarlarBolgelerRoute: typeof AppAyarlarBolgelerRoute;
  AppAyarlarDestekErisimiRoute: typeof AppAyarlarDestekErisimiRoute;
  AppAyarlarGuvenlikRoute: typeof AppAyarlarGuvenlikRoute;
  AppAyarlarIstasyonDevirleriRoute: typeof AppAyarlarIstasyonDevirleriRoute;
  AppAyarlarKullanicilarRoute: typeof AppAyarlarKullanicilarRoute;
  AppAyarlarProfilRoute: typeof AppAyarlarProfilRoute;
  AppAyarlarRollerRoute: typeof AppAyarlarRollerRoute;
  AppAyarlarSirketlerRoute: typeof AppAyarlarSirketlerRoute;
  AppBakimAyarlarRoute: typeof AppBakimAyarlarRoute;
  AppBakimPlanlarRoute: typeof AppBakimPlanlarRoute;
  AppBakimRaporlarRoute: typeof AppBakimRaporlarRoute;
  AppBildirimlerTercihlerRoute: typeof AppBildirimlerTercihlerRoute;
  AppButceIdRoute: typeof AppButceIdRoute;
  AppButceRaporRoute: typeof AppButceRaporRoute;
  AppCariAcilisAktarimiRoute: typeof AppCariAcilisAktarimiRoute;
  AppCariHareketYeniRoute: typeof AppCariHareketYeniRoute;
  AppCariRaporlarRoute: typeof AppCariRaporlarRoute;
  AppCariRiskRoute: typeof AppCariRiskRoute;
  AppCariYeniRoute: typeof AppCariYeniRoute;
  AppCekSenetIdRoute: typeof AppCekSenetIdRoute;
  AppCekSenetAyarlarRoute: typeof AppCekSenetAyarlarRoute;
  AppCekSenetBordroYeniRoute: typeof AppCekSenetBordroYeniRoute;
  AppCekSenetKarnelerRoute: typeof AppCekSenetKarnelerRoute;
  AppCekSenetRaporlarRoute: typeof AppCekSenetRaporlarRoute;
  AppCekSenetTakvimRoute: typeof AppCekSenetTakvimRoute;
  AppFaturalarAyarlarRoute: typeof AppFaturalarAyarlarRoute;
  AppFaturalarEArsivTalepleriRoute: typeof AppFaturalarEArsivTalepleriRoute;
  AppFaturalarYeniRoute: typeof AppFaturalarYeniRoute;
  AppFiloCounterpartyIdRoute: typeof AppFiloCounterpartyIdRoute;
  AppFiloAracTalepleriRoute: typeof AppFiloAracTalepleriRoute;
  AppFiloTuketimRoute: typeof AppFiloTuketimRoute;
  AppFinansAyarlarRoute: typeof AppFinansAyarlarRoute;
  AppFinansDbsRoute: typeof AppFinansDbsRoute;
  AppFinansEkstreRoute: typeof AppFinansEkstreRoute;
  AppFinansHareketYeniRoute: typeof AppFinansHareketYeniRoute;
  AppFinansHareketlerRoute: typeof AppFinansHareketlerRoute;
  AppFinansKredilerRoute: typeof AppFinansKredilerRoute;
  AppFinansPosRoute: typeof AppFinansPosRoute;
  AppFinansTeminatlarRoute: typeof AppFinansTeminatlarRoute;
  AppFiyatlarTopluDegisiklikRoute: typeof AppFiyatlarTopluDegisiklikRoute;
  AppGiderlerTanimlarRoute: typeof AppGiderlerTanimlarRoute;
  AppGiderlerYeniRoute: typeof AppGiderlerYeniRoute;
  AppKasaAyarlarRoute: typeof AppKasaAyarlarRoute;
  AppKasaKampanyalarRoute: typeof AppKasaKampanyalarRoute;
  AppKatalogUrunlerRoute: typeof AppKatalogUrunlerRoute;
  AppKvkkAyarlarRoute: typeof AppKvkkAyarlarRoute;
  AppKvkkMetinlerRoute: typeof AppKvkkMetinlerRoute;
  AppKvkkPazarlamaRoute: typeof AppKvkkPazarlamaRoute;
  AppMarketAyarlarRoute: typeof AppMarketAyarlarRoute;
  AppMarketEtiketlerRoute: typeof AppMarketEtiketlerRoute;
  AppMarketFiyatOnerisiRoute: typeof AppMarketFiyatOnerisiRoute;
  AppMarketGunKapanislariRoute: typeof AppMarketGunKapanislariRoute;
  AppMarketHareketlerRoute: typeof AppMarketHareketlerRoute;
  AppMarketLisanslarRoute: typeof AppMarketLisanslarRoute;
  AppMarketPartilerRoute: typeof AppMarketPartilerRoute;
  AppMarketRaporlarRoute: typeof AppMarketRaporlarRoute;
  AppMarketSiparisOnerisiRoute: typeof AppMarketSiparisOnerisiRoute;
  AppMuhasebeAraclarRoute: typeof AppMuhasebeAraclarRoute;
  AppMuhasebeDonemlerRoute: typeof AppMuhasebeDonemlerRoute;
  AppMuhasebeEslestirmelerRoute: typeof AppMuhasebeEslestirmelerRoute;
  AppMuhasebeHesapPlaniRoute: typeof AppMuhasebeHesapPlaniRoute;
  AppMuhasebeRaporlarRoute: typeof AppMuhasebeRaporlarRoute;
  AppMusterilerIdRoute: typeof AppMusterilerIdRoute;
  AppMusterilerYeniRoute: typeof AppMusterilerYeniRoute;
  AppOdemelerIdRoute: typeof AppOdemelerIdRoute;
  AppOnaylarIdRoute: typeof AppOnaylarIdRoute;
  AppOnaylarPolitikalarRoute: typeof AppOnaylarPolitikalarRoute;
  AppOnaylarVekaletlerRoute: typeof AppOnaylarVekaletlerRoute;
  AppRaporlarAkaryakitRoute: typeof AppRaporlarAkaryakitRoute;
  AppRaporlarAyarlarRoute: typeof AppRaporlarAyarlarRoute;
  AppRaporlarFinansRoute: typeof AppRaporlarFinansRoute;
  AppRaporlarKarlilikRoute: typeof AppRaporlarKarlilikRoute;
  AppRaporlarKarsilastirmaRoute: typeof AppRaporlarKarsilastirmaRoute;
  AppRaporlarZamanlanmisRoute: typeof AppRaporlarZamanlanmisRoute;
  AppSadakatIncelemeRoute: typeof AppSadakatIncelemeRoute;
  AppSadakatKurallarRoute: typeof AppSadakatKurallarRoute;
  AppSadakatProgramRoute: typeof AppSadakatProgramRoute;
  AppSadakatRaporlarRoute: typeof AppSadakatRaporlarRoute;
  AppSadakatSeviyelerRoute: typeof AppSadakatSeviyelerRoute;
  AppSarjAgAktarimlariRoute: typeof AppSarjAgAktarimlariRoute;
  AppSarjAyarlarRoute: typeof AppSarjAyarlarRoute;
  AppSarjDisaAktarimRoute: typeof AppSarjDisaAktarimRoute;
  AppSarjPanoRoute: typeof AppSarjPanoRoute;
  AppSarjRaporlarRoute: typeof AppSarjRaporlarRoute;
  AppSarjTarifelerRoute: typeof AppSarjTarifelerRoute;
  AppUyumTurlerRoute: typeof AppUyumTurlerRoute;
  AppVardiyaAyarlarRoute: typeof AppVardiyaAyarlarRoute;
  AppVardiyaPanoRoute: typeof AppVardiyaPanoRoute;
  AppVardiyaPersonelRoute: typeof AppVardiyaPersonelRoute;
  AppVardiyaRaporlarRoute: typeof AppVardiyaRaporlarRoute;
  AppVardiyaSablonlarRoute: typeof AppVardiyaSablonlarRoute;
  AppVardiyaZRaporlariRoute: typeof AppVardiyaZRaporlariRoute;
  AppVergiTakvimiKdvOzetiRoute: typeof AppVergiTakvimiKdvOzetiRoute;
  AppVergiTakvimiKurallarRoute: typeof AppVergiTakvimiKurallarRoute;
  AppYikamaAyarlarRoute: typeof AppYikamaAyarlarRoute;
  AppYikamaCalismalarRoute: typeof AppYikamaCalismalarRoute;
  AppYikamaKimyasallarRoute: typeof AppYikamaKimyasallarRoute;
  AppYikamaProgramlarRoute: typeof AppYikamaProgramlarRoute;
  AppYikamaRandevularRoute: typeof AppYikamaRandevularRoute;
  AppYikamaRaporlarRoute: typeof AppYikamaRaporlarRoute;
  AppYikamaSiraRoute: typeof AppYikamaSiraRoute;
  AppYikamaUnitelerRoute: typeof AppYikamaUnitelerRoute;
  AppAjanlarIndexRoute: typeof AppAjanlarIndexRoute;
  AppAlarmlarIndexRoute: typeof AppAlarmlarIndexRoute;
  AppBildirimlerIndexRoute: typeof AppBildirimlerIndexRoute;
  AppButceIndexRoute: typeof AppButceIndexRoute;
  AppCariIndexRoute: typeof AppCariIndexRoute;
  AppCekSenetIndexRoute: typeof AppCekSenetIndexRoute;
  AppFaturalarIndexRoute: typeof AppFaturalarIndexRoute;
  AppFiloIndexRoute: typeof AppFiloIndexRoute;
  AppFinansIndexRoute: typeof AppFinansIndexRoute;
  AppFiyatlarIndexRoute: typeof AppFiyatlarIndexRoute;
  AppGiderlerIndexRoute: typeof AppGiderlerIndexRoute;
  AppMusterilerIndexRoute: typeof AppMusterilerIndexRoute;
  AppNakitAkisIndexRoute: typeof AppNakitAkisIndexRoute;
  AppOdemelerIndexRoute: typeof AppOdemelerIndexRoute;
  AppOnaylarIndexRoute: typeof AppOnaylarIndexRoute;
  AppRaporlarIndexRoute: typeof AppRaporlarIndexRoute;
  AppUyumIndexRoute: typeof AppUyumIndexRoute;
  AppVergiTakvimiIndexRoute: typeof AppVergiTakvimiIndexRoute;
  AppAkaryakitDolumlarIdRoute: typeof AppAkaryakitDolumlarIdRoute;
  AppAkaryakitDolumlarYeniRoute: typeof AppAkaryakitDolumlarYeniRoute;
  AppAkaryakitSiparislerIdRoute: typeof AppAkaryakitSiparislerIdRoute;
  AppAkaryakitSiparislerYeniRoute: typeof AppAkaryakitSiparislerYeniRoute;
  AppAyarlarIstasyonlarStationIdRoute: typeof AppAyarlarIstasyonlarStationIdRoute;
  AppBakimIsEmirleriIdRoute: typeof AppBakimIsEmirleriIdRoute;
  AppCariIdDuzenleRoute: typeof AppCariIdDuzenleRoute;
  AppCekSenetBordrolarIdRoute: typeof AppCekSenetBordrolarIdRoute;
  AppFaturalarIdDuzenleRoute: typeof AppFaturalarIdDuzenleRoute;
  AppFaturalarGelenKutusuIdRoute: typeof AppFaturalarGelenKutusuIdRoute;
  AppFaturalarIrsaliyelerIdRoute: typeof AppFaturalarIrsaliyelerIdRoute;
  AppFaturalarIrsaliyelerYeniRoute: typeof AppFaturalarIrsaliyelerYeniRoute;
  AppFinansBankalarIdRoute: typeof AppFinansBankalarIdRoute;
  AppFinansKasalarIdRoute: typeof AppFinansKasalarIdRoute;
  AppGiderlerIdDuzenleRoute: typeof AppGiderlerIdDuzenleRoute;
  AppKasaSatislarIdRoute: typeof AppKasaSatislarIdRoute;
  AppKvkkBasvurularIdRoute: typeof AppKvkkBasvurularIdRoute;
  AppMarketEslestirmeIdRoute: typeof AppMarketEslestirmeIdRoute;
  AppMarketFirelerIdRoute: typeof AppMarketFirelerIdRoute;
  AppMarketMalKabulIdRoute: typeof AppMarketMalKabulIdRoute;
  AppMarketSayimlarIdRoute: typeof AppMarketSayimlarIdRoute;
  AppMarketSiparislerIdRoute: typeof AppMarketSiparislerIdRoute;
  AppMarketStokProductIdRoute: typeof AppMarketStokProductIdRoute;
  AppMarketTransferlerIdRoute: typeof AppMarketTransferlerIdRoute;
  AppMuhasebeFislerYeniRoute: typeof AppMuhasebeFislerYeniRoute;
  AppSadakatAboneliklerIdRoute: typeof AppSadakatAboneliklerIdRoute;
  AppSadakatKuponlarIdRoute: typeof AppSadakatKuponlarIdRoute;
  AppSarjOturumlarIdRoute: typeof AppSarjOturumlarIdRoute;
  AppSarjUnitelerIdRoute: typeof AppSarjUnitelerIdRoute;
  AppUyumBelgelerIdRoute: typeof AppUyumBelgelerIdRoute;
  AppUyumDenetimlerIdRoute: typeof AppUyumDenetimlerIdRoute;
  AppVardiyaGunSonuIdRoute: typeof AppVardiyaGunSonuIdRoute;
  AppYikamaIsEmirleriIdRoute: typeof AppYikamaIsEmirleriIdRoute;
  AppYikamaKredilerIdRoute: typeof AppYikamaKredilerIdRoute;
  AppAkaryakitDolumlarIndexRoute: typeof AppAkaryakitDolumlarIndexRoute;
  AppAkaryakitSiparislerIndexRoute: typeof AppAkaryakitSiparislerIndexRoute;
  AppAyarlarIstasyonlarIndexRoute: typeof AppAyarlarIstasyonlarIndexRoute;
  AppBakimIsEmirleriIndexRoute: typeof AppBakimIsEmirleriIndexRoute;
  AppBakimVarliklarIndexRoute: typeof AppBakimVarliklarIndexRoute;
  AppCariIdIndexRoute: typeof AppCariIdIndexRoute;
  AppCekSenetBordrolarIndexRoute: typeof AppCekSenetBordrolarIndexRoute;
  AppFaturalarIdIndexRoute: typeof AppFaturalarIdIndexRoute;
  AppFaturalarGelenKutusuIndexRoute: typeof AppFaturalarGelenKutusuIndexRoute;
  AppFaturalarIrsaliyelerIndexRoute: typeof AppFaturalarIrsaliyelerIndexRoute;
  AppFinansBankalarIndexRoute: typeof AppFinansBankalarIndexRoute;
  AppFinansKasalarIndexRoute: typeof AppFinansKasalarIndexRoute;
  AppGiderlerIdIndexRoute: typeof AppGiderlerIdIndexRoute;
  AppKasaSatislarIndexRoute: typeof AppKasaSatislarIndexRoute;
  AppKvkkBasvurularIndexRoute: typeof AppKvkkBasvurularIndexRoute;
  AppMarketEslestirmeIndexRoute: typeof AppMarketEslestirmeIndexRoute;
  AppMarketFirelerIndexRoute: typeof AppMarketFirelerIndexRoute;
  AppMarketMalKabulIndexRoute: typeof AppMarketMalKabulIndexRoute;
  AppMarketSayimlarIndexRoute: typeof AppMarketSayimlarIndexRoute;
  AppMarketSiparislerIndexRoute: typeof AppMarketSiparislerIndexRoute;
  AppMarketStokIndexRoute: typeof AppMarketStokIndexRoute;
  AppMarketTransferlerIndexRoute: typeof AppMarketTransferlerIndexRoute;
  AppMuhasebeFislerIndexRoute: typeof AppMuhasebeFislerIndexRoute;
  AppSadakatAboneliklerIndexRoute: typeof AppSadakatAboneliklerIndexRoute;
  AppSadakatKuponlarIndexRoute: typeof AppSadakatKuponlarIndexRoute;
  AppSarjOturumlarIndexRoute: typeof AppSarjOturumlarIndexRoute;
  AppSarjUnitelerIndexRoute: typeof AppSarjUnitelerIndexRoute;
  AppUyumBelgelerIndexRoute: typeof AppUyumBelgelerIndexRoute;
  AppUyumDenetimlerIndexRoute: typeof AppUyumDenetimlerIndexRoute;
  AppVardiyaGunSonuIndexRoute: typeof AppVardiyaGunSonuIndexRoute;
  AppVardiyaVardiyalarIndexRoute: typeof AppVardiyaVardiyalarIndexRoute;
  AppYikamaIsEmirleriIndexRoute: typeof AppYikamaIsEmirleriIndexRoute;
  AppYikamaKredilerIndexRoute: typeof AppYikamaKredilerIndexRoute;
  AppBakimVarliklarKindIdRoute: typeof AppBakimVarliklarKindIdRoute;
  AppMuhasebeFislerIdDuzenleRoute: typeof AppMuhasebeFislerIdDuzenleRoute;
  AppMuhasebeFislerIdIndexRoute: typeof AppMuhasebeFislerIdIndexRoute;
  AppVardiyaVardiyalarIdIndexRoute: typeof AppVardiyaVardiyalarIdIndexRoute;
  AppVardiyaVardiyalarIdHesapMemberIdRoute: typeof AppVardiyaVardiyalarIdHesapMemberIdRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppDuyurularRoute: AppDuyurularRoute,
  AppKurulumRoute: AppKurulumRoute,
  AppIndexRoute: AppIndexRoute,
  AppAjanlarIdRoute: AppAjanlarIdRoute,
  AppAkaryakitAyarlarRoute: AppAkaryakitAyarlarRoute,
  AppAkaryakitEndeksRoute: AppAkaryakitEndeksRoute,
  AppAkaryakitFireRaporuRoute: AppAkaryakitFireRaporuRoute,
  AppAkaryakitFiyatFarkiRoute: AppAkaryakitFiyatFarkiRoute,
  AppAkaryakitMaliyetRoute: AppAkaryakitMaliyetRoute,
  AppAkaryakitMutabakatRoute: AppAkaryakitMutabakatRoute,
  AppAkaryakitSatislarRoute: AppAkaryakitSatislarRoute,
  AppAkaryakitSiparisOnerileriRoute: AppAkaryakitSiparisOnerileriRoute,
  AppAkaryakitTanklarRoute: AppAkaryakitTanklarRoute,
  AppAlarmlarAlarmIdRoute: AppAlarmlarAlarmIdRoute,
  AppAlarmlarKurallarRoute: AppAlarmlarKurallarRoute,
  AppAyarlarAbonelikRoute: AppAyarlarAbonelikRoute,
  AppAyarlarBolgelerRoute: AppAyarlarBolgelerRoute,
  AppAyarlarDestekErisimiRoute: AppAyarlarDestekErisimiRoute,
  AppAyarlarGuvenlikRoute: AppAyarlarGuvenlikRoute,
  AppAyarlarIstasyonDevirleriRoute: AppAyarlarIstasyonDevirleriRoute,
  AppAyarlarKullanicilarRoute: AppAyarlarKullanicilarRoute,
  AppAyarlarProfilRoute: AppAyarlarProfilRoute,
  AppAyarlarRollerRoute: AppAyarlarRollerRoute,
  AppAyarlarSirketlerRoute: AppAyarlarSirketlerRoute,
  AppBakimAyarlarRoute: AppBakimAyarlarRoute,
  AppBakimPlanlarRoute: AppBakimPlanlarRoute,
  AppBakimRaporlarRoute: AppBakimRaporlarRoute,
  AppBildirimlerTercihlerRoute: AppBildirimlerTercihlerRoute,
  AppButceIdRoute: AppButceIdRoute,
  AppButceRaporRoute: AppButceRaporRoute,
  AppCariAcilisAktarimiRoute: AppCariAcilisAktarimiRoute,
  AppCariHareketYeniRoute: AppCariHareketYeniRoute,
  AppCariRaporlarRoute: AppCariRaporlarRoute,
  AppCariRiskRoute: AppCariRiskRoute,
  AppCariYeniRoute: AppCariYeniRoute,
  AppCekSenetIdRoute: AppCekSenetIdRoute,
  AppCekSenetAyarlarRoute: AppCekSenetAyarlarRoute,
  AppCekSenetBordroYeniRoute: AppCekSenetBordroYeniRoute,
  AppCekSenetKarnelerRoute: AppCekSenetKarnelerRoute,
  AppCekSenetRaporlarRoute: AppCekSenetRaporlarRoute,
  AppCekSenetTakvimRoute: AppCekSenetTakvimRoute,
  AppFaturalarAyarlarRoute: AppFaturalarAyarlarRoute,
  AppFaturalarEArsivTalepleriRoute: AppFaturalarEArsivTalepleriRoute,
  AppFaturalarYeniRoute: AppFaturalarYeniRoute,
  AppFiloCounterpartyIdRoute: AppFiloCounterpartyIdRoute,
  AppFiloAracTalepleriRoute: AppFiloAracTalepleriRoute,
  AppFiloTuketimRoute: AppFiloTuketimRoute,
  AppFinansAyarlarRoute: AppFinansAyarlarRoute,
  AppFinansDbsRoute: AppFinansDbsRoute,
  AppFinansEkstreRoute: AppFinansEkstreRoute,
  AppFinansHareketYeniRoute: AppFinansHareketYeniRoute,
  AppFinansHareketlerRoute: AppFinansHareketlerRoute,
  AppFinansKredilerRoute: AppFinansKredilerRoute,
  AppFinansPosRoute: AppFinansPosRoute,
  AppFinansTeminatlarRoute: AppFinansTeminatlarRoute,
  AppFiyatlarTopluDegisiklikRoute: AppFiyatlarTopluDegisiklikRoute,
  AppGiderlerTanimlarRoute: AppGiderlerTanimlarRoute,
  AppGiderlerYeniRoute: AppGiderlerYeniRoute,
  AppKasaAyarlarRoute: AppKasaAyarlarRoute,
  AppKasaKampanyalarRoute: AppKasaKampanyalarRoute,
  AppKatalogUrunlerRoute: AppKatalogUrunlerRoute,
  AppKvkkAyarlarRoute: AppKvkkAyarlarRoute,
  AppKvkkMetinlerRoute: AppKvkkMetinlerRoute,
  AppKvkkPazarlamaRoute: AppKvkkPazarlamaRoute,
  AppMarketAyarlarRoute: AppMarketAyarlarRoute,
  AppMarketEtiketlerRoute: AppMarketEtiketlerRoute,
  AppMarketFiyatOnerisiRoute: AppMarketFiyatOnerisiRoute,
  AppMarketGunKapanislariRoute: AppMarketGunKapanislariRoute,
  AppMarketHareketlerRoute: AppMarketHareketlerRoute,
  AppMarketLisanslarRoute: AppMarketLisanslarRoute,
  AppMarketPartilerRoute: AppMarketPartilerRoute,
  AppMarketRaporlarRoute: AppMarketRaporlarRoute,
  AppMarketSiparisOnerisiRoute: AppMarketSiparisOnerisiRoute,
  AppMuhasebeAraclarRoute: AppMuhasebeAraclarRoute,
  AppMuhasebeDonemlerRoute: AppMuhasebeDonemlerRoute,
  AppMuhasebeEslestirmelerRoute: AppMuhasebeEslestirmelerRoute,
  AppMuhasebeHesapPlaniRoute: AppMuhasebeHesapPlaniRoute,
  AppMuhasebeRaporlarRoute: AppMuhasebeRaporlarRoute,
  AppMusterilerIdRoute: AppMusterilerIdRoute,
  AppMusterilerYeniRoute: AppMusterilerYeniRoute,
  AppOdemelerIdRoute: AppOdemelerIdRoute,
  AppOnaylarIdRoute: AppOnaylarIdRoute,
  AppOnaylarPolitikalarRoute: AppOnaylarPolitikalarRoute,
  AppOnaylarVekaletlerRoute: AppOnaylarVekaletlerRoute,
  AppRaporlarAkaryakitRoute: AppRaporlarAkaryakitRoute,
  AppRaporlarAyarlarRoute: AppRaporlarAyarlarRoute,
  AppRaporlarFinansRoute: AppRaporlarFinansRoute,
  AppRaporlarKarlilikRoute: AppRaporlarKarlilikRoute,
  AppRaporlarKarsilastirmaRoute: AppRaporlarKarsilastirmaRoute,
  AppRaporlarZamanlanmisRoute: AppRaporlarZamanlanmisRoute,
  AppSadakatIncelemeRoute: AppSadakatIncelemeRoute,
  AppSadakatKurallarRoute: AppSadakatKurallarRoute,
  AppSadakatProgramRoute: AppSadakatProgramRoute,
  AppSadakatRaporlarRoute: AppSadakatRaporlarRoute,
  AppSadakatSeviyelerRoute: AppSadakatSeviyelerRoute,
  AppSarjAgAktarimlariRoute: AppSarjAgAktarimlariRoute,
  AppSarjAyarlarRoute: AppSarjAyarlarRoute,
  AppSarjDisaAktarimRoute: AppSarjDisaAktarimRoute,
  AppSarjPanoRoute: AppSarjPanoRoute,
  AppSarjRaporlarRoute: AppSarjRaporlarRoute,
  AppSarjTarifelerRoute: AppSarjTarifelerRoute,
  AppUyumTurlerRoute: AppUyumTurlerRoute,
  AppVardiyaAyarlarRoute: AppVardiyaAyarlarRoute,
  AppVardiyaPanoRoute: AppVardiyaPanoRoute,
  AppVardiyaPersonelRoute: AppVardiyaPersonelRoute,
  AppVardiyaRaporlarRoute: AppVardiyaRaporlarRoute,
  AppVardiyaSablonlarRoute: AppVardiyaSablonlarRoute,
  AppVardiyaZRaporlariRoute: AppVardiyaZRaporlariRoute,
  AppVergiTakvimiKdvOzetiRoute: AppVergiTakvimiKdvOzetiRoute,
  AppVergiTakvimiKurallarRoute: AppVergiTakvimiKurallarRoute,
  AppYikamaAyarlarRoute: AppYikamaAyarlarRoute,
  AppYikamaCalismalarRoute: AppYikamaCalismalarRoute,
  AppYikamaKimyasallarRoute: AppYikamaKimyasallarRoute,
  AppYikamaProgramlarRoute: AppYikamaProgramlarRoute,
  AppYikamaRandevularRoute: AppYikamaRandevularRoute,
  AppYikamaRaporlarRoute: AppYikamaRaporlarRoute,
  AppYikamaSiraRoute: AppYikamaSiraRoute,
  AppYikamaUnitelerRoute: AppYikamaUnitelerRoute,
  AppAjanlarIndexRoute: AppAjanlarIndexRoute,
  AppAlarmlarIndexRoute: AppAlarmlarIndexRoute,
  AppBildirimlerIndexRoute: AppBildirimlerIndexRoute,
  AppButceIndexRoute: AppButceIndexRoute,
  AppCariIndexRoute: AppCariIndexRoute,
  AppCekSenetIndexRoute: AppCekSenetIndexRoute,
  AppFaturalarIndexRoute: AppFaturalarIndexRoute,
  AppFiloIndexRoute: AppFiloIndexRoute,
  AppFinansIndexRoute: AppFinansIndexRoute,
  AppFiyatlarIndexRoute: AppFiyatlarIndexRoute,
  AppGiderlerIndexRoute: AppGiderlerIndexRoute,
  AppMusterilerIndexRoute: AppMusterilerIndexRoute,
  AppNakitAkisIndexRoute: AppNakitAkisIndexRoute,
  AppOdemelerIndexRoute: AppOdemelerIndexRoute,
  AppOnaylarIndexRoute: AppOnaylarIndexRoute,
  AppRaporlarIndexRoute: AppRaporlarIndexRoute,
  AppUyumIndexRoute: AppUyumIndexRoute,
  AppVergiTakvimiIndexRoute: AppVergiTakvimiIndexRoute,
  AppAkaryakitDolumlarIdRoute: AppAkaryakitDolumlarIdRoute,
  AppAkaryakitDolumlarYeniRoute: AppAkaryakitDolumlarYeniRoute,
  AppAkaryakitSiparislerIdRoute: AppAkaryakitSiparislerIdRoute,
  AppAkaryakitSiparislerYeniRoute: AppAkaryakitSiparislerYeniRoute,
  AppAyarlarIstasyonlarStationIdRoute: AppAyarlarIstasyonlarStationIdRoute,
  AppBakimIsEmirleriIdRoute: AppBakimIsEmirleriIdRoute,
  AppCariIdDuzenleRoute: AppCariIdDuzenleRoute,
  AppCekSenetBordrolarIdRoute: AppCekSenetBordrolarIdRoute,
  AppFaturalarIdDuzenleRoute: AppFaturalarIdDuzenleRoute,
  AppFaturalarGelenKutusuIdRoute: AppFaturalarGelenKutusuIdRoute,
  AppFaturalarIrsaliyelerIdRoute: AppFaturalarIrsaliyelerIdRoute,
  AppFaturalarIrsaliyelerYeniRoute: AppFaturalarIrsaliyelerYeniRoute,
  AppFinansBankalarIdRoute: AppFinansBankalarIdRoute,
  AppFinansKasalarIdRoute: AppFinansKasalarIdRoute,
  AppGiderlerIdDuzenleRoute: AppGiderlerIdDuzenleRoute,
  AppKasaSatislarIdRoute: AppKasaSatislarIdRoute,
  AppKvkkBasvurularIdRoute: AppKvkkBasvurularIdRoute,
  AppMarketEslestirmeIdRoute: AppMarketEslestirmeIdRoute,
  AppMarketFirelerIdRoute: AppMarketFirelerIdRoute,
  AppMarketMalKabulIdRoute: AppMarketMalKabulIdRoute,
  AppMarketSayimlarIdRoute: AppMarketSayimlarIdRoute,
  AppMarketSiparislerIdRoute: AppMarketSiparislerIdRoute,
  AppMarketStokProductIdRoute: AppMarketStokProductIdRoute,
  AppMarketTransferlerIdRoute: AppMarketTransferlerIdRoute,
  AppMuhasebeFislerYeniRoute: AppMuhasebeFislerYeniRoute,
  AppSadakatAboneliklerIdRoute: AppSadakatAboneliklerIdRoute,
  AppSadakatKuponlarIdRoute: AppSadakatKuponlarIdRoute,
  AppSarjOturumlarIdRoute: AppSarjOturumlarIdRoute,
  AppSarjUnitelerIdRoute: AppSarjUnitelerIdRoute,
  AppUyumBelgelerIdRoute: AppUyumBelgelerIdRoute,
  AppUyumDenetimlerIdRoute: AppUyumDenetimlerIdRoute,
  AppVardiyaGunSonuIdRoute: AppVardiyaGunSonuIdRoute,
  AppYikamaIsEmirleriIdRoute: AppYikamaIsEmirleriIdRoute,
  AppYikamaKredilerIdRoute: AppYikamaKredilerIdRoute,
  AppAkaryakitDolumlarIndexRoute: AppAkaryakitDolumlarIndexRoute,
  AppAkaryakitSiparislerIndexRoute: AppAkaryakitSiparislerIndexRoute,
  AppAyarlarIstasyonlarIndexRoute: AppAyarlarIstasyonlarIndexRoute,
  AppBakimIsEmirleriIndexRoute: AppBakimIsEmirleriIndexRoute,
  AppBakimVarliklarIndexRoute: AppBakimVarliklarIndexRoute,
  AppCariIdIndexRoute: AppCariIdIndexRoute,
  AppCekSenetBordrolarIndexRoute: AppCekSenetBordrolarIndexRoute,
  AppFaturalarIdIndexRoute: AppFaturalarIdIndexRoute,
  AppFaturalarGelenKutusuIndexRoute: AppFaturalarGelenKutusuIndexRoute,
  AppFaturalarIrsaliyelerIndexRoute: AppFaturalarIrsaliyelerIndexRoute,
  AppFinansBankalarIndexRoute: AppFinansBankalarIndexRoute,
  AppFinansKasalarIndexRoute: AppFinansKasalarIndexRoute,
  AppGiderlerIdIndexRoute: AppGiderlerIdIndexRoute,
  AppKasaSatislarIndexRoute: AppKasaSatislarIndexRoute,
  AppKvkkBasvurularIndexRoute: AppKvkkBasvurularIndexRoute,
  AppMarketEslestirmeIndexRoute: AppMarketEslestirmeIndexRoute,
  AppMarketFirelerIndexRoute: AppMarketFirelerIndexRoute,
  AppMarketMalKabulIndexRoute: AppMarketMalKabulIndexRoute,
  AppMarketSayimlarIndexRoute: AppMarketSayimlarIndexRoute,
  AppMarketSiparislerIndexRoute: AppMarketSiparislerIndexRoute,
  AppMarketStokIndexRoute: AppMarketStokIndexRoute,
  AppMarketTransferlerIndexRoute: AppMarketTransferlerIndexRoute,
  AppMuhasebeFislerIndexRoute: AppMuhasebeFislerIndexRoute,
  AppSadakatAboneliklerIndexRoute: AppSadakatAboneliklerIndexRoute,
  AppSadakatKuponlarIndexRoute: AppSadakatKuponlarIndexRoute,
  AppSarjOturumlarIndexRoute: AppSarjOturumlarIndexRoute,
  AppSarjUnitelerIndexRoute: AppSarjUnitelerIndexRoute,
  AppUyumBelgelerIndexRoute: AppUyumBelgelerIndexRoute,
  AppUyumDenetimlerIndexRoute: AppUyumDenetimlerIndexRoute,
  AppVardiyaGunSonuIndexRoute: AppVardiyaGunSonuIndexRoute,
  AppVardiyaVardiyalarIndexRoute: AppVardiyaVardiyalarIndexRoute,
  AppYikamaIsEmirleriIndexRoute: AppYikamaIsEmirleriIndexRoute,
  AppYikamaKredilerIndexRoute: AppYikamaKredilerIndexRoute,
  AppBakimVarliklarKindIdRoute: AppBakimVarliklarKindIdRoute,
  AppMuhasebeFislerIdDuzenleRoute: AppMuhasebeFislerIdDuzenleRoute,
  AppMuhasebeFislerIdIndexRoute: AppMuhasebeFislerIdIndexRoute,
  AppVardiyaVardiyalarIdIndexRoute: AppVardiyaVardiyalarIdIndexRoute,
  AppVardiyaVardiyalarIdHesapMemberIdRoute:
    AppVardiyaVardiyalarIdHesapMemberIdRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

interface PlatformRouteChildren {
  PlatformAyarlarRoute: typeof PlatformAyarlarRoute;
  PlatformDestekRoute: typeof PlatformDestekRoute;
  PlatformDevirlerRoute: typeof PlatformDevirlerRoute;
  PlatformDuyurularRoute: typeof PlatformDuyurularRoute;
  PlatformPersonelRoute: typeof PlatformPersonelRoute;
  PlatformPlanlarRoute: typeof PlatformPlanlarRoute;
  PlatformSaglikRoute: typeof PlatformSaglikRoute;
  PlatformTahsilatRoute: typeof PlatformTahsilatRoute;
  PlatformYayinlarRoute: typeof PlatformYayinlarRoute;
  PlatformIndexRoute: typeof PlatformIndexRoute;
  PlatformFaturalarIdRoute: typeof PlatformFaturalarIdRoute;
  PlatformKiracilarIdRoute: typeof PlatformKiracilarIdRoute;
  PlatformFaturalarIndexRoute: typeof PlatformFaturalarIndexRoute;
  PlatformKiracilarIndexRoute: typeof PlatformKiracilarIndexRoute;
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformAyarlarRoute: PlatformAyarlarRoute,
  PlatformDestekRoute: PlatformDestekRoute,
  PlatformDevirlerRoute: PlatformDevirlerRoute,
  PlatformDuyurularRoute: PlatformDuyurularRoute,
  PlatformPersonelRoute: PlatformPersonelRoute,
  PlatformPlanlarRoute: PlatformPlanlarRoute,
  PlatformSaglikRoute: PlatformSaglikRoute,
  PlatformTahsilatRoute: PlatformTahsilatRoute,
  PlatformYayinlarRoute: PlatformYayinlarRoute,
  PlatformIndexRoute: PlatformIndexRoute,
  PlatformFaturalarIdRoute: PlatformFaturalarIdRoute,
  PlatformKiracilarIdRoute: PlatformKiracilarIdRoute,
  PlatformFaturalarIndexRoute: PlatformFaturalarIndexRoute,
  PlatformKiracilarIndexRoute: PlatformKiracilarIndexRoute,
};

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
);

interface PortalRouteChildren {
  PortalAraclarRoute: typeof PortalAraclarRoute;
  PortalFaturalarRoute: typeof PortalFaturalarRoute;
  PortalIslemlerRoute: typeof PortalIslemlerRoute;
  PortalTaleplerRoute: typeof PortalTaleplerRoute;
  PortalIndexRoute: typeof PortalIndexRoute;
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAraclarRoute: PortalAraclarRoute,
  PortalFaturalarRoute: PortalFaturalarRoute,
  PortalIslemlerRoute: PortalIslemlerRoute,
  PortalTaleplerRoute: PortalTaleplerRoute,
  PortalIndexRoute: PortalIndexRoute,
};

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren);

interface SiraEkraniRouteChildren {
  SiraEkraniYikamaRoute: typeof SiraEkraniYikamaRoute;
}

const SiraEkraniRouteChildren: SiraEkraniRouteChildren = {
  SiraEkraniYikamaRoute: SiraEkraniYikamaRoute,
};

const SiraEkraniRouteWithChildren = SiraEkraniRoute._addFileChildren(
  SiraEkraniRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DavetRoute: DavetRoute,
  GirisRoute: GirisRoute,
  ParolaSifirlaRoute: ParolaSifirlaRoute,
  ParolaUnuttumRoute: ParolaUnuttumRoute,
  PlatformRoute: PlatformRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  SiraEkraniRoute: SiraEkraniRouteWithChildren,
  DevUiShowcaseRoute: DevUiShowcaseRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
